import {
	IPatternAssets,
	ITemplateSet
} from '@/types'

export const TemplateSets: ITemplateSet = {
	GalleryTemplates: [
		{
			thumb: 'templates/thumbnails/GalleryScene_001_001.png',
			name: 'Gallery 001 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_001_001.babylon',
			id: 400,
			radius: 3.6,
			radiusMax: 10.2506,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_001_002.png',
			name: 'Gallery 001 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_001_002.babylon',
			id: 401,
			radius: 4.1728,
			radiusMax: 10.2506,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_001_003.png',
			name: 'Gallery 001 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_001_003.babylon',
			id: 402,
			radius: 9.8838,
			radiusMax: 10.5562,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_001_004.png',
			name: 'Gallery 001 - 5 Large Objects',
			url: 'templates/meshes/GalleryScene_001_004.babylon',
			id: 403,
			radius: 9,
			radiusMax: 10.2506,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_002_001.png',
			name: 'Gallery 002 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_002_001.babylon',
			id: 404,
			radius: 3.6,
			radiusMax: 10.0595,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_002_002.png',
			name: 'Gallery 002 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_002_002.babylon',
			id: 405,
			radius: 4.1728,
			radiusMax: 10.0595,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_002_003.png',
			name: 'Gallery 002 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_002_003.babylon',
			id: 406,
			radius: 9.8838,
			radiusMax: 11.7893,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_002_004.png',
			name: 'Gallery 002 - 5 Large Objects',
			url: 'templates/meshes/GalleryScene_002_004.babylon',
			id: 407,
			radius: 9,
			radiusMax: 10.0595,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_003_001.png',
			name: 'Gallery 003 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_003_001.babylon',
			id: 408,
			radius: 3.6,
			radiusMax: 10.0397,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_003_002.png',
			name: 'Gallery 003 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_003_002.babylon',
			id: 409,
			radius: 4.1728,
			radiusMax: 10.0397,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_003_003.png',
			name: 'Gallery 003 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_003_003.babylon',
			id: 410,
			radius: 9.8838,
			radiusMax: 12.1734,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_003_004.png',
			name: 'Gallery 003 - 5 Large Objects',
			url: 'templates/meshes/GalleryScene_003_004.babylon',
			id: 411,
			radius: 9,
			radiusMax: 10.0397,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_004_001.png',
			name: 'Gallery 004 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_004_001.babylon',
			id: 412,
			radius: 3.8065,
			radiusMax: 8.3062,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_004_002.png',
			name: 'Gallery 004 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_004_002.babylon',
			id: 413,
			radius: 4.3089,
			radiusMax: 8.3062,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_004_003.png',
			name: 'Gallery 004 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_004_003.babylon',
			id: 414,
			radius: 9.8621,
			radiusMax: 10.5523,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_004_004.png',
			name: 'Gallery 004 - 5 Large Objects',
			url: 'templates/meshes/GalleryScene_004_004.babylon',
			id: 415,
			radius: 8.6,
			radiusMax: 10.0397,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_005_001.png',
			name: 'Gallery 005 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_005_001.babylon',
			id: 416,
			radius: 3.6,
			radiusMax: 7.7931,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_005_002.png',
			name: 'Gallery 005 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_005_002.babylon',
			id: 417,
			radius: 4.2899,
			radiusMax: 7.7931,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_005_003.png',
			name: 'Gallery 005 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_005_003.babylon',
			id: 418,
			radius: 9.8295,
			radiusMax: 9.8295,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_005_004.png',
			name: 'Gallery 005 - 5 Large Objects',
			url: 'templates/meshes/GalleryScene_005_004.babylon',
			id: 419,
			radius: 9,
			radiusMax: 10.0397,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_006_001.png',
			name: 'Gallery 006 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_006_001.babylon',
			id: 420,
			radius: 3.6,
			radiusMax: 10.138,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_006_002.png',
			name: 'Gallery 006 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_006_002.babylon',
			id: 421,
			radius: 4.2268,
			radiusMax: 10.138,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_006_003.png',
			name: 'Gallery 006 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_006_003.babylon',
			id: 422,
			radius: 9.8441,
			radiusMax: 11.3455,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_006_004.png',
			name: 'Gallery 006 - 5 Large Objects',
			url: 'templates/meshes/GalleryScene_006_004.babylon',
			id: 423,
			radius: 9,
			radiusMax: 10.138,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_007_001.png',
			name: 'Gallery 007 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_007_001.babylon',
			id: 424,
			radius: 7.4803,
			radiusMax: 12.557,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_007_002.png',
			name: 'Gallery 007 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_007_002.babylon',
			id: 425,
			radius: 7.4803,
			radiusMax: 12.557,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_007_003.png',
			name: 'Gallery 007 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_007_003.babylon',
			id: 426,
			radius: 15,
			radiusMax: 17.5993,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_007_004.png',
			name: 'Gallery 007 - 6 Large Objects',
			url: 'templates/meshes/GalleryScene_007_004.babylon',
			id: 427,
			radius: 15,
			radiusMax: 17.5993,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_008_001.png',
			name: 'Gallery 008 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_008_001.babylon',
			id: 428,
			radius: 6.3282,
			radiusMax: 12.3486,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_008_002.png',
			name: 'Gallery 008 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_008_002.babylon',
			id: 429,
			radius: 6.3481,
			radiusMax: 12.3486,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_008_003.png',
			name: 'Gallery 008 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_008_003.babylon',
			id: 430,
			radius: 9.8076,
			radiusMax: 17.6352,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_008_004.png',
			name: 'Gallery 008 - 5 Large Objects',
			url: 'templates/meshes/GalleryScene_008_004.babylon',
			id: 431,
			radius: 9.8076,
			radiusMax: 12.3486,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_009_001.png',
			name: 'Gallery 009 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_009_001.babylon',
			id: 432,
			radius: 5.3452,
			radiusMax: 19.154,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_009_002.png',
			name: 'Gallery 009 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_009_002.babylon',
			id: 433,
			radius: 5.3452,
			radiusMax: 19.154,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_009_003.png',
			name: 'Gallery 009 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_009_003.babylon',
			id: 434,
			radius: 12.1159,
			radiusMax: 19.154,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_009_004.png',
			name: 'Gallery 009 - 6 Large Objects',
			url: 'templates/meshes/GalleryScene_009_004.babylon',
			id: 435,
			radius: 12.1159,
			radiusMax: 19.154,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_010_001.png',
			name: 'Gallery 010 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_010_001.babylon',
			id: 436,
			radius: 3.6,
			radiusMax: 10.9994,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_010_002.png',
			name: 'Gallery 010 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_010_002.babylon',
			id: 437,
			radius: 4.3652,
			radiusMax: 10.9994,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_010_003.png',
			name: 'Gallery 010 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_010_003.babylon',
			id: 438,
			radius: 11.5768,
			radiusMax: 14.1901,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_010_004.png',
			name: 'Gallery 010 - 5 Large Objects',
			url: 'templates/meshes/GalleryScene_010_004.babylon',
			id: 439,
			radius: 9,
			radiusMax: 10.9994,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_011_001.png',
			name: 'Gallery 011 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_011_001.babylon',
			id: 440,
			radius: 6.3477,
			radiusMax: 12.9616,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_011_002.png',
			name: 'Gallery 011 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_011_002.babylon',
			id: 441,
			radius: 6.3477,
			radiusMax: 12.9616,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_011_003.png',
			name: 'Gallery 011 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_011_003.babylon',
			id: 442,
			radius: 11.25,
			radiusMax: 12.9616,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_011_004.png',
			name: 'Gallery 011 - 3 Large Objects',
			url: 'templates/meshes/GalleryScene_011_004.babylon',
			id: 443,
			radius: 11.25,
			radiusMax: 12.9616,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_012_001.png',
			name: 'Gallery 012 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_012_001.babylon',
			id: 444,
			radius: 7.2882,
			radiusMax: 15.7882,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_012_002.png',
			name: 'Gallery 012 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_012_002.babylon',
			id: 445,
			radius: 7.2882,
			radiusMax: 15.7882,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_012_003.png',
			name: 'Gallery 012 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_012_003.babylon',
			id: 446,
			radius: 12.519,
			radiusMax: 15.7882,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_012_004.png',
			name: 'Gallery 012 - 3 Large Objects',
			url: 'templates/meshes/GalleryScene_012_004.babylon',
			id: 447,
			radius: 12.519,
			radiusMax: 15.7882,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_013_001.png',
			name: 'Gallery 013 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_013_001.babylon',
			id: 448,
			radius: 6.5198,
			radiusMax: 14.5198,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_013_002.png',
			name: 'Gallery 013 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_013_002.babylon',
			id: 449,
			radius: 6.5198,
			radiusMax: 14.5198,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_013_003.png',
			name: 'Gallery 013 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_013_003.babylon',
			id: 450,
			radius: 13.7685,
			radiusMax: 14.5198,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_013_004.png',
			name: 'Gallery 013 - 3 Large Objects',
			url: 'templates/meshes/GalleryScene_013_004.babylon',
			id: 451,
			radius: 13.7685,
			radiusMax: 14.5198,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_014_001.png',
			name: 'Gallery 014 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_014_001.babylon',
			id: 452,
			radius: 9.561,
			radiusMax: 16.2889,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_014_002.png',
			name: 'Gallery 014 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_014_002.babylon',
			id: 453,
			radius: 9.561,
			radiusMax: 16.2889,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_014_003.png',
			name: 'Gallery 014 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_014_003.babylon',
			id: 454,
			radius: 12.5583,
			radiusMax: 16.2889,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_014_004.png',
			name: 'Gallery 014 - 3 Large Objects',
			url: 'templates/meshes/GalleryScene_014_004.babylon',
			id: 455,
			radius: 9.561,
			radiusMax: 16.2889,
		},
	],
	PatternTemplates: [{
		name: '1x1 Half 1',
		thumb: 'templates/thumbnails/Icon_Template_011.png',
		url: 'templates/meshes/Template_011.babylon',
		id: 0,
	},
		{
			name: '1x1 Half 2',
			thumb: 'templates/thumbnails/Icon_Template_012.png',
			url: 'templates/meshes/Template_012.babylon',
			id: 1,
		},
		{
			name: '1x1 Square',
			thumb: 'templates/thumbnails/Icon_Template_001.png',
			url: 'templates/meshes/Template_001.babylon',
			id: 2,
		},
		{
			name: '1x1',
			thumb: 'templates/thumbnails/Icon_Template_013.png',
			url: 'templates/meshes/Template_013.babylon',
			id: 3,
		},
		{
			name: '2x2 Square',
			thumb: 'templates/thumbnails/Icon_Template_002.png',
			url: 'templates/meshes/Template_002.babylon',
			id: 4,
		},
		{
			name: '2x2',
			thumb: 'templates/thumbnails/Icon_Template_014.png',
			url: 'templates/meshes/Template_014.babylon',
			id: 5,
		},
		{
			name: '3x3 Square',
			thumb: 'templates/thumbnails/Icon_Template_003.png',
			url: 'templates/meshes/Template_003.babylon',
			id: 6,
		},
		{
			name: '3x3',
			thumb: 'templates/thumbnails/Icon_Template_015.png',
			url: 'templates/meshes/Template_015.babylon',
			id: 7,
		},
		{
			name: '4x4 Square',
			thumb: 'templates/thumbnails/Icon_Template_004.png',
			url: 'templates/meshes/Template_004.babylon',
			id: 8,
		},
		{
			name: '4x4',
			thumb: 'templates/thumbnails/Icon_Template_016.png',
			url: 'templates/meshes/Template_016.babylon',
			id: 9,
		},
		{
			name: '5x5 Square',
			thumb: 'templates/thumbnails/Icon_Template_005.png',
			url: 'templates/meshes/Template_005.babylon',
			id: 10,
		},
		{
			name: '5x5',
			thumb: 'templates/thumbnails/Icon_Template_017.png',
			url: 'templates/meshes/Template_017.babylon',
			id: 11,
		},
		{
			name: '6x6 Square',
			thumb: 'templates/thumbnails/Icon_Template_006.png',
			url: 'templates/meshes/Template_006.babylon',
			id: 12,
		},
		{
			name: 'Windmill',
			thumb: 'templates/thumbnails/Icon_Template_031.png',
			url: 'templates/meshes/Template_031.babylon',
			id: 13,
		},
		{
			name: "Washington's Puzzle",
			thumb: 'templates/thumbnails/Icon_Template_030.png',
			url: 'templates/meshes/Template_030.babylon',
			id: 14,
		},
		{
			name: 'Vortex',
			thumb: 'templates/thumbnails/Icon_Template_029.png',
			url: 'templates/meshes/Template_029.babylon',
			id: 15,
		},
		{
			name: 'Triangles 2',
			thumb: 'templates/thumbnails/Icon_Template_021.png',
			url: 'templates/meshes/Template_021.babylon',
			id: 16,
		},
		{
			name: 'Triangles 1',
			thumb: 'templates/thumbnails/Icon_Template_020.png',
			url: 'templates/meshes/Template_020.babylon',
			id: 17,
		},
		{
			name: 'Interlocked Squares 1',
			thumb: 'templates/thumbnails/Icon_Template_028.png',
			url: 'templates/meshes/Template_028.babylon',
			id: 18,
		},
		{
			name: 'Diamonds 2',
			thumb: 'templates/thumbnails/Icon_Template_019.png',
			url: 'templates/meshes/Template_019.babylon',
			id: 19,
		},
		{
			name: 'Diamonds 1',
			thumb: 'templates/thumbnails/Icon_Template_018.png',
			url: 'templates/meshes/Template_018.babylon',
			id: 20,
		},
		{
			name: "Cleopatra's Fan",
			thumb: 'templates/thumbnails/Icon_Template_027.png',
			url: 'templates/meshes/Template_027.babylon',
			id: 21,
		},
		{
			name: 'Arabic Lattice',
			thumb: 'templates/thumbnails/Icon_Template_026.png',
			url: 'templates/meshes/Template_026.babylon',
			id: 22,
			// uOffset: 0.5,
			// vOffset: 0.5,
		},
		{
			name: 'Abstract Triangles 2',
			thumb: 'templates/thumbnails/Icon_Template_025.png',
			url: 'templates/meshes/Template_025.babylon',
			id: 23,
			// uOffset: 0.5,
			// vOffset: 0.5,
			accentTiling: 4,
		},
		{
			name: 'Abstract Triangles 1',
			thumb: 'templates/thumbnails/Icon_Template_024.png',
			url: 'templates/meshes/Template_024.babylon',
			id: 24,
		},
		{
			name: '10x10 Square',
			thumb: 'templates/thumbnails/Icon_Template_010.png',
			url: 'templates/meshes/Template_010.babylon',
			id: 25,
			accentTiling: 0.4,
		},
		{
			name: '9x9 Square',
			thumb: 'templates/thumbnails/Icon_Template_009.png',
			url: 'templates/meshes/Template_009.babylon',
			id: 26,
			accentTiling: 0.44,
		},
		{
			name: 'Pinwheel 1',
			thumb: 'templates/thumbnails/Icon_Template_041.png',
			url: 'templates/meshes/Template_041.babylon',
			id: 27,
		},
		{
			name: '8x8',
			thumb: 'templates/thumbnails/Icon_Template_023.png',
			url: 'templates/meshes/Template_023.babylon',
			id: 28,
		},
		{
			name: '7x7 Square',
			thumb: 'templates/thumbnails/Icon_Template_007.png',
			url: 'templates/meshes/Template_007.babylon',
			id: 29,
		},
		{
			name: '6x6',
			thumb: 'templates/thumbnails/Icon_Template_022.png',
			url: 'templates/meshes/Template_022.babylon',
			id: 30,
		},
		{
			name: '8x8 Square',
			thumb: 'templates/thumbnails/Icon_Template_008.png',
			url: 'templates/meshes/Template_008.babylon',
			id: 31,
		},
		{
			name: '9x9 Grid',
			thumb: 'templates/thumbnails/Icon_Template_032.png',
			url: 'templates/meshes/Template_032.babylon',
			id: 32,
		},
		{
			name: '10x10 Grid',
			thumb: 'templates/thumbnails/Icon_Template_033.png',
			url: 'templates/meshes/Template_033.babylon',
			id: 33,
		},
		{
			name: '11x11 Squares',
			thumb: 'templates/thumbnails/Icon_Template_034.png',
			url: 'templates/meshes/Template_034.babylon',
			id: 34,
		},
		{
			name: '11x11 Grid',
			thumb: 'templates/thumbnails/Icon_Template_035.png',
			url: 'templates/meshes/Template_035.babylon',
			id: 35,
		},
		{
			name: '12x12 Squares',
			thumb: 'templates/thumbnails/Icon_Template_036.png',
			url: 'templates/meshes/Template_036.babylon',
			id: 36,
		},
		{
			name: '12x12 Grid',
			thumb: 'templates/thumbnails/Icon_Template_037.png',
			url: 'templates/meshes/Template_037.babylon',
			id: 37,
		},
		{
			name: 'Triangles 3',
			thumb: 'templates/thumbnails/Icon_Template_038.png',
			url: 'templates/meshes/Template_038.babylon',
			id: 38,
		},
		{
			name: 'Diamonds 3',
			thumb: 'templates/thumbnails/Icon_Template_039.png',
			url: 'templates/meshes/Template_039.babylon',
			id: 39,
		},
		{
			name: 'Sunburst',
			thumb: 'templates/thumbnails/Icon_Template_040.png',
			url: 'templates/meshes/Template_040.babylon',
			id: 40,
		},
		{
			name: 'Starwheel',
			thumb: 'templates/thumbnails/Icon_Template_042.png',
			url: 'templates/meshes/Template_042.babylon',
			id: 41,
		},
		{
			name: 'Blazing Star 1',
			thumb: 'templates/thumbnails/Icon_Template_043.png',
			url: 'templates/meshes/Template_043.babylon',
			id: 42,
		},
		{
			name: 'Blazing Star 2',
			thumb: 'templates/thumbnails/Icon_Template_044.png',
			url: 'templates/meshes/Template_044.babylon',
			id: 43,
		},
		{
			name: 'Blazing Star 3',
			thumb: 'templates/thumbnails/Icon_Template_045.png',
			url: 'templates/meshes/Template_045.babylon',
			id: 44,
		},
		{
			name: 'Blazing Star 4',
			thumb: 'templates/thumbnails/Icon_Template_046.png',
			url: 'templates/meshes/Template_046.babylon',
			id: 45,
		},
		{
			name: 'Circles 1',
			thumb: 'templates/thumbnails/Icon_Template_047.png',
			url: 'templates/meshes/Template_047.babylon',
			id: 46,
		},
		{
			name: 'Circles 2',
			thumb: 'templates/thumbnails/Icon_Template_048.png',
			url: 'templates/meshes/Template_048.babylon',
			id: 47,
		},
		{
			name: '7x7 Template',
			thumb: 'templates/thumbnails/Icon_Template_049.png',
			url: 'templates/meshes/Template_049.babylon',
			id: 48,
		},
		{
			name: 'Diamond Leaf',
			thumb: 'templates/thumbnails/Icon_Template_050.png',
			url: 'templates/meshes/Template_050.babylon',
			id: 49,
		},
		{
			name: 'Spinwheel',
			thumb: 'templates/thumbnails/Icon_Template_051.png',
			url: 'templates/meshes/Template_051.babylon',
			id: 50,
		},
		{
			name: 'Circles 3',
			thumb: 'templates/thumbnails/Icon_Template_052.png',
			url: 'templates/meshes/Template_052.babylon',
			id: 51,
		},
		{
			name: 'Dresden Fan',
			thumb: 'templates/thumbnails/Icon_Template_053.png',
			url: 'templates/meshes/Template_053.babylon',
			id: 52,
		},
		{
			name: 'Wavy Checkers',
			thumb: 'templates/thumbnails/Icon_Template_054.png',
			url: 'templates/meshes/Template_054.babylon',
			id: 53,
		},
		{
			name: 'Fleur De Lis 1',
			thumb: 'templates/thumbnails/Icon_Template_055.png',
			url: 'templates/meshes/Template_055.babylon',
			id: 54,
		},
		{
			name: 'Fleur De Lis 2',
			thumb: 'templates/thumbnails/Icon_Template_056.png',
			url: 'templates/meshes/Template_056.babylon',
			id: 55,
		},
		{
			name: 'Fleur De Lis 3',
			thumb: 'templates/thumbnails/Icon_Template_057.png',
			url: 'templates/meshes/Template_057.babylon',
			id: 56,
		},
		{
			name: 'Fan 1',
			thumb: 'templates/thumbnails/Icon_Template_058.png',
			url: 'templates/meshes/Template_058.babylon',
			id: 57,
		},
		{
			name: 'Circles 4',
			thumb: 'templates/thumbnails/Icon_Template_059.png',
			url: 'templates/meshes/Template_059.babylon',
			id: 58,
		},
		{
			name: 'Fan 2',
			thumb: 'templates/thumbnails/Icon_Template_060.png',
			url: 'templates/meshes/Template_060.babylon',
			id: 59,
		},
		{
			name: 'Cubic 3',
			thumb: 'templates/thumbnails/Icon_Template_061.png',
			url: 'templates/meshes/Template_061.babylon',
			id: 60,
		},
		{
			name: 'Cubic 2',
			thumb: 'templates/thumbnails/Icon_Template_062.png',
			url: 'templates/meshes/Template_062.babylon',
			id: 61,
		},
		{
			name: 'Twist 1',
			thumb: 'templates/thumbnails/Icon_Template_063.png',
			url: 'templates/meshes/Template_063.babylon',
			id: 62,
		},
		{
			name: 'Flower Garden',
			thumb: 'templates/thumbnails/Icon_Template_064.png',
			url: 'templates/meshes/Template_064.babylon',
			id: 63,
		},
		{
			name: 'Twist 2',
			thumb: 'templates/thumbnails/Icon_Template_065.png',
			url: 'templates/meshes/Template_065.babylon',
			id: 64,
		},
		{
			name: 'Ellipse 1',
			thumb: 'templates/thumbnails/Icon_Template_066.png',
			url: 'templates/meshes/Template_066.babylon',
			id: 65,
		},
		{
			name: 'Twist 3',
			thumb: 'templates/thumbnails/Icon_Template_067.png',
			url: 'templates/meshes/Template_067.babylon',
			id: 66,
		},
		{
			name: 'Sun Ray',
			thumb: 'templates/thumbnails/Icon_Template_068.png',
			url: 'templates/meshes/Template_068.babylon',
			id: 67,
		},
		{
			name: 'Cross 4',
			thumb: 'templates/thumbnails/Icon_Template_069.png',
			url: 'templates/meshes/Template_069.babylon',
			id: 68,
		},
		{
			name: 'Accordion',
			thumb: 'templates/thumbnails/Icon_Template_070.png',
			url: 'templates/meshes/Template_070.babylon',
			id: 69,
		},
		{
			name: 'Rings 1',
			thumb: 'templates/thumbnails/Icon_Template_071.png',
			url: 'templates/meshes/Template_071.babylon',
			id: 70,
		},
		{
			name: 'Rings 2',
			thumb: 'templates/thumbnails/Icon_Template_072.png',
			url: 'templates/meshes/Template_072.babylon',
			id: 71,
		},
		{
			name: 'Flying Geese 1',
			thumb: 'templates/thumbnails/Icon_Template_073.png',
			url: 'templates/meshes/Template_073.babylon',
			id: 72,
		},
		{
			name: 'Beach Umbrella',
			thumb: 'templates/thumbnails/Icon_Template_074.png',
			url: 'templates/meshes/Template_074.babylon',
			id: 73,
		},
		{
			name: 'Diagonal 1',
			thumb: 'templates/thumbnails/Icon_Template_075.png',
			url: 'templates/meshes/Template_075.babylon',
			id: 74,
		},
		{
			name: 'Cross 1',
			thumb: 'templates/thumbnails/Icon_Template_076.png',
			url: 'templates/meshes/Template_076.babylon',
			id: 75,
		},
		{
			name: 'Cross 2',
			thumb: 'templates/thumbnails/Icon_Template_077.png',
			url: 'templates/meshes/Template_077.babylon',
			id: 76,
		},
		{
			name: 'Horizontal Bar',
			thumb: 'templates/thumbnails/Icon_Template_078.png',
			url: 'templates/meshes/Template_078.babylon',
			id: 77,
		},
		{
			name: 'Flower 2',
			thumb: 'templates/thumbnails/Icon_Template_079.png',
			url: 'templates/meshes/Template_079.babylon',
			id: 78,
		},
		{
			name: 'Cubic 1',
			thumb: 'templates/thumbnails/Icon_Template_080.png',
			url: 'templates/meshes/Template_080.babylon',
			id: 79,
		},
		{
			name: 'Twist 4',
			thumb: 'templates/thumbnails/Icon_Template_081.png',
			url: 'templates/meshes/Template_081.babylon',
			id: 80,
		},
		{
			name: 'Flower 1',
			thumb: 'templates/thumbnails/Icon_Template_082.png',
			url: 'templates/meshes/Template_082.babylon',
			id: 81,
		},
		{
			name: 'Blazing Star 5',
			thumb: 'templates/thumbnails/Icon_Template_083.png',
			url: 'templates/meshes/Template_083.babylon',
			id: 82,
		},
		{
			name: 'Skyscraper',
			thumb: 'templates/thumbnails/Icon_Template_084.png',
			url: 'templates/meshes/Template_084.babylon',
			id: 83,
		},
		{
			name: 'Interlocked Squares 2',
			thumb: 'templates/thumbnails/Icon_Template_085.png',
			url: 'templates/meshes/Template_085.babylon',
			id: 84,
		},
		{
			name: 'Indian Summer',
			thumb: 'templates/thumbnails/Icon_Template_086.png',
			url: 'templates/meshes/Template_086.babylon',
			id: 85,
		},
		{
			name: 'Interlocked Squares 3',
			thumb: 'templates/thumbnails/Icon_Template_087.png',
			url: 'templates/meshes/Template_087.babylon',
			id: 86,
		},
		{
			name: 'Dual Wheel 1',
			thumb: 'templates/thumbnails/Icon_Template_088.png',
			url: 'templates/meshes/Template_088.babylon',
			id: 87,
		},
		{
			name: 'Circus Tent',
			thumb: 'templates/thumbnails/Icon_Template_089.png',
			url: 'templates/meshes/Template_089.babylon',
			id: 88,
		},
		{
			name: 'Halo 1',
			thumb: 'templates/thumbnails/Icon_Template_090.png',
			url: 'templates/meshes/Template_090.babylon',
			id: 89,
		},
		{
			name: 'Hex 15 Column',
			thumb: 'templates/thumbnails/Icon_Template_091.png',
			url: 'templates/meshes/Template_091.babylon',
			id: 90,
		},
		{
			name: 'Hex 4 Column',
			thumb: 'templates/thumbnails/Icon_Template_092.png',
			url: 'templates/meshes/Template_092.babylon',
			id: 91,
		},
		{
			name: 'Hex 7.5 Column',
			thumb: 'templates/thumbnails/Icon_Template_093.png',
			url: 'templates/meshes/Template_093.babylon',
			id: 92,
		},
		{
			name: 'Hex 8 Column',
			thumb: 'templates/thumbnails/Icon_Template_094.png',
			url: 'templates/meshes/Template_094.babylon',
			id: 93,
		},
		{
			name: 'Hex 2.5 Column',
			thumb: 'templates/thumbnails/Icon_Template_095.png',
			url: 'templates/meshes/Template_095.babylon',
			id: 94,
		},
		{
			name: 'Hex 5 Column',
			thumb: 'templates/thumbnails/Icon_Template_096.png',
			url: 'templates/meshes/Template_096.babylon',
			id: 95,
		},
		{
			name: 'Hex 3 Column',
			thumb: 'templates/thumbnails/Icon_Template_097.png',
			url: 'templates/meshes/Template_097.babylon',
			id: 96,
		},
		{
			name: 'Hex 6 Column',
			thumb: 'templates/thumbnails/Icon_Template_098.png',
			url: 'templates/meshes/Template_098.babylon',
			id: 97,
		},
		{
			name: 'Arkansas Traveler 1',
			thumb: 'templates/thumbnails/Icon_Template_099.png',
			url: 'templates/meshes/Template_099.babylon',
			id: 98,
		},
		{
			name: 'Arkansas Traveler 2',
			thumb: 'templates/thumbnails/Icon_Template_100.png',
			url: 'templates/meshes/Template_100.babylon',
			id: 99,
		},
		{
			name: 'Flying Geese 2',
			thumb: 'templates/thumbnails/Icon_Template_101.png',
			url: 'templates/meshes/Template_101.babylon',
			id: 100,
		},
		{
			name: 'Rounded Star 1',
			thumb: 'templates/thumbnails/Icon_Template_102.png',
			url: 'templates/meshes/Template_102.babylon',
			id: 101,
		},
		{
			name: 'Rounded Star 2',
			thumb: 'templates/thumbnails/Icon_Template_103.png',
			url: 'templates/meshes/Template_103.babylon',
			id: 102,
		},
		{
			name: 'Rounded Star 3',
			thumb: 'templates/thumbnails/Icon_Template_104.png',
			url: 'templates/meshes/Template_104.babylon',
			id: 103,
		},
		{
			name: 'Spherical Crescents',
			thumb: 'templates/thumbnails/Icon_Template_105.png',
			url: 'templates/meshes/Template_105.babylon',
			id: 104,
		},
		{
			name: 'Blazing Star 6',
			thumb: 'templates/thumbnails/Icon_Template_106.png',
			url: 'templates/meshes/Template_106.babylon',
			id: 105,
		},
		{
			name: 'Pinwheel 2',
			thumb: 'templates/thumbnails/Icon_Template_107.png',
			url: 'templates/meshes/Template_107.babylon',
			id: 106,
		},
		{
			name: 'Blazing Star 7',
			thumb: 'templates/thumbnails/Icon_Template_108.png',
			url: 'templates/meshes/Template_108.babylon',
			id: 107,
		},
		{
			name: 'Pinwheel 3',
			thumb: 'templates/thumbnails/Icon_Template_109.png',
			url: 'templates/meshes/Template_109.babylon',
			id: 108,
		},
		{
			name: 'Tile Star 1',
			thumb: 'templates/thumbnails/Icon_Template_110.png',
			url: 'templates/meshes/Template_110.babylon',
			id: 109,
		},
		{
			name: 'Pinwheel 4',
			thumb: 'templates/thumbnails/Icon_Template_111.png',
			url: 'templates/meshes/Template_111.babylon',
			id: 110,
		},
		{
			name: 'Cross 5',
			thumb: 'templates/thumbnails/Icon_Template_112.png',
			url: 'templates/meshes/Template_112.babylon',
			id: 111,
		},
		{
			name: 'Flying Geese 3',
			thumb: 'templates/thumbnails/Icon_Template_113.png',
			url: 'templates/meshes/Template_113.babylon',
			id: 112,
		},
		{
			name: 'Star Knot 1',
			thumb: 'templates/thumbnails/Icon_Template_114.png',
			url: 'templates/meshes/Template_114.babylon',
			id: 113,
		},
		{
			name: 'Star Knot 2',
			thumb: 'templates/thumbnails/Icon_Template_115.png',
			url: 'templates/meshes/Template_115.babylon',
			id: 114,
		},
		{
			name: 'Cross 3',
			thumb: 'templates/thumbnails/Icon_Template_116.png',
			url: 'templates/meshes/Template_116.babylon',
			id: 115,
		},
		{
			name: 'Flower 3',
			thumb: 'templates/thumbnails/Icon_Template_117.png',
			url: 'templates/meshes/Template_117.babylon',
			id: 116,
		},
		{
			name: 'Log Cabin',
			thumb: 'templates/thumbnails/Icon_Template_118.png',
			url: 'templates/meshes/Template_118.babylon',
			id: 117,
		},
		{
			name: 'Pinwheel 5',
			thumb: 'templates/thumbnails/Icon_Template_119.png',
			url: 'templates/meshes/Template_119.babylon',
			id: 118,
		},
		{
			name: '1x1',
			url: 'templates/meshes/ProjectTemplate_001.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_001.png',
			id: 300,
			radius: 2
		},
		{
			name: '1x2',
			url: 'templates/meshes/ProjectTemplate_002.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_002.png',
			id: 301,
			radius: 3
		},
		{
			name: '2x2',
			url: 'templates/meshes/ProjectTemplate_003.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_003.png',
			id: 302,
			radius: 3,
			accentScale: 2
		},
		{
			name: '2x3',
			url: 'templates/meshes/ProjectTemplate_004.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_004.png',
			id: 303,
			radius: 4.5,
			accentScale: 2
		},
		{
			name: '2x4',
			url: 'templates/meshes/ProjectTemplate_005.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_005.png',
			id: 304,
			radius: 5.75,
			accentScale: 2
		},
		{
			name: '3x3',
			url: 'templates/meshes/ProjectTemplate_006.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_006.png',
			id: 305,
			radius: 4.5,
			accentScale: 3
		},
		{
			name: '3x4',
			url: 'templates/meshes/ProjectTemplate_007.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_007.png',
			id: 306,
			radius: 5.75,
			accentScale: 3
		},
		{
			name: '3x5',
			url: 'templates/meshes/ProjectTemplate_008.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_008.png',
			id: 307,
			radius: 7,
			accentScale: 3
		},
		{
			name: '4x4',
			url: 'templates/meshes/ProjectTemplate_009.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_009.png',
			id: 308,
			radius: 5.75,
			accentScale: 4
		},
		{
			name: '4x5',
			url: 'templates/meshes/ProjectTemplate_010.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_010.png',
			id: 309,
			radius: 7,
			accentScale: 4
		},
		{
			name: '4x6',
			url: 'templates/meshes/ProjectTemplate_011.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_011.png',
			id: 310,
			radius: 8.5,
			accentScale: 4
		},
		{
			name: '5x5',
			url: 'templates/meshes/ProjectTemplate_012.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_012.png',
			id: 311,
			radius: 7,
			accentScale: 5
		},
		{
			name: '5x6',
			url: 'templates/meshes/ProjectTemplate_013.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_013.png',
			id: 312,
			radius: 8.5,
			accentScale: 5
		},
		{
			name: '5x7',
			url: 'templates/meshes/ProjectTemplate_014.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_014.png',
			id: 313,
			radius: 10,
			accentScale: 5
		},
		{
			name: '6x6',
			url: 'templates/meshes/ProjectTemplate_015.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_015.png',
			id: 314,
			radius: 8.5,
			accentScale: 6
		},
		{
			name: '6x7',
			url: 'templates/meshes/ProjectTemplate_016.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_016.png',
			id: 315,
			radius: 10,
			accentScale: 6
		},
		{
			name: '6x8',
			url: 'templates/meshes/ProjectTemplate_017.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_017.png',
			id: 316,
			radius: 11.25,
			accentScale: 6
		},
		{
			name: '7x7',
			url: 'templates/meshes/ProjectTemplate_018.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_018.png',
			id: 317,
			radius: 10,
			accentScale: 7
		},
		{
			name: '7x8',
			url: 'templates/meshes/ProjectTemplate_019.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_019.png',
			id: 318,
			radius: 11.25,
			accentScale: 7
		},
		{
			name: '7x9',
			url: 'templates/meshes/ProjectTemplate_020.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_020.png',
			id: 319,
			radius: 12.5,
			accentScale: 7
		},
		{
			name: '8x8',
			url: 'templates/meshes/ProjectTemplate_021.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_021.png',
			id: 320,
			radius: 11.25,
			accentScale: 8
		},
		{
			name: '8x9',
			url: 'templates/meshes/ProjectTemplate_022.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_022.png',
			id: 321,
			radius: 12.5,
			accentScale: 8
		},
		{
			name: '8x10',
			url: 'templates/meshes/ProjectTemplate_023.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_023.png',
			id: 322,
			radius: 14,
			accentScale: 8
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_001_001.png',
			name: 'Gallery 001 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_001_001.babylon',
			id: 400,
			radius: 3.6,
			radiusMax: 10.2506,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_001_002.png',
			name: 'Gallery 001 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_001_002.babylon',
			id: 401,
			radius: 4.1728,
			radiusMax: 10.2506,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_001_003.png',
			name: 'Gallery 001 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_001_003.babylon',
			id: 402,
			radius: 9.8838,
			radiusMax: 10.5562,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_001_004.png',
			name: 'Gallery 001 - 5 Large Objects',
			url: 'templates/meshes/GalleryScene_001_004.babylon',
			id: 403,
			radius: 3.6,
			radiusMax: 10.2506,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_002_001.png',
			name: 'Gallery 002 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_002_001.babylon',
			id: 404,
			radius: 3.6,
			radiusMax: 10.0595,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_002_002.png',
			name: 'Gallery 002 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_002_002.babylon',
			id: 405,
			radius: 4.1728,
			radiusMax: 10.0595,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_002_003.png',
			name: 'Gallery 002 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_002_003.babylon',
			id: 406,
			radius: 9.8838,
			radiusMax: 11.7893,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_002_004.png',
			name: 'Gallery 002 - 5 Large Objects',
			url: 'templates/meshes/GalleryScene_002_004.babylon',
			id: 407,
			radius: 3.6,
			radiusMax: 10.0595,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_003_001.png',
			name: 'Gallery 003 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_003_001.babylon',
			id: 408,
			radius: 3.6,
			radiusMax: 10.0397,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_003_002.png',
			name: 'Gallery 003 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_003_002.babylon',
			id: 409,
			radius: 4.1728,
			radiusMax: 10.0397,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_003_003.png',
			name: 'Gallery 003 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_003_003.babylon',
			id: 410,
			radius: 9.8838,
			radiusMax: 12.1734,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_003_004.png',
			name: 'Gallery 003 - 5 Large Objects',
			url: 'templates/meshes/GalleryScene_003_004.babylon',
			id: 411,
			radius: 3.6,
			radiusMax: 10.0397,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_004_001.png',
			name: 'Gallery 004 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_004_001.babylon',
			id: 412,
			radius: 3.8065,
			radiusMax: 8.3062,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_004_002.png',
			name: 'Gallery 004 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_004_002.babylon',
			id: 413,
			radius: 4.3089,
			radiusMax: 8.3062,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_004_003.png',
			name: 'Gallery 004 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_004_003.babylon',
			id: 414,
			radius: 9.8621,
			radiusMax: 10.5523,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_004_004.png',
			name: 'Gallery 004 - 5 Large Objects',
			url: 'templates/meshes/GalleryScene_004_004.babylon',
			id: 415,
			radius: 3.8065,
			radiusMax: 8.3062,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_005_001.png',
			name: 'Gallery 005 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_005_001.babylon',
			id: 416,
			radius: 3.6,
			radiusMax: 7.7931,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_005_002.png',
			name: 'Gallery 005 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_005_002.babylon',
			id: 417,
			radius: 4.2899,
			radiusMax: 7.7931,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_005_003.png',
			name: 'Gallery 005 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_005_003.babylon',
			id: 418,
			radius: 9.8295,
			radiusMax: 9.8295,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_005_004.png',
			name: 'Gallery 005 - 5 Large Objects',
			url: 'templates/meshes/GalleryScene_005_004.babylon',
			id: 419,
			radius: 3.6,
			radiusMax: 7.7931,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_006_001.png',
			name: 'Gallery 006 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_006_001.babylon',
			id: 420,
			radius: 3.6,
			radiusMax: 10.138,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_006_002.png',
			name: 'Gallery 006 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_006_002.babylon',
			id: 421,
			radius: 4.2268,
			radiusMax: 10.138,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_006_003.png',
			name: 'Gallery 006 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_006_003.babylon',
			id: 422,
			radius: 9.8441,
			radiusMax: 11.3455,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_006_004.png',
			name: 'Gallery 006 - 5 Large Objects',
			url: 'templates/meshes/GalleryScene_006_004.babylon',
			id: 423,
			radius: 3.6,
			radiusMax: 10.138,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_007_001.png',
			name: 'Gallery 007 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_007_001.babylon',
			id: 424,
			radius: 7.4803,
			radiusMax: 12.557,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_007_002.png',
			name: 'Gallery 007 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_007_002.babylon',
			id: 425,
			radius: 7.4803,
			radiusMax: 12.557,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_007_003.png',
			name: 'Gallery 007 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_007_003.babylon',
			id: 426,
			radius: 15,
			radiusMax: 17.5993,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_007_004.png',
			name: 'Gallery 007 - 6 Large Objects',
			url: 'templates/meshes/GalleryScene_007_004.babylon',
			id: 427,
			radius: 7.4803,
			radiusMax: 12.557,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_008_001.png',
			name: 'Gallery 008 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_008_001.babylon',
			id: 428,
			radius: 6.3282,
			radiusMax: 12.3486,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_008_002.png',
			name: 'Gallery 008 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_008_002.babylon',
			id: 429,
			radius: 6.3481,
			radiusMax: 12.3486,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_008_003.png',
			name: 'Gallery 008 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_008_003.babylon',
			id: 430,
			radius: 9.8076,
			radiusMax: 17.6352,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_008_004.png',
			name: 'Gallery 008 - 5 Large Objects',
			url: 'templates/meshes/GalleryScene_008_004.babylon',
			id: 431,
			radius: 6.3282,
			radiusMax: 12.3486,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_009_001.png',
			name: 'Gallery 009 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_009_001.babylon',
			id: 432,
			radius: 5.3452,
			radiusMax: 19.154,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_009_002.png',
			name: 'Gallery 009 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_009_002.babylon',
			id: 433,
			radius: 5.3452,
			radiusMax: 19.154,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_009_003.png',
			name: 'Gallery 009 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_009_003.babylon',
			id: 434,
			radius: 12.1159,
			radiusMax: 19.154,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_009_004.png',
			name: 'Gallery 009 - 6 Large Objects',
			url: 'templates/meshes/GalleryScene_009_004.babylon',
			id: 435,
			radius: 5.3452,
			radiusMax: 19.154,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_010_001.png',
			name: 'Gallery 010 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_010_001.babylon',
			id: 436,
			radius: 3.6,
			radiusMax: 10.9994,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_010_002.png',
			name: 'Gallery 010 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_010_002.babylon',
			id: 437,
			radius: 4.3652,
			radiusMax: 10.9994,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_010_003.png',
			name: 'Gallery 010 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_010_003.babylon',
			id: 438,
			radius: 11.5768,
			radiusMax: 14.1901,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_010_004.png',
			name: 'Gallery 010 - 5 Large Objects',
			url: 'templates/meshes/GalleryScene_010_004.babylon',
			id: 439,
			radius: 3.6,
			radiusMax: 10.9994,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_011_001.png',
			name: 'Gallery 011 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_011_001.babylon',
			id: 440,
			radius: 6.3477,
			radiusMax: 12.9616,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_011_002.png',
			name: 'Gallery 011 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_011_002.babylon',
			id: 441,
			radius: 6.3477,
			radiusMax: 12.9616,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_011_003.png',
			name: 'Gallery 011 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_011_003.babylon',
			id: 442,
			radius: 11.25,
			radiusMax: 12.9616,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_011_004.png',
			name: 'Gallery 011 - 3 Large Objects',
			url: 'templates/meshes/GalleryScene_011_004.babylon',
			id: 443,
			radius: 6.3477,
			radiusMax: 12.9616,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_012_001.png',
			name: 'Gallery 012 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_012_001.babylon',
			id: 444,
			radius: 7.2882,
			radiusMax: 15.7882,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_012_002.png',
			name: 'Gallery 012 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_012_002.babylon',
			id: 445,
			radius: 7.2882,
			radiusMax: 15.7882,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_012_003.png',
			name: 'Gallery 012 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_012_003.babylon',
			id: 446,
			radius: 12.519,
			radiusMax: 15.7882,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_012_004.png',
			name: 'Gallery 012 - 3 Large Objects',
			url: 'templates/meshes/GalleryScene_012_004.babylon',
			id: 447,
			radius: 7.2882,
			radiusMax: 15.7882,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_013_001.png',
			name: 'Gallery 013 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_013_001.babylon',
			id: 448,
			radius: 6.5198,
			radiusMax: 14.5198,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_013_002.png',
			name: 'Gallery 013 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_013_002.babylon',
			id: 449,
			radius: 6.5198,
			radiusMax: 14.5198,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_013_003.png',
			name: 'Gallery 013 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_013_003.babylon',
			id: 450,
			radius: 13.7685,
			radiusMax: 14.5198,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_013_004.png',
			name: 'Gallery 013 - 3 Large Objects',
			url: 'templates/meshes/GalleryScene_013_004.babylon',
			id: 451,
			radius: 6.5198,
			radiusMax: 14.5198,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_014_001.png',
			name: 'Gallery 014 - 1 Large Object',
			url: 'templates/meshes/GalleryScene_014_001.babylon',
			id: 452,
			radius: 9.561,
			radiusMax: 16.2889,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_014_002.png',
			name: 'Gallery 014 - 6 Small Objects',
			url: 'templates/meshes/GalleryScene_014_002.babylon',
			id: 453,
			radius: 9.561,
			radiusMax: 16.2889,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_014_003.png',
			name: 'Gallery 014 - 18 Small Objects',
			url: 'templates/meshes/GalleryScene_014_003.babylon',
			id: 454,
			radius: 12.5583,
			radiusMax: 16.2889,
		},
		{
			thumb: 'templates/thumbnails/GalleryScene_014_004.png',
			name: 'Gallery 014 - 3 Large Objects',
			url: 'templates/meshes/GalleryScene_014_004.babylon',
			id: 455,
			radius: 9.561,
			radiusMax: 16.2889,
		},
	],
	QuiltTemplates: [{
		name: '1x1',
		url: 'templates/meshes/ProjectTemplate_001.babylon',
		thumb: 'templates/thumbnails/ProjectTemplate_001.png',
		id: 300,
		radius: 2,
	},
		{
			name: '1x2',
			url: 'templates/meshes/ProjectTemplate_002.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_002.png',
			id: 301,
			radius: 3,
		},
		{
			name: '2x2',
			url: 'templates/meshes/ProjectTemplate_003.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_003.png',
			id: 302,
			radius: 3,
			accentScale: 2
		},
		{
			name: '2x3',
			url: 'templates/meshes/ProjectTemplate_004.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_004.png',
			id: 303,
			radius: 4.5,
			accentScale: 2
		},
		{
			name: '2x4',
			url: 'templates/meshes/ProjectTemplate_005.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_005.png',
			id: 304,
			radius: 5.75,
			accentScale: 2
		},
		{
			name: '3x3',
			url: 'templates/meshes/ProjectTemplate_006.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_006.png',
			id: 305,
			radius: 4.5,
			accentScale: 3
		},
		{
			name: '3x4',
			url: 'templates/meshes/ProjectTemplate_007.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_007.png',
			id: 306,
			radius: 5.75,
			accentScale: 3
		},
		{
			name: '3x5',
			url: 'templates/meshes/ProjectTemplate_008.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_008.png',
			id: 307,
			radius: 7,
			accentScale: 3
		},
		{
			name: '4x4',
			url: 'templates/meshes/ProjectTemplate_009.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_009.png',
			id: 308,
			radius: 5.75,
			accentScale: 4
		},
		{
			name: '4x5',
			url: 'templates/meshes/ProjectTemplate_010.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_010.png',
			id: 309,
			radius: 7,
			accentScale: 4
		},
		{
			name: '4x6',
			url: 'templates/meshes/ProjectTemplate_011.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_011.png',
			id: 310,
			radius: 8.5,
			accentScale: 4
		},
		{
			name: '5x5',
			url: 'templates/meshes/ProjectTemplate_012.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_012.png',
			id: 311,
			radius: 7,
			accentScale: 5
		},
		{
			name: '5x6',
			url: 'templates/meshes/ProjectTemplate_013.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_013.png',
			id: 312,
			radius: 8.5,
			accentScale: 5
		},
		{
			name: '5x7',
			url: 'templates/meshes/ProjectTemplate_014.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_014.png',
			id: 313,
			radius: 10,
			accentScale: 5
		},
		{
			name: '6x6',
			url: 'templates/meshes/ProjectTemplate_015.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_015.png',
			id: 314,
			radius: 8.5,
			accentScale: 6
		},
		{
			name: '6x7',
			url: 'templates/meshes/ProjectTemplate_016.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_016.png',
			id: 315,
			radius: 10,
			accentScale: 6
		},
		{
			name: '6x8',
			url: 'templates/meshes/ProjectTemplate_017.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_017.png',
			id: 316,
			radius: 11.25,
			accentScale: 6
		},
		{
			name: '7x7',
			url: 'templates/meshes/ProjectTemplate_018.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_018.png',
			id: 317,
			radius: 10,
			accentScale: 7
		},
		{
			name: '7x8',
			url: 'templates/meshes/ProjectTemplate_019.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_019.png',
			id: 318,
			radius: 11.25,
			accentScale: 7
		},
		{
			name: '7x9',
			url: 'templates/meshes/ProjectTemplate_020.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_020.png',
			id: 319,
			radius: 12.5,
			accentScale: 7
		},
		{
			name: '8x8',
			url: 'templates/meshes/ProjectTemplate_021.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_021.png',
			id: 320,
			radius: 11.25,
			accentScale: 8
		},
		{
			name: '8x9',
			url: 'templates/meshes/ProjectTemplate_022.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_022.png',
			id: 321,
			radius: 12.5,
			accentScale: 8
		},
		{
			name: '8x10',
			url: 'templates/meshes/ProjectTemplate_023.babylon',
			thumb: 'templates/thumbnails/ProjectTemplate_023.png',
			id: 322,
			radius: 14,
			accentScale: 8
		},
	],
}

export const Assets: IPatternAssets = {
	templates: [...TemplateSets.GalleryTemplates, ...TemplateSets.PatternTemplates],
	prints: {
		standard: [{
			name: 'Print_Plain',
			albedoURL: 'N/A',
			maskURL: 'N/A',
			channels: 'R',
			rColor: 'FFFFFF',
			gColor: '',
			bColor: '',
			aColor: '',
			tiling: 1,
			thumb: 'prints/thumbs/Thb_Print_Plain.png',
			id: 18,
		},
			{
				name: 'Print_Animal_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Animal_001.tga',
				channels: 'RG',
				rColor: 'FFFFFF',
				gColor: '262626',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Animal_001.png',
				id: 32,
			},
			{
				name: 'Print_Animal_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Animal_002.tga',
				channels: 'RG',
				rColor: 'FF7C0B',
				gColor: '000000',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Animal_002.png',
				id: 34,
			},
			{
				name: 'Print_Animal_003',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Animal_003.tga',
				channels: 'RG',
				rColor: 'FFC05D',
				gColor: '431024',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Animal_003.png',
				id: 35,
			},
			{
				name: 'Print_Animal_004',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Animal_004.tga',
				channels: 'RGB',
				rColor: 'FFF7BD',
				gColor: 'FFE01E',
				bColor: '0E0E0E',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Animal_004.png',
				id: 36,
			},
			{
				name: 'Print_Arches_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Arches_001.tga',
				channels: 'RG',
				rColor: 'FFFFFF',
				gColor: 'BE3328',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 16,
				thumb: 'prints/thumbs/Thb_Print_Arches_001.png',
				id: 37,
			},
			{
				name: 'Print_Boats_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Boats_001.tga',
				channels: 'RGBA',
				rColor: 'FFFFFF',
				gColor: '85AAE2',
				bColor: 'B4D3E5',
				aColor: '3F3F4D',
				tiling: 13.8,
				thumb: 'prints/thumbs/Thb_Print_Boats_001.png',
				id: 38,
			},
			{
				name: 'Print_Boxes_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Boxes_001.tga',
				channels: 'RGB',
				rColor: 'EE4E4E',
				gColor: '92FF88',
				bColor: '3849D9',
				aColor: 'N/A',
				tiling: 16,
				thumb: 'prints/thumbs/Thb_Print_Boxes_001.png',
				id: 39,
			},
			{
				name: 'Print_Brocade_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Brocade_001.tga',
				channels: 'RG',
				rColor: 'FFFFFF',
				gColor: '2B8AA6',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 16,
				thumb: 'prints/thumbs/Thb_Print_Brocade_001.png',
				id: 40,
			},
			{
				name: 'Print_Brocade_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Brocade_002.tga',
				channels: 'RG',
				rColor: 'FFFFFF',
				gColor: 'C5122B',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 16,
				thumb: 'prints/thumbs/Thb_Print_Brocade_002.png',
				id: 41,
			},
			{
				name: 'Print_Brocade_003',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Brocade_003.tga',
				channels: 'RG',
				rColor: 'FFFFFF',
				gColor: '90248E',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 16,
				thumb: 'prints/thumbs/Thb_Print_Brocade_003.png',
				id: 42,
			},
			{
				name: 'Print_Checkers_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Checkers_001.tga',
				channels: 'RG',
				rColor: 'FFFFFF',
				gColor: '94E7FF',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 36,
				thumb: 'prints/thumbs/Thb_Print_Checkers_001.png',
				id: 132,
			},
			{
				name: 'Print_Checkers_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Checkers_002.tga',
				channels: 'RGB',
				rColor: 'FFFFFF',
				gColor: '94E7FF',
				bColor: '6464A1',
				aColor: 'N/A',
				tiling: 14,
				thumb: 'prints/thumbs/Thb_Print_Checkers_002.png',
				id: 43,
			},
			{
				name: 'Print_Checkers_003',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Checkers_003.tga',
				channels: 'RG',
				rColor: 'D63A3A',
				gColor: '0E1D19',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 22,
				thumb: 'prints/thumbs/Thb_Print_Checkers_003.png',
				id: 44,
			},
			{
				name: 'Print_Checkers_004',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Checkers_004.tga',
				channels: 'RG',
				rColor: '94E5DF',
				gColor: 'CC6D6D',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 16,
				thumb: 'prints/thumbs/Thb_Print_Checkers_004.png',
				id: 45,
			},
			{
				name: 'Print_Checkers_005',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Checkers_005.tga',
				channels: 'RG',
				rColor: 'FFFFFF',
				gColor: '94E7FF',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 38,
				thumb: 'prints/thumbs/Thb_Print_Checkers_005.png',
				id: 46,
			},
			{
				name: 'Print_Checkers_006',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Checkers_006.tga',
				channels: 'RGB',
				rColor: '7E9CFF',
				gColor: '94E7FF',
				bColor: '6464A1',
				aColor: 'N/A',
				tiling: 16,
				thumb: 'prints/thumbs/Thb_Print_Checkers_006.png',
				id: 47,
			},
			{
				name: 'Print_Chevrons_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Chevrons_001.tga',
				channels: 'RG',
				rColor: 'B9B1A9',
				gColor: 'FFD4D0',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 20,
				thumb: 'prints/thumbs/Thb_Print_Chevrons_001.png',
				id: 1,
			},
			{
				name: 'Print_Chevrons_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Chevrons_002.tga',
				channels: 'RG',
				rColor: 'F39FC3',
				gColor: '8FFFE6',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 20,
				thumb: 'prints/thumbs/Thb_Print_Chevrons_002.png',
				id: 2,
			},
			{
				name: 'Print_Chevrons_003',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Chevrons_003.tga',
				channels: 'RGB',
				rColor: '35F1E7',
				gColor: '1EABFF',
				bColor: 'FF5A00',
				aColor: 'N/A',
				tiling: 16,
				thumb: 'prints/thumbs/Thb_Print_Chevrons_003.png',
				id: 48,
			},
			{
				name: 'Print_Chevrons_004',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Chevrons_004.tga',
				channels: 'RGB',
				rColor: '35F1E7',
				gColor: '1EABFF',
				bColor: 'FF5A00',
				aColor: 'N/A',
				tiling: 16,
				thumb: 'prints/thumbs/Thb_Print_Chevrons_004.png',
				id: 49,
			},
			{
				name: 'Print_Chevrons_005',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Chevrons_005.tga',
				channels: 'RG',
				rColor: '8EF135',
				gColor: '385E42',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 20,
				thumb: 'prints/thumbs/Thb_Print_Chevrons_005.png',
				id: 50,
			},
			{
				name: 'Print_Chevrons_006',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Chevrons_006.tga',
				channels: 'RGBA',
				rColor: 'fffd91',
				gColor: 'ff8079',
				bColor: '71cbe8',
				aColor: 'a964a8',  
				tiling: 16,
				thumb: 'prints/thumbs/Thb_Print_Chevrons_006.png',
				id: 51,
			},
			{
				name: 'Print_Chevrons_007',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Chevrons_007.tga',
				channels: 'RGBA',
				rColor: 'fffd91',
				gColor: 'ff8079',
				bColor: '71cbe8',
				aColor: 'a964a8',  
				tiling: 10.75,
				thumb: 'prints/thumbs/Thb_Print_Chevrons_007.png',
				id: 52,
			},
			{
				name: 'Print_Chevrons_008',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Chevrons_008.tga',
				channels: 'RGBA',
				rColor: 'FFFFFF',
				gColor: '5565AF',
				bColor: 'F389B8',
				aColor: '6CC7B4',
				tiling: 10,
				thumb: 'prints/thumbs/Thb_Print_Chevrons_008.png',
				id: 53,
			},
			{
				name: 'Print_Damask_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Damask_001.tga',
				channels: 'RG',
				rColor: '202041',
				gColor: 'FFFFFF',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 9,
				thumb: 'prints/thumbs/Thb_Print_Damask_001.png',
				id: 54,
			},
			{
				name: 'Print_Damask_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Damask_002.tga',
				channels: 'RGB',
				rColor: 'FFFFFF',
				gColor: 'E5988B',
				bColor: '434343',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Damask_002.png',
				id: 55,
			},
			{
				name: 'Print_Damask_003',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Damask_003.tga',
				channels: 'RGBA',
				rColor: '111180',
				gColor: 'FFFFFF',
				bColor: '457359',
				aColor: '559888',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Damask_003.png',
				id: 56,
			},
			{
				name: 'Print_Damask_004',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Damask_004.tga',
				channels: 'RGBA',
				rColor: '6ECABE',
				gColor: 'FFFFFF',
				bColor: 'DBD7A4',
				aColor: '1A59BC',
				tiling: 16,
				thumb: 'prints/thumbs/Thb_Print_Damask_004.png',
				id: 33,
			},
			{
				name: 'Print_Damask_005',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Damask_005.tga',
				channels: 'RG',
				rColor: '6ECABE',
				gColor: 'FFFFFF',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 24,
				thumb: 'prints/thumbs/Thb_Print_Damask_005.png',
				id: 57,
			},
			{
				name: 'Print_Dogs_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Dogs_001.tga',
				channels: 'RGB',
				rColor: '4EB0EE',
				gColor: 'B7F1EE',
				bColor: '3865D9',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Dogs_001.png',
				id: 58,
			},
			{
				name: 'Print_Dots_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Dots_001.tga',
				channels: 'RG',
				rColor: '202041',
				gColor: 'FFFFFF',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 10,
				thumb: 'prints/thumbs/Thb_Print_Dots_001.png',
				id: 3,
			},
			{
				name: 'Print_Dots_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Dots_002.tga',
				channels: 'RG',
				rColor: 'FF003D',
				gColor: 'FFFFFF',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 10,
				thumb: 'prints/thumbs/Thb_Print_Dots_002.png',
				id: 4,
			},
			{
				name: 'Print_Dots_003',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Dots_003.tga',
				channels: 'RGB',
				rColor: 'FFFCF2',
				gColor: 'C3A75F',
				bColor: '573D3C',
				aColor: 'N/A',
				tiling: 10,
				thumb: 'prints/thumbs/Thb_Print_Dots_003.png',
				id: 5,
			},
			{
				name: 'Print_Dots_004',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Dots_004.tga',
				channels: 'RGB',
				rColor: 'FFFFFF',
				gColor: 'FC75FF',
				bColor: '6DF4FF',
				aColor: 'N/A',
				tiling: 10,
				thumb: 'prints/thumbs/Thb_Print_Dots_004.png',
				id: 6,
			},
			{
				name: 'Print_Dots_005',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Dots_005.tga',
				channels: 'RG',
				rColor: '4B734D',
				gColor: 'FFFFFF',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 10,
				thumb: 'prints/thumbs/Thb_Print_Dots_005.png',
				id: 7,
			},
			{
				name: 'Print_Dots_006',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Dots_006.tga',
				channels: 'RG',
				rColor: 'FFDF86',
				gColor: '7B7B7B',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 10.65,
				thumb: 'prints/thumbs/Thb_Print_Dots_006.png',
				id: 59,
			},
			{
				name: 'Print_Dots_007',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Dots_007.tga',
				channels: 'RGB',
				rColor: '2E2E2E',
				gColor: '88F3EA',
				bColor: 'FF6D95',
				aColor: 'N/A',
				tiling: 10.65,
				thumb: 'prints/thumbs/Thb_Print_Dots_007.png',
				id: 60,
			},
			{
				name: 'Print_Dots_008',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Dots_008.tga',
				channels: 'RGBA',
				rColor: 'FFDF86', 
				gColor: 'a692c1',
				bColor: '6DF4FF',
				aColor: '725598',
				tiling: 11.15,
				thumb: 'prints/thumbs/Thb_Print_Dots_008.png',
				id: 61,
			},
			{
				name: 'Print_Dots_009',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Dots_009.tga',
				channels: 'RGBA',
				rColor: 'FFFEFB',
				gColor: '7B7B7B',
				bColor: '6DF4FF',
				aColor: '725598',
				tiling: 9.6,
				thumb: 'prints/thumbs/Thb_Print_Dots_009.png',
				id: 62,
			},
			{
				name: 'Print_Dots_010',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Dots_010.tga',
				channels: 'RGB',
				rColor: '42C3EC',
				gColor: '000000',
				bColor: '6DF4FF',
				aColor: 'N/A',
				tiling: 10.7,
				thumb: 'prints/thumbs/Thb_Print_Dots_010.png',
				id: 63,
			},
			{
				name: 'Print_Dots_011',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Dots_011.tga',
				channels: 'RGBA',
				rColor: 'AEFFCB',
				gColor: '7B7B7B',
				bColor: 'B452D1',
				aColor: '725598',
				tiling: 16,
				thumb: 'prints/thumbs/Thb_Print_Dots_011.png',
				id: 64,
			},
			{
				name: 'Print_Drops_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Drops_001.tga',
				channels: 'RGBA',
				rColor: '4EB0EE',
				gColor: 'B7F1EE',
				bColor: 'D438D9',
				aColor: '5B5B5B',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Drops_001.png',
				id: 65,
			},
			{
				name: 'Print_FleurDeLis_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_FleurDeLis_001.tga',
				channels: 'RG',
				rColor: '17173F',
				gColor: '44446F',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_FleurDeLis_001.png',
				id: 8,
			},
			{
				name: 'Print_Geometric_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_001.tga',
				channels: 'RG',
				rColor: 'FEFFC9',
				gColor: 'C3A27F',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Geometric_001.png',
				id: 9,
			},
			{
				name: 'Print_Geometric_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_002.tga',
				channels: 'RG',
				rColor: 'B75820',
				gColor: 'FFEAD5',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 22,
				thumb: 'prints/thumbs/Thb_Print_Geometric_002.png',
				id: 66,
			},
			{
				name: 'Print_Geometric_003',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_003.tga',
				channels: 'RG',
				rColor: 'B7202C',
				gColor: 'FFEAD5',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 22,
				thumb: 'prints/thumbs/Thb_Print_Geometric_003.png',
				id: 67,
			},
			{
				name: 'Print_Geometric_004',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_004.tga',
				channels: 'RG',
				rColor: '20B723',
				gColor: '000000',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 22,
				thumb: 'prints/thumbs/Thb_Print_Geometric_004.png',
				id: 68,
			},
			{
				name: 'Print_Geometric_005',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_005.tga',
				channels: 'RGB',
				rColor: 'B72093',
				gColor: 'FF7998',
				bColor: '251F78',
				aColor: 'N/A',
				tiling: 22,
				thumb: 'prints/thumbs/Thb_Print_Geometric_005.png',
				id: 69,
			},
			{
				name: 'Print_Geometric_006',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_006.tga',
				channels: 'RGB',
				rColor: 'B7202E',
				gColor: 'FFFFFF',
				bColor: '35DDD1',
				aColor: 'N/A',
				tiling: 18,
				thumb: 'prints/thumbs/Thb_Print_Geometric_006.png',
				id: 70,
			},
			{
				name: 'Print_Geometric_007',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_007.tga',
				channels: 'RGB',
				rColor: '476C4D',
				gColor: 'FFFFFF',
				bColor: '203133',
				aColor: 'N/A',
				tiling: 20,
				thumb: 'prints/thumbs/Thb_Print_Geometric_007.png',
				id: 71,
			},
			{
				name: 'Print_Geometric_008',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_008.tga',
				channels: 'RGBA',
				rColor: 'F5F5D8',
				gColor: 'FF86DD',
				bColor: '8CE0CA',
				aColor: 'A254F3',
				tiling: 12.5,
				thumb: 'prints/thumbs/Thb_Print_Geometric_008.png',
				id: 72,
			},
			{
				name: 'Print_Geometric_009',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_009.tga',
				channels: 'RG',
				rColor: 'F5F5D8',
				gColor: '6C0C51',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 18,
				thumb: 'prints/thumbs/Thb_Print_Geometric_009.png',
				id: 73,
			},
			{
				name: 'Print_Geometric_010',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_010.tga',
				channels: 'RG',
				rColor: 'E0E0E0',
				gColor: '3F002D',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 14,
				thumb: 'prints/thumbs/Thb_Print_Geometric_010.png',
				id: 74,
			},
			{
				name: 'Print_Geometric_011',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_011.tga',
				channels: 'RGBA',
				rColor: 'D62941',
				gColor: 'FF869E',
				bColor: 'E2343D',
				aColor: 'E95567',
				tiling: 18,
				thumb: 'prints/thumbs/Thb_Print_Geometric_011.png',
				id: 75,
			},
			{
				name: 'Print_Geometric_012',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_012.tga',
				channels: 'RGB',
				rColor: '1F1D1D',
				gColor: 'A2F5FF',
				bColor: '63BDE2',
				aColor: 'N/A',
				tiling: 20,
				thumb: 'prints/thumbs/Thb_Print_Geometric_012.png',
				id: 76,
			},
			{
				name: 'Print_Geometric_013',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_013.tga',
				channels: 'RGBA',
				rColor: '1F1D1D',
				gColor: 'FCFFD5',
				bColor: 'E29663',
				aColor: 'D42C27',
				tiling: 24,
				thumb: 'prints/thumbs/Thb_Print_Geometric_013.png',
				id: 77,
			},
			{
				name: 'Print_Geometric_014',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_014.tga',
				channels: 'RG',
				rColor: '1F1D1D',
				gColor: 'FCFFD5',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 24,
				thumb: 'prints/thumbs/Thb_Print_Geometric_014.png',
				id: 78,
			},
			{
				name: 'Print_Geometric_015',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_015.tga',
				channels: 'RGBA',
				rColor: '9EFDFC',  
				gColor: '477f99',
				bColor: '63E2A6',
				aColor: 'FFFFFF',
				tiling: 15,
				thumb: 'prints/thumbs/Thb_Print_Geometric_015.png',
				id: 79,
			},
			{
				name: 'Print_Geometric_016',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_016.tga',
				channels: 'RGB',
				rColor: '9EFDFC',
				gColor: '5B5B5B',
				bColor: 'E29663',
				aColor: 'N/A',
				tiling: 28,
				thumb: 'prints/thumbs/Thb_Print_Geometric_016.png',
				id: 80,
			},
			{
				name: 'Print_Geometric_017',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_017.tga',
				channels: 'RGB',
				rColor: 'B3F6F8',
				gColor: '8C3762',
				bColor: 'CF6E94',
				aColor: 'N/A',
				tiling: 14,
				thumb: 'prints/thumbs/Thb_Print_Geometric_017.png',
				id: 81,
			},
			{
				name: 'Print_Geometric_018',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_018.tga',
				channels: 'RGB',
				rColor: 'B3F6F8',
				gColor: '8C3762',
				bColor: 'CF6E94',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Geometric_018.png',
				id: 82,
			},
			{
				name: 'Print_Geometric_019',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_019.tga',
				channels: 'RGBA',
				rColor: 'F8B3C4',
				gColor: '8C3762',
				bColor: '776ECF',
				aColor: '000000',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Geometric_019.png',
				id: 83,
			},
			{
				name: 'Print_Geometric_020',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_020.tga',
				channels: 'RGBA',
				rColor: '3B529A',
				gColor: 'FFFFFF',
				bColor: '776ECF',
				aColor: '000000',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Geometric_020.png',
				id: 84,
			},
			{
				name: 'Print_Geometric_021',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_021.tga',
				channels: 'RGB',
				rColor: '94A5D9',
				gColor: '6477B0',
				bColor: '534C9A',
				aColor: 'N/A',
				tiling: 20,
				thumb: 'prints/thumbs/Thb_Print_Geometric_021.png',
				id: 85,
			},
			{
				name: 'Print_Geometric_022',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_022.tga',
				channels: 'RGB',
				rColor: '94A5D9',
				gColor: '6477B0',
				bColor: '534C9A',
				aColor: 'N/A',
				tiling: 22,
				thumb: 'prints/thumbs/Thb_Print_Geometric_022.png',
				id: 86,
			},
			{
				name: 'Print_Geometric_023',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_023.tga',
				channels: 'RG',
				rColor: '000000',
				gColor: 'C84141',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 22,
				thumb: 'prints/thumbs/Thb_Print_Geometric_023.png',
				id: 87,
			},
			{
				name: 'Print_Geometric_024',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_024.tga',
				channels: 'RGBA',
				rColor: '000000',
				gColor: 'C84141',
				bColor: 'FFFFFF',
				aColor: '163B6F',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Geometric_024.png',
				id: 88,
			},
			{
				name: 'Print_Gingham_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Gingham_001.tga',
				channels: 'RGB',
				rColor: 'ec9d9f',
				gColor: 'ec5154',
				bColor: 'FFFFFF',
				aColor: 'N/A',
				tiling: 20,
				thumb: 'prints/thumbs/Thb_Print_Gingham_001.png',
				id: 10,
			},
			{
				name: 'Print_Gingham_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Gingham_002.tga',
				channels: 'RGB',
				rColor: 'FFA0A1',
				gColor: 'FF474B',
				bColor: 'FFFFFF',
				aColor: 'N/A',
				tiling: 18.5,
				thumb: 'prints/thumbs/Thb_Print_Gingham_002.png',
				id: 89,
			},
			{
				name: 'Print_Gingham_003',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Gingham_003.tga',
				channels: 'RG',
				rColor: 'FFA0A1',
				gColor: 'FF474B',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 16,
				thumb: 'prints/thumbs/Thb_Print_Gingham_003.png',
				id: 90,
			},
			{
				name: 'Print_Harlequin_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Harlequin_001.tga',
				channels: 'RGB',
				rColor: 'FFFFFF',
				gColor: 'FF0006',
				bColor: '000000',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Harlequin_001.png',
				id: 11,
			},
			{
				name: 'Print_Harlequin_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Harlequin_002.tga',
				channels: 'RGB',
				rColor: 'FFFFFF',
				gColor: 'EDBAFF',
				bColor: 'FFDF92',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Harlequin_002.png',
				id: 12,
			},
			{
				name: 'Print_Harlequin_003',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Harlequin_003.tga',
				channels: 'RGBA',
				rColor: 'F5B900',
				gColor: '01C51C',
				bColor: '725598',
				aColor: '2A0E4F',
				tiling: 16,
				thumb: 'prints/thumbs/Thb_Print_Harlequin_003.png',
				id: 91,
			},
			{
				name: 'Print_Harlequin_004',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Harlequin_004.tga',
				channels: 'RGBA',
				rColor: '4EB0EE',
				gColor: 'B7F1EE',
				bColor: 'D438D9',
				aColor: '5B5B5B',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Harlequin_004.png',
				id: 92,
			},
			{
				name: 'Print_Harlequin_005',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Harlequin_005.tga',
				channels: 'RG',
				rColor: 'FFFFFF',
				gColor: '4179C8',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 16,
				thumb: 'prints/thumbs/Thb_Print_Harlequin_005.png',
				id: 93,
			},
			{
				name: 'Print_Hearts_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Hearts_001.tga',
				channels: 'RGBA',
				rColor: 'ffffff',  
				gColor: 'cd7e81',
				bColor: '7ab6cb',
				aColor: 'e63137',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Hearts_001.png',
				id: 94,
			},
			{
				name: 'Print_Hearts_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Hearts_002.tga',
				channels: 'RGBA',
				rColor: 'ffffff',  
				gColor: 'cd7e81',
				bColor: '7ab6cb',
				aColor: 'e63137',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Hearts_002.png',
				id: 95,
			},
			{
				name: 'Print_Knot_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Knot_001.tga',
				channels: 'RGB',
				rColor: 'CC1818',
				gColor: '8EAFB9',
				bColor: '0E0E0E',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Knot_001.png',
				id: 96,
			},
			{
				name: 'Print_Leaves_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Leaves_001.tga',
				channels: 'RGBA',
				rColor: 'FFFFFF',
				gColor: 'CAC64B',
				bColor: 'BEAA7D',
				aColor: '8C7B54',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Leaves_001.png',
				id: 13,
			},
			{
				name: 'Print_Notes_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Notes_001.tga',
				channels: 'RG',
				rColor: 'FFFFFF',
				gColor: '000000',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 10,
				thumb: 'prints/thumbs/Thb_Print_Notes_001.png',
				id: 97,
			},
			{
				name: 'Print_Ogee_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Ogee_001.tga',
				channels: 'RG',
				rColor: '9197B2',
				gColor: 'FFFFFF',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Ogee_001.png',
				id: 14,
			},
			{
				name: 'Print_Ogee_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Ogee_002.tga',
				channels: 'RGBA',
				rColor: 'c5eefb', 
				gColor: 'FFFFFF',
				bColor: 'de92ff',
				aColor: '725598',
				tiling: 16,
				thumb: 'prints/thumbs/Thb_Print_Ogee_002.png',
				id: 98,
			},
			{
				name: 'Print_Ogee_003',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Ogee_003.tga',
				channels: 'RGB',
				rColor: '6F1F3A',
				gColor: 'FFA970',
				bColor: 'BC5669',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Ogee_003.png',
				id: 99,
			},
			{
				name: 'Print_Paisley_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Paisley_002.tga',
				channels: 'RG',
				rColor: '901915',
				gColor: 'FFFFFF',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Paisley_002.png',
				id: 16,
			},
			{
				name: 'Print_Paisley_003',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Paisley_003.tga',
				channels: 'RG',
				rColor: '2F186C',
				gColor: 'FFFFFF',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 5,
				thumb: 'prints/thumbs/Thb_Print_Paisley_003.png',
				id: 17,
			},
			{
				name: 'Print_Peacock_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Peacock_001.tga',
				channels: 'RGBA',
				rColor: '4EB0EE',
				gColor: 'B7F1EE',
				bColor: 'D438D9',
				aColor: '5B5B5B',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Peacock_001.png',
				id: 100,
			},
			{
				name: 'Print_Plaid_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Plaid_001.tga',
				channels: 'RGB',
				rColor: '1F1D1D',
				gColor: 'FCFFD5',
				bColor: 'E29663',
				aColor: 'N/A',
				tiling: 32,
				thumb: 'prints/thumbs/Thb_Print_Plaid_001.png',
				id: 101,
			},
			{
				name: 'Print_Plaid_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Plaid_002.tga',
				channels: 'RGBA',
				rColor: '1F1D1D',
				gColor: 'FCFFD5',
				bColor: 'E29663',
				aColor: 'D42C27',
				tiling: 16,
				thumb: 'prints/thumbs/Thb_Print_Plaid_002.png',
				id: 102,
			},
			{
				name: 'Print_Plaid_004',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Plaid_004.tga',
				channels: 'RGBA',
				rColor: '878787',
				gColor: 'D5FFD5',
				bColor: '9DE263',
				aColor: '2755D4',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Plaid_004.png',
				id: 104,
			},
			{
				name: 'Print_Psychadelic_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Psychadelic_001.tga',
				channels: 'RGBA',
				rColor: '23214F',
				gColor: '4697B0',
				bColor: '64D6BB',
				aColor: 'BC4B6C',
				tiling: 14,
				thumb: 'prints/thumbs/Thb_Print_Psychadelic_001.png',
				id: 105,
			},
			{
				name: 'Print_Scales_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Scales_001.tga',
				channels: 'RGB',
				rColor: '6DEE7B',
				gColor: '4FB072',
				bColor: '23711B',
				aColor: 'N/A',
				tiling: 22,
				thumb: 'prints/thumbs/Thb_Print_Scales_001.png',
				id: 106,
			},
			{
				name: 'Print_Scales_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Scales_002.tga',
				channels: 'RG',
				rColor: 'EE6DA9',
				gColor: '4F8BB0',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 20,
				thumb: 'prints/thumbs/Thb_Print_Scales_002.png',
				id: 107,
			},
			{
				name: 'Print_Star_Grid_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Star_Grid_001.tga',
				channels: 'RG',
				rColor: '46938D',
				gColor: '88FFC2',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 10,
				thumb: 'prints/thumbs/Thb_Print_Star_Grid_001.png',
				id: 19,
			},
			{
				name: 'Print_Stars_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Stars_001.tga',
				channels: 'RG',
				rColor: 'FFFFFF',
				gColor: '85AAE2',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 18,
				thumb: 'prints/thumbs/Thb_Print_Stars_001.png',
				id: 108,
			},
			{
				name: 'Print_Stars_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Stars_002.tga',
				channels: 'RGB',
				rColor: 'FFFFFF',
				gColor: '24549C',
				bColor: 'C51712',
				aColor: 'N/A',
				tiling: 16,
				thumb: 'prints/thumbs/Thb_Print_Stars_002.png',
				id: 109,
			},
			{
				name: 'Print_Stars_003',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Stars_003.tga',
				channels: 'RGB',
				rColor: 'FFFFFF',
				gColor: '24549C',
				bColor: 'AD2D2A',
				aColor: 'N/A',
				tiling: 18,
				thumb: 'prints/thumbs/Thb_Print_Stars_003.png',
				id: 110,
			},
			{
				name: 'Print_Stars_004',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Stars_004.tga',
				channels: 'RGBA',
				rColor: 'FFFFFF',
				gColor: '24549C',
				bColor: 'C51712',
				aColor: '3F3F4D',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Stars_004.png',
				id: 111,
			},
			{
				name: 'Print_Stars_005',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Stars_005.tga',
				channels: 'RGBA',
				rColor: 'FFFFFF',
				gColor: '24549C',
				bColor: 'C51712',
				aColor: '3F3F4D',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Stars_005.png',
				id: 112,
			},
			{
				name: 'Print_Stars_006',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Stars_006.tga',
				channels: 'RGBA',
				rColor: 'FFEC2A',
				gColor: '2FC1C3',
				bColor: 'FFFFFF',
				aColor: '364A76',
				tiling: 16,
				thumb: 'prints/thumbs/Thb_Print_Stars_006.png',
				id: 113,
			},
			{
				name: 'Print_Stars_007',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Stars_007.tga',
				channels: 'RGBA',
				rColor: '909090',
				gColor: 'FFFFFF',
				bColor: '2A2D98',
				aColor: 'C30808',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Stars_007.png',
				id: 114,
			},
			{
				name: 'Print_Stripes_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Stripes_001.tga',
				channels: 'RG',
				rColor: '82BFE5',
				gColor: 'FFFFFF',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 10,
				thumb: 'prints/thumbs/Thb_Print_Stripes_001.png',
				id: 20,
			},
			{
				name: 'Print_Stripes_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Stripes_002.tga',
				channels: 'RG',
				rColor: '2F2B5B',
				gColor: 'FFFFFF',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Stripes_002.png',
				id: 21,
			},
			{
				name: 'Print_Stripes_003',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Stripes_003.tga',
				channels: 'RGB',
				rColor: 'FFFFFF',
				gColor: '040054',
				bColor: 'FFAAB9',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Stripes_003.png',
				id: 22,
			},
			{
				name: 'Print_Stripes_004',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Stripes_004.tga',
				channels: 'RGBA',
				rColor: 'FFFFFF',
				gColor: 'C9C6FF',
				bColor: 'FF8A9F',
				aColor: '9A0016',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Stripes_004.png',
				id: 23,
			},
			{
				name: 'Print_Stripes_005',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Stripes_005.tga',
				channels: 'RGBA',
				rColor: 'B1FFCB',
				gColor: '7EA687',
				bColor: 'F5D5FF',
				aColor: 'FFFFFF',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Stripes_005.png',
				id: 24,
			},
			{
				name: 'Print_Stripes_006',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Stripes_006.tga',
				channels: 'RG',
				rColor: 'FFFFFF',
				gColor: '0E112B',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 10,
				thumb: 'prints/thumbs/Thb_Print_Stripes_006.png',
				id: 25,
			},
			{
				name: 'Print_Stripes_007',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Stripes_007.tga',
				channels: 'RGBA',
				rColor: 'FFFFFF',
				gColor: '522F4C',
				bColor: 'EEBCD3',
				aColor: 'C796FF',
				tiling: 20,
				thumb: 'prints/thumbs/Thb_Print_Stripes_007.png',
				id: 115,
			},
			{
				name: 'Print_Stripes_008',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Stripes_008.tga',
				channels: 'RGBA',
				rColor: 'FFFFFF',
				gColor: '0E112B',
				bColor: 'CA84C3',
				aColor: 'B74646',
				tiling: 16,
				thumb: 'prints/thumbs/Thb_Print_Stripes_008.png',
				id: 116,
			},
			{
				name: 'Print_Stripes_009',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Stripes_009.tga',
				channels: 'RGBA',
				rColor: '88CBFF',
				gColor: '0E0F2B',
				bColor: 'D5EEFF',
				aColor: '4746B7',
				tiling: 20,
				thumb: 'prints/thumbs/Thb_Print_Stripes_009.png',
				id: 117,
			},
			{
				name: 'Print_Stripes_011',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Stripes_011.tga',
				channels: 'RGBA',
				rColor: 'D6545C',
				gColor: 'FF99A8',
				bColor: 'FDB6B9',
				aColor: 'C84345',
				tiling: 14,
				thumb: 'prints/thumbs/Thb_Print_Stripes_011.png',
				id: 119,
			},
			{
				name: 'Print_Tile_Flower_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Tile_Flower_001.tga',
				channels: 'RGB',
				rColor: 'FFFFFF',
				gColor: '40456F',
				bColor: 'C9CEFF',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Tile_Flower_001.png',
				id: 26,
			},
			{
				name: 'Print_Tile_Flower_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Tile_Flower_002.tga',
				channels: 'RG',
				rColor: 'FFFFFF',
				gColor: '40456F',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Tile_Flower_002.png',
				id: 27,
			},
			{
				name: 'Print_Tile_Flower_003',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Tile_Flower_003.tga',
				channels: 'RGB',
				rColor: 'FFFFFF',
				gColor: 'DB9CBE',
				bColor: '9F4C59',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Tile_Flower_003.png',
				id: 28,
			},
			{
				name: 'Print_Tile_Flower_004',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Tile_Flower_004.tga',
				channels: 'RGB',
				rColor: '4A8DA6',
				gColor: 'FFFFFF',
				bColor: 'B3FCFF',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Tile_Flower_004.png',
				id: 29,
			},
			{
				name: 'Print_Tile_Flower_005',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Tile_Flower_005.tga',
				channels: 'RGB',
				rColor: '25C4FF',
				gColor: '18648C',
				bColor: 'B3FCFF',
				aColor: 'N/A',
				tiling: 6,
				thumb: 'prints/thumbs/Thb_Print_Tile_Flower_005.png',
				id: 30,
			},
			{
				name: 'Print_Tile_Flower_006',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Tile_Flower_006.tga',
				channels: 'RG',
				rColor: 'FFFFFF',
				gColor: '188C1A',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Tile_Flower_006.png',
				id: 120,
			},
			{
				name: 'Print_Tile_Flower_007',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Tile_Flower_007.tga',
				channels: 'RGBA',
				rColor: 'f8fcde',  
				gColor: '596359',
				bColor: '758c46',
				aColor: '297650',
				tiling: 16,
				thumb: 'prints/thumbs/Thb_Print_Tile_Flower_007.png',
				id: 121,
			},
			{
				name: 'Print_Tile_Flower_008',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Tile_Flower_008.tga',
				channels: 'RGBA',
				rColor: '0773ff',  
				gColor: 'ffd165',
				bColor: '070878',
				aColor: 'ffaa5b',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Tile_Flower_008.png',
				id: 122,
			},
			{
				name: 'Print_Tile_Flower_009',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Tile_Flower_009.tga',
				channels: 'RGBA',
				rColor: 'FFFFFF',
				gColor: '5EDAE5',
				bColor: '0E891E',
				aColor: 'B93E3E',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Tile_Flower_009.png',
				id: 123,
			},
			{
				name: 'Print_Tile_Flower_010',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Tile_Flower_010.tga',
				channels: 'RGB',
				rColor: '12488E',
				gColor: 'FCFFC2',
				bColor: '17A830',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Tile_Flower_010.png',
				id: 124,
			},
			{
				name: 'Print_Tile_Flower_011',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Tile_Flower_011.tga',
				channels: 'RG',
				rColor: '621E73',
				gColor: 'FFC7C2',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Tile_Flower_011.png',
				id: 125,
			},
			{
				name: 'Print_Tile_Flower_012',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Tile_Flower_012.tga',
				channels: 'RGB',
				rColor: '259389',
				gColor: 'FFC2F7',
				bColor: '2537C0',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Tile_Flower_012.png',
				id: 126,
			},
			{
				name: 'Print_Tile_Flower_013',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Tile_Flower_013.tga',
				channels: 'RGBA',
				rColor: '105927',
				gColor: '77C04D',
				bColor: 'AFE292',
				aColor: 'FFFFFF',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Tile_Flower_013.png',
				id: 127,
			},
			{
				name: 'Print_Tile_Flower_014',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Tile_Flower_014.tga',
				channels: 'RGBA',
				rColor: '22462D',
				gColor: '77C04D',
				bColor: 'ECF354',
				aColor: 'FFA231',
				tiling: 10,
				thumb: 'prints/thumbs/Thb_Print_Tile_Flower_014.png',
				id: 128,
			},
			{
				name: 'Print_Tile_Flower_015',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Tile_Flower_015.tga',
				channels: 'RGBA',
				rColor: '081E29',
				gColor: '77C04D',
				bColor: 'FA4627',
				aColor: '599039',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Tile_Flower_015.png',
				id: 129,
			},
			{
				name: 'Print_Tile_Flower_016',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Tile_Flower_016.tga',
				channels: 'RGBA',
				rColor: 'F5F450',
				gColor: '94C04D',
				bColor: '396A1C',
				aColor: '48931C',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Tile_Flower_016.png',
				id: 130,
			},
			{
				name: 'Print_Tile_Flower_017',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Tile_Flower_017.tga',
				channels: 'RGBA',
				rColor: '959595',
				gColor: 'B04646',
				bColor: 'D66464',
				aColor: '675A56',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Tile_Flower_017.png',
				id: 131,
			},
			{
				name: 'Print_Whales_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Whales_001.tga',
				channels: 'RGBA',
				rColor: 'FFFFFF',
				gColor: '85AAE2',
				bColor: 'B4D3E5',
				aColor: '3F3F4D',
				tiling: 6,
				thumb: 'prints/thumbs/Thb_Print_Whales_001.png',
				id: 31,
			},
			{
				name: 'Print_Arrows_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Arrows_001.tga',
				channels: 'RG',
				rColor: 'FFF402',
				gColor: '6699CC',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Arrows_001.png',
				id: 133,
			},
			{
				name: 'Print_Clover_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Clover_001.tga',
				channels: 'RG',
				rColor: '00B200',
				gColor: '5BF05B',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Clover_001.png',
				id: 134,
			},
			{
				name: 'Print_Tile_Flower_018',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Tile_Flower_018.tga',
				channels: 'RGBA',
				rColor: 'A63446',
				gColor: 'FBFEF9',
				bColor: '0C6291',
				aColor: '000004',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Tile_Flower_018.png',
				id: 135,
			},
			{
				name: 'Print_Tile_Flower_019',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Tile_Flower_019.tga',
				channels: 'RG',
				rColor: 'D10F10',
				gColor: 'F7A399',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 16,
				thumb: 'prints/thumbs/Thb_Print_Tile_Flower_019.png',
				id: 136,
			},
			{
				name: 'Print_Tile_Flower_020',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Tile_Flower_020.tga',
				channels: 'RGB',
				rColor: '152552',
				gColor: 'D84C4C',
				bColor: 'FCE209',
				aColor: 'N/A',
				tiling: 10,
				thumb: 'prints/thumbs/Thb_Print_Tile_Flower_020.png',
				id: 137,
			},
			{
				name: 'Print_Tile_Flower_021',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Tile_Flower_021.tga',
				channels: 'RGBA',
				rColor: '72FFDE',
				gColor: '158C70',
				bColor: 'DEFCF5',
				aColor: '22C7A0',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Tile_Flower_021.png',
				id: 138,
			},
			{
				name: 'Print_Kaleidoscope_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Kaleidoscope_001.tga',
				channels: 'RGB',
				rColor: '158C70',
				gColor: '002C79',
				bColor: '9FCAE9',
				aColor: 'N/A',
				tiling: 10,
				thumb: 'prints/thumbs/Thb_Print_Kaleidoscope_001.png',
				id: 139,
			},
			{
				name: 'Print_Kaleidoscope_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Kaleidoscope_002.tga',
				channels: 'RGBA',
				rColor: '6B2D5C',
				gColor: 'F0386B',
				bColor: 'FF5376',
				aColor: 'F8C0C8',
				tiling: 10,
				thumb: 'prints/thumbs/Thb_Print_Kaleidoscope_002.png',
				id: 140,
			},
			{
				name: 'Print_Kaleidoscope_003',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Kaleidoscope_003.tga',
				channels: 'RGBA',
				rColor: '000000',
				gColor: '7E2E84',
				bColor: 'D14081',
				aColor: 'EF798A',
				tiling: 10,
				thumb: 'prints/thumbs/Thb_Print_Kaleidoscope_003.png',
				id: 141,
			},
			{
				name: 'Print_Kaleidoscope_004',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Kaleidoscope_004.tga',
				channels: 'RGB',
				rColor: '3D348B',
				gColor: '7678ED',
				bColor: 'F7B801',
				aColor: 'N/A',
				tiling: 9.6,
				thumb: 'prints/thumbs/Thb_Print_Kaleidoscope_004.png',
				id: 142,
			},
			{
				name: 'Print_Maze_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Maze_001.tga',
				channels: 'RG',
				rColor: '0760CD',
				gColor: 'BFDAFF',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Maze_001.png',
				id: 143,
			},
			{
				name: 'Print_Pins_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Pins_001.tga',
				channels: 'RG',
				rColor: 'A63446',
				gColor: 'FBFEF9',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Pins_001.png',
				id: 144,
			},
			{
				name: 'Print_Triangles_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Triangles_001.tga',
				channels: 'RG',
				rColor: 'FA7400',
				gColor: 'D75B00',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 36,
				thumb: 'prints/thumbs/Thb_Print_Triangles_001.png',
				id: 145,
			},
			{
				name: 'Print_Triangles_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Triangles_002.tga',
				channels: 'RGB',
				rColor: '246EB9',
				gColor: '4CB944',
				bColor: 'FDFFFC',
				aColor: 'N/A',
				tiling: 22,
				thumb: 'prints/thumbs/Thb_Print_Triangles_002.png',
				id: 146,
			},
			{
				name: 'Print_Wave_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Wave_001.tga',
				channels: 'RGB',
				rColor: '533A71',
				gColor: '6184D8',
				bColor: '50C5B7',
				aColor: 'N/A',
				tiling: 10,
				thumb: 'prints/thumbs/Thb_Print_Wave_001.png',
				id: 147,
			},
			{
				name: 'Print_Checkers_007',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Checkers_007.tga',
				channels: 'RG',
				rColor: 'FF0B00',
				gColor: 'FF5600',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Checkers_007.png',
				id: 148,
			},
			{
				name: 'Print_Circles_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Circles_001.tga',
				channels: 'RGB',
				rColor: '337CA0',
				gColor: '3EC300',
				bColor: 'FFFC31',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Circles_001.png',
				id: 149,
			},
			{
				name: 'Print_Circles_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Circles_002.tga',
				channels: 'RG',
				rColor: 'EAC435',
				gColor: '345995',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Circles_002.png',
				id: 150,
			},
			{
				name: 'Print_Geometric_025',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_025.tga',
				channels: 'RG',
				rColor: '8CB369',
				gColor: 'F4E285',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 5.6,
				thumb: 'prints/thumbs/Thb_Print_Geometric_025.png',
				id: 151,
			},
			{
				name: 'Print_Geometric_026',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_026.tga',
				channels: 'RG',
				rColor: '042A2B',
				gColor: '5EB1BF',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Geometric_026.png',
				id: 152,
			},
			{
				name: 'Print_Circles_003',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Circles_003.tga',
				channels: 'RG',
				rColor: '89023E',
				gColor: 'CC7178',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Circles_003.png',
				id: 153,
			},
			{
				name: 'Print_Squares_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Squares_001.tga',
				channels: 'RG',
				rColor: '95DD24',
				gColor: '6F9C28',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Squares_001.png',
				id: 154,
			},
			{
				name: 'Print_Weave_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Weave_001.tga',
				channels: 'RG',
				rColor: '72FFDE',
				gColor: '158C70',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Weave_001.png',
				id: 155,
			},
			{
				name: 'Print_Geometric_027',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_027.tga',
				channels: 'RG',
				rColor: '7776BC',
				gColor: 'CDC7E5',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Geometric_027.png',
				id: 156,
			},
			{
				name: 'Print_Geometric_028',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_028.tga',
				channels: 'RG',
				rColor: '0760CD',
				gColor: 'BFDAFF',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Geometric_028.png',
				id: 157,
			},
			{
				name: 'Print_Tile_Flower_022',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Tile_Flower_022.tga',
				channels: 'RGB',
				rColor: '6ACDE9',
				gColor: 'F1EE72',
				bColor: '7EC893',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Tile_Flower_022.png',
				id: 158,
			},
			{
				name: 'Print_Dots_012',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Dots_012.tga',
				channels: 'RGBA',
				rColor: 'FFFFFF',
				gColor: '5565AF',
				bColor: 'F389B8',
				aColor: '6CC7B4',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Dots_012.png',
				id: 159,
			},
			{
				name: 'Print_Geometric_029',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_029.tga',
				channels: 'RGBA',
				rColor: 'FFFFFF',
				gColor: '71BF44',
				bColor: '4479BD',
				aColor: 'F47624',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Geometric_029.png',
				id: 160,
			},
			{
				name: 'Print_Squares_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Squares_002.tga',
				channels: 'RGBA',
				rColor: '7CC242',
				gColor: 'FBF594',
				bColor: '5BC9E3',
				aColor: 'EF7FB2',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Squares_002.png',
				id: 161,
			},
			{
				name: 'Print_Chevrons_009',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Chevrons_009.tga',
				channels: 'RG',
				rColor: 'FFFFFF',
				gColor: '000000',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 24,
				thumb: 'prints/thumbs/Thb_Print_Chevrons_009.png',
				id: 162,
			},
			{
				name: 'Print_Circles_004',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Circles_004.tga',
				channels: 'RGBA',
				rColor: '87C440',
				gColor: '2D6EB6',
				bColor: '8558A5',
				aColor: 'FFD16F',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Circles_004.png',
				id: 163,
			},
			{
				name: 'Print_Stars_008',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Stars_008.tga',
				channels: 'RGB',
				rColor: '2D60AD',
				gColor: 'A3DCEA',
				bColor: '000000',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Stars_008.png',
				id: 164,
			},
			{
				name: 'Print_Dots_013',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Dots_013.tga',
				channels: 'RGB',
				rColor: 'FFFFFF',
				gColor: 'A3DCEA',
				bColor: 'A0B0DA',
				aColor: 'N/A',
				tiling: 4,
				thumb: 'prints/thumbs/Thb_Print_Dots_013.png',
				id: 165,
			},
			{
				name: 'Print_Misc_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Misc_001.tga',
				channels: 'RGB',
				rColor: '5067B0',
				gColor: '37C6F4',
				bColor: '374FA2',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Misc_001.png',
				id: 166,
			},
			{
				name: 'Print_Stars_009',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Stars_009.tga',
				channels: 'RGB',
				rColor: 'A9D049',
				gColor: '72C054',
				bColor: '2D60AD',
				aColor: 'N/A',
				tiling: 4,
				thumb: 'prints/thumbs/Thb_Print_Stars_009.png',
				id: 167,
			},
			{
				name: 'Print_Triangles_005',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Triangles_005.tga',
				channels: 'RG',
				rColor: 'FFFFFF',
				gColor: '16A0D3',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Triangles_005.png',
				id: 168,
			},
			{
				name: 'Print_Geometric_030',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_030.tga',
				channels: 'RG',
				rColor: '1CA796',
				gColor: '7CCCC5',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Geometric_030.png',
				id: 169,
			},
			{
				name: 'Print_Triangles_003',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Triangles_003.tga',
				channels: 'RGB',
				rColor: '76CCC6',
				gColor: '27A675',
				bColor: '3084B9',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Triangles_003.png',
				id: 170,
			},
			{
				name: 'Print_Geometric_031',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_031.tga',
				channels: 'RGBA',
				rColor: '577DBA',
				gColor: 'E3DE49',
				bColor: '7DC042',
				aColor: '7E57A6',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Geometric_031.png',
				id: 171,
			},
			{
				name: 'Print_Geometric_032',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_032.tga',
				channels: 'RG',
				rColor: 'FFFFFF',
				gColor: '000000',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 4,
				thumb: 'prints/thumbs/Thb_Print_Geometric_032.png',
				id: 172,
			},
			{
				name: 'Print_Geometric_033',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_033.tga',
				channels: 'RG',
				rColor: 'FFFFFF',
				gColor: '6599D2',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Geometric_033.png',
				id: 173,
			},
			{
				name: 'Print_Leaves_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Leaves_002.tga',
				channels: 'RG',
				rColor: 'BDE5E1',
				gColor: '1CA796',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 6,
				thumb: 'prints/thumbs/Thb_Print_Leaves_002.png',
				id: 174,
			},
			{
				name: 'Print_Dots_014',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Dots_014.tga',
				channels: 'RG',
				rColor: 'EE3A26',
				gColor: 'EDF1B2',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 20,
				thumb: 'prints/thumbs/Thb_Print_Dots_014.png',
				id: 175,
			},
			{
				name: 'Print_Misc_002',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Misc_002.tga',
				channels: 'RGB',
				rColor: 'EDF1B2',
				gColor: '8BC63F',
				bColor: 'FED66D',
				aColor: 'N/A',
				tiling: 12,
				thumb: 'prints/thumbs/Thb_Print_Misc_002.png',
				id: 176,
			},
			{
				name: 'Print_Circles_005',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Circles_005.tga',
				channels: 'RG',
				rColor: 'FFFFFF',
				gColor: '000000',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Circles_005.png',
				id: 177,
			},
			{
				name: 'Print_Geometric_034',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_034.tga',
				channels: 'RGBA',
				rColor: '8CD6F0',
				gColor: '9ECF6C',
				bColor: '70CAC7',
				aColor: '4E56A5',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Geometric_034.png',
				id: 178,
			},
			{
				name: 'Print_Geometric_035',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_035.tga',
				channels: 'RGBA',
				rColor: '9996C4',
				gColor: '86849E',
				bColor: 'CD8A9D',
				aColor: '522B80',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Geometric_035.png',
				id: 179,
			},
			{
				name: 'Print_Geometric_036',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_036.tga',
				channels: 'RGBA',
				rColor: 'D3D4D4',
				gColor: 'A9A9A9',
				bColor: '7D7E7E',
				aColor: '3D1110',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Geometric_036.png',
				id: 180,
			},
			{
				name: 'Print_Geometric_037',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_037.tga',
				channels: 'RGBA',
				rColor: '84D2DE',
				gColor: '73BF43',
				bColor: '59479D',
				aColor: '9558A4',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Geometric_037.png',
				id: 181,
			},
			{
				name: 'Print_Geometric_038',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_038.tga',
				channels: 'RGBA',
				rColor: 'F7F16B',
				gColor: '70C22E',
				bColor: '687CBD',
				aColor: 'B673B0',
				tiling: 4,
				thumb: 'prints/thumbs/Thb_Print_Geometric_038.png',
				id: 182,
			},
			{
				name: 'Print_Geometric_039',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_039.tga',
				channels: 'RGBA',
				rColor: 'B894C4',
				gColor: '8D92C8',
				bColor: 'F2EF72',
				aColor: '76C799',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Geometric_039.png',
				id: 183,
			},
			{
				name: 'Print_Diamond_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Diamond_001.tga',
				channels: 'RGB',
				rColor: '8D92C8',
				gColor: '79D1EB',
				bColor: '425CAA',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Diamond_001.png',
				id: 184,
			},
			{
				name: 'Print_Geometric_040',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_040.tga',
				channels: 'RG',
				rColor: '79CAB6',
				gColor: '49479D',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Geometric_040.png',
				id: 185,
			},
			{
				name: 'Print_Geometric_048',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_048.tga',
				channels: 'RGB',
				rColor: 'FFFFFF',
				gColor: '4C6BB3',
				bColor: 'D67D5C',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Geometric_048.png',
				id: 186,
			},
			{
				name: 'Print_Circles_006',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Circles_006.tga',
				channels: 'RG',
				rColor: 'FFFFFF',
				gColor: 'F58D6D',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Circles_006.png',
				id: 187,
			},
			{
				name: 'Print_Geometric_041',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_041.tga',
				channels: 'RGB',
				rColor: 'FFFFFF',
				gColor: '48BCEC',
				bColor: 'ECA337',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Geometric_041.png',
				id: 188,
			},
			{
				name: 'Print_Dots_015',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Dots_015.tga',
				channels: 'RGB',
				rColor: '5BCCF5',
				gColor: 'FFFFFF',
				bColor: '5565AF',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Dots_015.png',
				id: 189,
			},
			{
				name: 'Print_Triangles_004',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Triangles_004.tga',
				channels: 'RGB',
				rColor: 'FFFFFF',
				gColor: 'FBB485',
				bColor: 'FDD321',
				aColor: 'N/A',
				tiling: 4,
				thumb: 'prints/thumbs/Thb_Print_Triangles_004.png',
				id: 190,
			},
			{
				name: 'Print_Stars_010',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Stars_010.tga',
				channels: 'RGBA',
				rColor: 'FBF594',
				gColor: 'F05A61',
				bColor: '6ACDE9',
				aColor: '8D4F98',
				tiling: 6,
				thumb: 'prints/thumbs/Thb_Print_Stars_010.png',
				id: 191,
			},
			{
				name: 'Print_Hex_001',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Hex_001.tga',
				channels: 'RGBA',
				rColor: 'FFE53C',
				gColor: 'FFAA00',
				bColor: 'F1AB4A',
				aColor: 'FFCE45',
				tiling: 4,
				thumb: 'prints/thumbs/Thb_Print_Hex_001.png',
				id: 192,
			},
			{
				name: 'Print_Geometric_042',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_042.tga',
				channels: 'RG',
				rColor: 'E2F1DE',
				gColor: '6CBD45',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 4,
				thumb: 'prints/thumbs/Thb_Print_Geometric_042.png',
				id: 193,
			},
			{
				name: 'Print_Geometric_043',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_043.tga',
				channels: 'RGB',
				rColor: 'FDD321',
				gColor: '2D6EB6',
				bColor: '48BCEC',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Geometric_043.png',
				id: 194,
			},
			{
				name: 'Print_Checkers_008',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Checkers_008.tga',
				channels: 'RG',
				rColor: 'FFFFFF',
				gColor: '5BC9E3',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 6,
				thumb: 'prints/thumbs/Thb_Print_Checkers_008.png',
				id: 195,
			},
			{
				name: 'Print_Geometric_044',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_044.tga',
				channels: 'RGB',
				rColor: 'FFFFFF',
				gColor: '29B24B',
				bColor: 'EF4423',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Geometric_044.png',
				id: 196,
			},
			{
				name: 'Print_Geometric_045',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_045.tga',
				channels: 'RGB',
				rColor: '000000',
				gColor: '2D6EB6',
				bColor: 'FDD321',
				aColor: 'N/A',
				tiling: 4,
				thumb: 'prints/thumbs/Thb_Print_Geometric_045.png',
				id: 197,
			},
			{
				name: 'Print_Geometric_046',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_046.tga',
				channels: 'RG',
				rColor: 'F99D1B',
				gColor: '000000',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 4,
				thumb: 'prints/thumbs/Thb_Print_Geometric_046.png',
				id: 198,
			},
			{
				name: 'Print_Misc_003',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Misc_003.tga',
				channels: 'RGB',
				rColor: 'FFFFFF',
				gColor: '6ECFF0',
				bColor: '000000',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Misc_003.png',
				id: 199,
			},
			{
				name: 'Print_Circles_007',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Circles_007.tga',
				channels: 'RGBA',
				rColor: '1461AD',
				gColor: 'BBD7C7',
				bColor: 'BA6F9F',
				aColor: '69AF43',
				tiling: 4,
				thumb: 'prints/thumbs/Thb_Print_Circles_007.png',
				id: 200,
			},
			{
				name: 'Print_Dots_016',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Dots_016.tga',
				channels: 'RGBA',
				rColor: 'FFFFFF',
				gColor: '80C341',
				bColor: '4D8FCC',
				aColor: 'CF7EB4',
				tiling: 4,
				thumb: 'prints/thumbs/Thb_Print_Dots_016.png',
				id: 201,
			},
			{
				name: 'Print_Circles_008',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Circles_008.tga',
				channels: 'RGB',
				rColor: 'FFFFFF',
				gColor: 'F26222',
				bColor: '000000',
				aColor: 'N/A',
				tiling: 8,
				thumb: 'prints/thumbs/Thb_Print_Circles_008.png',
				id: 202,
			},
			{
				name: 'Print_Geometric_047',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Geometric_047.tga',
				channels: 'RG',
				rColor: 'D8CDBC',
				gColor: '0B0C0D',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 4,
				thumb: 'prints/thumbs/Thb_Print_Geometric_047.png',
				id: 203,
			},
			{
				name: 'Print_Squares_003',
				albedoURL: 'N/A',
				maskURL: 'prints/masks/Print_Squares_003.tga',
				channels: 'RG',
				rColor: '988372',
				gColor: 'D6CBB8',
				bColor: 'N/A',
				aColor: 'N/A',
				tiling: 4,
				thumb: 'prints/thumbs/Thb_Print_Squares_003.png',
				id: 204,
			},
		],
		uploads: [],
	},
	materials: [{
		albedo: 'materials/textures/BrushedMetal_001_D.png',
		normal: 'materials/textures/BrushedMetal_001_N.png',
		r: 'materials/textures/BrushedMetal_001_R.png',
		thumb: 'materials/thumbs/Thb_Mat_Metal_001a.png',
		normalMapStrength: 1,
		tiling: 1,
		metalness: 0.5,
		smoothness: 0.53,
		name: 'BrushedMetal 001',
		id: 13,
	},
		{
			albedo: 'materials/textures/GlazedClay_D.png',
			normal: 'materials/textures/GlazedClay_N.png',
			r: 'materials/textures/GlazedClay_R.png',
			thumb: 'materials/thumbs/Thb_Mat_Clay_001.png',
			normalMapStrength: 0.47,
			tiling: 1,
			metalness: 0.00,
			smoothness: 0.61,
			name: 'Glazed Clay',
			id: 1,
			uOffset: 0.5,
			vOffset: 0.5,
		},
		{
			albedo: 'materials/textures/Marble_D.png',
			normal: 'materials/textures/Marble_N.png',
			r: 'materials/textures/Marble_R.png',
			thumb: 'materials/thumbs/Thb_Mat_Marble_001.png',
			normalMapStrength: 0.36,
			tiling: 1,
			metalness: 0,
			smoothness: 0.7,
			name: 'Marble',
			id: 4,
		},
		{
			albedo: 'materials/textures/OldWood_D.png',
			normal: 'materials/textures/OldWood_N.png',
			r: 'materials/textures/OldWood_R.png',
			thumb: 'materials/thumbs/Thb_Mat_Wood_001c.png',
			normalMapStrength: 0.2,
			tiling: 1,
			metalness: 0,
			smoothness: 0.25,
			name: 'Old Wood',
			id: 6,
		},
		{
			albedo: 'materials/textures/PolishedWood_D.png',
			normal: 'materials/textures/PolishedWood_N.png',
			r: 'materials/textures/PolishedWood_R.png',
			thumb: 'materials/thumbs/Thb_Mat_Wood_001b.png',
			normalMapStrength: 0.07,
			tiling: 1,
			metalness: 0.001,
			smoothness: 0.05,
			name: 'Polished Wood',
			id: 7,
		},
		{
			albedo: 'materials/textures/Stone_001_D.png',
			normal: 'materials/textures/Stone_001_N.png',
			r: 'materials/textures/Stone_001_R.png',
			thumb: 'materials/thumbs/Thb_Mat_Stone_001b.png',
			normalMapStrength: 1,
			tiling: 1,
			smoothness: 0.65,
			name: 'Stone 001',
			id: 8,
		},
		{
			albedo: 'materials/textures/Stone_D.png',
			normal: 'materials/textures/Stone_N.png',
			r: 'materials/textures/Stone_R.png',
			thumb: 'materials/thumbs/Thb_Mat_Stone_001a.png',
			normalMapStrength: 0.2,
			tiling: 1,
			metalness: 0,
			smoothness: 0.65,
			name: 'Stone',
			id: 9,
		},
		{
			albedo: 'materials/textures/Wood_001_D.png',
			normal: 'materials/textures/Wood_001_N.png',
			r: 'materials/textures/Wood_001_R.png',
			thumb: 'materials/thumbs/Thb_Mat_Wood_001a.png',
			normalMapStrength: 0,
			tiling: 1.0,
			metalness: 0,
			smoothness: 0.7,
			name: 'Wood 001',
			id: 10,
		},
		{
			albedo: 'materials/textures/Fabric_004_diffuse.png',
			normal: 'materials/textures/Fabric_004_normal.png',
			r: 'materials/textures/Fabric_004_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Fabric_004.png',
			normalMapStrength: 0.868,
			tiling: 1,
			metalness: 0,
			smoothness: 0.55,
			name: 'Fabric 004',
			id: 11,
		},
		{
			albedo: 'materials/textures/Leather_005_diffuse.png',
			normal: 'materials/textures/Leather_005_normal.png',
			r: 'materials/textures/Leather_005_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Leather_005.png',
			normalMapStrength: 0.4,
			tiling: 0.7,
			metalness: 0,
			smoothness: 0.35,
			name: 'Leather 005',
			id: 12,
		},
		{
			albedo: 'materials/textures/Cardboard_001_diffuse.png',
			normal: 'materials/textures/Cardboard_001_normal.png',
			r: 'materials/textures/Cardboard_001_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Cardboard_001.png',
			normalMapStrength: 1,
			tiling: 0.5,
			metalness: 0.13,
			smoothness: 0.1,
			name: 'Cardboard 001',
			id: 14,
		},
		{
			albedo: 'materials/textures/Concrete_001_diffuse.png',
			normal: 'materials/textures/Concrete_001_normal.png',
			r: 'materials/textures/Concrete_001_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Concrete_001.png',
			normalMapStrength: 1,
			tiling: 1,
			metalness: 0.12,
			smoothness: 0.34,
			name: 'Concrete 001',
			id: 15,
		},
		{
			albedo: 'materials/textures/Concrete_002_diffuse.png',
			normal: 'materials/textures/Concrete_002_normal.png',
			r: 'materials/textures/Concrete_002_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Concrete_002.png',
			normalMapStrength: 1,
			tiling: 1,
			metalness: 0,
			smoothness: 0.45,
			name: 'Concrete 002',
			id: 16,
		},
		{
			albedo: 'materials/textures/Concrete_004_diffuse.png',
			normal: 'materials/textures/Concrete_004_normal.png',
			r: 'materials/textures/Concrete_004_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Concrete_004.png',
			normalMapStrength: 1,
			tiling: 1,
			metalness: 0.1,
			smoothness: 0.35,
			name: 'Concrete 004',
			id: 17,
		},
		{
			albedo: 'materials/textures/Fabric_001_diffuse.png',
			normal: 'materials/textures/Fabric_001_normal.png',
			r: 'materials/textures/Fabric_001_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Fabric_001.png',
			normalMapStrength: 0.72,
			tiling: 0.75,
			metalness: 0,
			smoothness: 0.32,
			name: 'Fabric 001',
			id: 18,
		},
		{
			albedo: 'materials/textures/Fabric_003_diffuse.png',
			normal: 'materials/textures/Fabric_003_normal.png',
			r: 'materials/textures/Fabric_003_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Fabric_003.png',
			normalMapStrength: 0.4,
			tiling: 0.5,
			metalness: 0,
			smoothness: 0.43,
			name: 'Fabric 003',
			id: 19,
		},
		{
			albedo: 'materials/textures/Fabric_010_diffuse.png',
			normal: 'materials/textures/Fabric_010_normal.png',
			r: 'materials/textures/Fabric_010_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Fabric_010.png',
			normalMapStrength: 0.3,
			tiling: 0.7,
			metalness: 0,
			smoothness: 0.3,
			name: 'Fabric 010',
			id: 20,
		},
		{
			albedo: 'materials/textures/Fabric_011_diffuse.png',
			normal: 'materials/textures/Fabric_011_normal.png',
			r: 'materials/textures/Fabric_011_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Fabric_011.png',
			normalMapStrength: 0.15,
			tiling: 0.65,
			metalness: 0,
			smoothness: 0,
			name: 'Fabric 011',
			id: 21,
		},
		{
			albedo: 'materials/textures/Fabric_012_diffuse.png',
			normal: 'materials/textures/Fabric_012_normal.png',
			r: 'materials/textures/Fabric_012_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Fabric_012.png',
			normalMapStrength: 0.35,
			tiling: 1,
			metalness: 0,
			smoothness: 0.25,
			name: 'Fabric 012',
			id: 22,
		},
		{
			albedo: 'materials/textures/Fabric_014_diffuse.png',
			normal: 'materials/textures/Fabric_014_normal.png',
			r: 'materials/textures/Fabric_014_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Fabric_014.png',
			normalMapStrength: 0.15,
			tiling: 0.75,
			metalness: 0,
			smoothness: 0.3,
			name: 'Fabric 014',
			id: 23,
		},
		{
			albedo: 'materials/textures/Fabric_015_diffuse.png',
			normal: 'materials/textures/Fabric_015_normal.png',
			r: 'materials/textures/Fabric_015_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Fabric_015.png',
			normalMapStrength: 0.5,
			tiling: 0.5,
			metalness: 0.15,
			smoothness: 0.3,
			name: 'Fabric 015',
			id: 24,
		},
		{
			albedo: 'materials/textures/Leather_001_diffuse.png',
			normal: 'materials/textures/Leather_001_normal.png',
			r: 'materials/textures/Leather_001_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Leather_001.png',
			normalMapStrength: 1,
			tiling: 0.5,
			metalness: 0,
			smoothness: 0.39,
			name: 'Leather 001',
			id: 25,
		},
		{
			albedo: 'materials/textures/Leather_003_diffuse.png',
			normal: 'materials/textures/Leather_003_normal.png',
			r: 'materials/textures/Leather_003_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Leather_003.png',
			normalMapStrength: 1,
			tiling: 1.75,
			metalness: 0,
			smoothness: 0.43,
			name: 'Leather 003',
			id: 26,
		},
		{
			albedo: 'materials/textures/Leather_004_diffuse.png',
			normal: 'materials/textures/Leather_004_normal.png',
			r: 'materials/textures/Leather_004_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Leather_004.png',
			normalMapStrength: 1,
			tiling: 1.00,
			metalness: 0,
			smoothness: 0.65,
			name: 'Leather 004',
			id: 27,
		},
		{
			albedo: 'materials/textures/Metal_001_diffuse.png',
			normal: 'materials/textures/Metal_001_normal.png',
			r: 'materials/textures/Metal_001_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Metal_001.png',
			normalMapStrength: 0.5,
			tiling: 1,
			metalness: 0.43,
			smoothness: 0.25,
			name: 'Metal 001',
			id: 28,
		},
		{
			albedo: 'materials/textures/Metal_003_diffuse.png',
			normal: 'materials/textures/Metal_003_normal.png',
			r: 'materials/textures/Metal_003_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Metal_003.png',
			normalMapStrength: 0.65,
			tiling: 1.66,
			metalness: 0.36,
			smoothness: 0.18,
			name: 'Metal 003',
			id: 29,
		},
		{
			albedo: 'materials/textures/Plastic_001_diffuse.png',
			normal: 'materials/textures/Plastic_001_normal.png',
			r: 'materials/textures/Plastic_001_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Plastic_001.png',
			normalMapStrength: 0.05,
			tiling: 0.75,
			metalness: 0,
			smoothness: 0,
			name: 'Plastic 001',
			id: 30,
		},
		{
			albedo: 'materials/textures/Stucco_001_diffuse.png',
			normal: 'materials/textures/Stucco_001_normal.png',
			r: 'materials/textures/Stucco_001_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Stucco_001.png',
			normalMapStrength: 0.3,
			tiling: 1,
			metalness: 0,
			smoothness: 0.4,
			name: 'Stucco 001',
			id: 31,
		},
		{
			albedo: 'materials/textures/Stucco_002_diffuse.png',
			normal: 'materials/textures/Stucco_002_normal.png',
			r: 'materials/textures/Stucco_002_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Stucco_002.png',
			normalMapStrength: 0.2,
			tiling: 0.5,
			metalness: 0.05,
			smoothness: 0,
			name: 'Stucco 002',
			id: 32,
		},
		{
			albedo: 'materials/textures/Wood_001_diffuse.png',
			normal: 'materials/textures/Wood_001_normal.png',
			r: 'materials/textures/Wood_001_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Wood_001.png',
			normalMapStrength: 1,
			tiling: 1.0,
			metalness: 0.11,
			smoothness: 0.04,
			name: 'Wood 001',
			id: 33,
		},
		{
			albedo: 'materials/textures/Wood_002_diffuse.png',
			normal: 'materials/textures/Wood_002_normal.png',
			r: 'materials/textures/Wood_002_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Wood_002.png',
			normalMapStrength: 0.3,
			tiling: 1,
			metalness: 0,
			smoothness: 0.25,
			name: 'Wood 002',
			id: 34,
		},
		{
			albedo: 'materials/textures/Wood_003_diffuse.png',
			normal: 'materials/textures/Wood_003_normal.png',
			r: 'materials/textures/Wood_003_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Wood_003.png',
			normalMapStrength: 0.3,
			tiling: 1,
			metalness: 0,
			smoothness: 0.56,
			name: 'Wood 003',
			id: 35,
		},
		{
			albedo: 'materials/textures/Concrete_003_diffuse.png',
			normal: 'materials/textures/Concrete_003_normal.png',
			r: 'materials/textures/Concrete_003_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Concrete_003.png',
			normalMapStrength: 0,
			tiling: 1,
			metalness: 0,
			smoothness: 0.0,
			name: 'Concrete 003',
			id: 36,
		},
		{
			albedo: 'materials/textures/Fabric_002_diffuse.png',
			normal: 'materials/textures/Fabric_002_normal.png',
			r: 'materials/textures/Fabric_002_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Fabric_002.png',
			normalMapStrength: 0.25,
			tiling: 1,
			metalness: 0,
			smoothness: 0.45,
			name: 'Fabric 002',
			id: 37,
		},
		{
			albedo: 'materials/textures/Fabric_005_diffuse.png',
			normal: 'materials/textures/Fabric_005_normal.png',
			r: 'materials/textures/Fabric_005_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Fabric_005.png',
			normalMapStrength: 0.721,
			tiling: 1,
			metalness: 0,
			smoothness: 0.2,
			name: 'Fabric 005',
			id: 38,
		},
		{
			albedo: 'materials/textures/Fabric_006_diffuse.png',
			normal: 'materials/textures/Fabric_006_normal.png',
			r: 'materials/textures/Fabric_006_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Fabric_006.png',
			normalMapStrength: 1,
			tiling: 1,
			metalness: 0,
			smoothness: 0.55,
			name: 'Fabric 006',
			id: 39,
		},
		{
			albedo: 'materials/textures/Fabric_007_diffuse.png',
			normal: 'materials/textures/Fabric_007_Denim_normal.png',
			r: 'materials/textures/Fabric_007_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Fabric_007.png',
			normalMapStrength: 0.1,
			tiling: 1,
			metalness: 0,
			smoothness: 0.35,
			name: 'Fabric 007',
			id: 40,
		},
		{
			albedo: 'materials/textures/Fabric_008_diffuse.png',
			normal: 'materials/textures/Fabric_008_normal.png',
			r: 'materials/textures/Fabric_008_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Fabric_008.png',
			normalMapStrength: 0.402,
			tiling: 1,
			metalness: 0,
			smoothness: 0.4,
			name: 'Fabric 008',
			id: 41,
		},
		{
			albedo: 'materials/textures/Fabric_009_diffuse.png',
			normal: 'materials/textures/Fabric_009_normal.png',
			r: 'materials/textures/Fabric_009_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Fabric_009.png',
			normalMapStrength: 0.6,
			tiling: 1,
			metalness: 0,
			smoothness: 0.2,
			name: 'Fabric 009',
			id: 42,
		},
		{
			albedo: 'materials/textures/Leather_002_diffuse.png',
			normal: 'materials/textures/Leather_002_normal.png',
			r: 'materials/textures/Leather_002_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Leather_002.png',
			normalMapStrength: 0.2,
			tiling: 2.0,
			metalness: 0,
			smoothness: 0.37,
			name: 'Leather 002',
			id: 44,
		},
		{
			albedo: 'materials/textures/Metal_002_diffuse.png',
			normal: 'materials/textures/Metal_002_normal.png',
			r: 'materials/textures/Metal_002_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Metal_002.png',
			normalMapStrength: 0.8,
			tiling: 1.66,
			metalness: 0.8,
			smoothness: 0.2,
			name: 'Metal 002',
			id: 45,
		},
		{
			albedo: 'materials/textures/Metal_004_diffuse.png',
			normal: 'materials/textures/Metal_004_normal.png',
			r: 'materials/textures/Metal_004_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Metal_004.png',
			normalMapStrength: 0.22,
			tiling: 1,
			metalness: 0.53,
			smoothness: 0,
			name: 'Metal 004',
			id: 46,
		},
		{
			albedo: 'materials/textures/Paper_001_diffuse.png',
			normal: 'materials/textures/Paper_001_normal.png',
			r: 'materials/textures/Paper_001_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Paper_001.png',
			normalMapStrength: 0.46,
			tiling: 0.7,
			metalness: 0,
			smoothness: 0,
			name: 'Paper 001',
			id: 47,
		},
		{
			albedo: 'materials/textures/Paper_002_diffuse.png',
			normal: 'materials/textures/Paper_002_normal.png',
			r: 'materials/textures/Paper_002_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Paper_002.png',
			normalMapStrength: 0.25,
			tiling: 0.7,
			metalness: 0.1,
			smoothness: 0,
			name: 'Paper 002',
			id: 48,
		},
		{
			albedo: 'materials/textures/Paper_003_diffuse.png',
			normal: 'materials/textures/Paper_003_normal.png',
			r: 'materials/textures/Paper_003_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Paper_003.png',
			normalMapStrength: 0.79,
			tiling: 1,
			metalness: 0.19,
			smoothness: 0.12,
			name: 'Paper 003',
			id: 49,
		},
		{
			albedo: 'materials/textures/Paper_004_diffuse.png',
			normal: 'materials/textures/Paper_004_normal.png',
			r: 'materials/textures/Paper_004_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Paper_004.png',
			normalMapStrength: 0.25,
			tiling: -1.0,
			metalness: 0,
			smoothness: 0.62,
			name: 'Paper 004',
			id: 50,
		},
		{
			albedo: 'materials/textures/Paper_005_diffuse.png',
			normal: 'materials/textures/Paper_005_normal.png',
			r: 'materials/textures/Paper_005_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Paper_005.png',
			normalMapStrength: 1.0,
			tiling: 1,
			metalness: 0,
			smoothness: 0.34,
			name: 'Paper 005',
			id: 51,
		},
		{
			albedo: 'materials/textures/Plastic_002_diffuse.png',
			normal: 'materials/textures/Plastic_002_normal.png',
			r: 'materials/textures/Plastic_002_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Plastic_002.png',
			normalMapStrength: 0.2,
			tiling: 1,
			metalness: 0,
			smoothness: 0,
			name: 'Plastic 002',
			id: 52,
		},
		{
			albedo: 'materials/textures/Plastic_003_diffuse.png',
			normal: 'materials/textures/Plastic_003_normal.png',
			r: 'materials/textures/Plastic_003_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Plastic_003.png',
			normalMapStrength: 0.3,
			tiling: 1,
			metalness: 0,
			smoothness: 0,
			name: 'Plastic 003',
			id: 53,
		},
		{
			albedo: 'materials/textures/Plastic_004_diffuse.png',
			normal: 'materials/textures/Plastic_004_normal.png',
			r: 'materials/textures/Plastic_004_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Plastic_004.png',
			normalMapStrength: 1,
			tiling: 1,
			metalness: 0,
			smoothness: 0.2,
			name: 'Plastic 004',
			id: 54,
		},
		{
			albedo: 'materials/textures/Wood_004_diffuse.png',
			normal: 'materials/textures/Wood_004_normal.png',
			r: 'materials/textures/Wood_004_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Wood_004.png',
			normalMapStrength: 1,
			tiling: 1.51,
			metalness: 0,
			smoothness: 0.50,
			name: 'Wood 004',
			id: 55,
		},
		{
			albedo: 'materials/textures/Wood_005_diffuse.png',
			normal: 'materials/textures/Wood_005_normal.png',
			r: 'materials/textures/Wood_005_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Wood_005.png',
			normalMapStrength: 0.95,
			tiling: 0.5,
			metalness: 0,
			smoothness: 0.42,
			name: 'Wood 005',
			id: 56,
		},
		{
			albedo: 'materials/textures/Bark_001_diffuse.png',
			normal: 'materials/textures/Bark_001_normal.png',
			r: 'materials/textures/Bark_001_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Bark_001.png',
			normalMapStrength: 0.1,
			tiling: 1,
			metalness: 0,
			smoothness: 0.6,
			name: 'Bark 001',
			id: 57,
		},
		{
			albedo: 'materials/textures/Blocks_001_diffuse.png',
			normal: 'materials/textures/Blocks_001_normal.png',
			r: 'materials/textures/Blocks_001_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Blocks_001.png',
			normalMapStrength: 1,
			tiling: 1.5,
			metalness: 0,
			smoothness: 0.3,
			name: 'Blocks 001',
			id: 58,
		},
		{
			albedo: 'materials/textures/CeilingTile_001_diffuse.png',
			normal: 'materials/textures/CeilingTile_001_normal.png',
			r: 'materials/textures/CeilingTile_001_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_CeilingTile_001.png',
			normalMapStrength: 0.7,
			tiling: 1,
			metalness: 0.1,
			smoothness: 0.5,
			name: 'Ceiling Tile 001',
			id: 59,
			uOffset: 0.5,
			vOffset: 0.5,
		},
		{
			albedo: 'materials/textures/CeramicTile_001_diffuse.png',
			normal: 'materials/textures/CeramicTile_001_normal.png',
			r: 'materials/textures/CeramicTile_001_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_CeramicTile_001.png',
			normalMapStrength: .08,
			tiling: 1,
			metalness: 0,
			smoothness: 0.6,
			name: 'Ceramic Tile 001',
			id: 60,
		},
		{
			albedo: 'materials/textures/Cracks_001_diffuse.png',
			normal: 'materials/textures/Cracks_001_normal.png',
			r: 'materials/textures/Cracks_001_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Cracks_001.png',
			normalMapStrength: 1,
			tiling: 1,
			metalness: 0,
			smoothness: 0.2,
			name: 'Cracks 001',
			id: 61,
		},
		{
			albedo: 'materials/textures/Panels_001_diffuse.png',
			normal: 'materials/textures/Panels_001_normal.png',
			r: 'materials/textures/Panels_001_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Panels_001.png',
			normalMapStrength: 0.4,
			tiling: 1,
			metalness: 0.7,
			smoothness: 0.25,
			name: 'Panels 001',
			id: 63,
		},
		{
			albedo: 'materials/textures/PanelsWood_001_diffuse.png',
			normal: 'materials/textures/PanelsWood_001_normal.png',
			r: 'materials/textures/PanelsWood_001_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_PanelsWood_001.png',
			normalMapStrength: 0.72,
			tiling: 1,
			metalness: 0,
			smoothness: 0.5,
			name: 'Panels Wood 001',
			id: 64,
		},
		{
			albedo: 'materials/textures/Pavement_001_diffuse.png',
			normal: 'materials/textures/Pavement_001_normal.png',
			r: 'materials/textures/Pavement_001_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Pavement_001.png',
			normalMapStrength: 1,
			tiling: 1,
			metalness: 0,
			smoothness: 0.25,
			uOffset: 0.5,
			vOffset: 0.5,
			name: 'Pavement 001',
			id: 65,
		},
		{
			albedo: 'materials/textures/Stone_002_diffuse.png',
			normal: 'materials/textures/Stone_002_normal.png',
			r: 'materials/textures/Stone_002_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Stone_002.png',
			normalMapStrength: 0.28,
			tiling: -1,
			metalness: 0,
			smoothness: 0.48,
			name: 'Stone 002',
			id: 70,
		},
		{
			albedo: 'materials/textures/Wood_006_diffuse.png',
			normal: 'materials/textures/Wood_006_normal.png',
			r: 'materials/textures/Wood_006_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Wood_006.png',
			normalMapStrength: 1,
			tiling: 1,
			metalness: 0.1,
			smoothness: 0.46,
			name: 'Wood 006',
			id: 73,
		},
		{
			albedo: 'materials/textures/Wood_007_diffuse.png',
			normal: 'materials/textures/Wood_007_normal.png',
			r: 'materials/textures/Wood_007_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Wood_007.png',
			normalMapStrength: 1,
			tiling: 1,
			metalness: 0,
			smoothness: 0.45,
			name: 'Wood 007',
			id: 74,
		},
		{
			albedo: 'materials/textures/geometric_001_diffuse.png',
			normal: 'materials/textures/geometric_001_normal.png',
			r: 'materials/textures/geometric_001_normal.png',
			thumb: 'materials/thumbs/Thb_Mat_Geometric_001.png',
			normalMapStrength: 0.55,
			tiling: 1,
			metalness: 0.05,
			smoothness: 0.45,
			uOffset: 0.5,
			vOffset: 0.5,
			name: 'Geometric 001',
			id: 75,
		},
		{
			albedo: 'materials/textures/geometric_002_diffuse.png',
			normal: 'materials/textures/geometric_002_normal.png',
			r: 'materials/textures/geometric_002_normal.png',
			thumb: 'materials/thumbs/Thb_Mat_Geometric_002.png',
			normalMapStrength: 0.55,
			tiling: 1,
			metalness: 0.05,
			smoothness: 0.45,
			uOffset: 0.5,
			vOffset: 0.5,
			name: 'Geometric 002',
			id: 76,
		},
		{
			albedo: 'materials/textures/CeramicTile_002_diffuse.png',
			normal: 'materials/textures/CeramicTile_002_normal.png',
			r: 'materials/textures/CeramicTile_002_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_CeramicTile_002.png',
			normalMapStrength: 0.92,
			tiling: 1,
			metalness: 0.1,
			smoothness: 0.38,
			name: 'Ceramic Tile 002',
			id: 77,
		},
		{
			albedo: 'materials/textures/CeramicTile_003_diffuse.png',
			normal: 'materials/textures/CeramicTile_003_normal.png',
			r: 'materials/textures/CeramicTile_003_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_CeramicTile_003.png',
			normalMapStrength: 0.92,
			tiling: 1,
			metalness: 0.1,
			smoothness: 0.38,
			name: 'Ceramic Tile 002',
			id: 78,
		},
		{
			albedo: 'materials/textures/Metal_005_diffuse.png',
			normal: 'materials/textures/Metal_005_normal.png',
			r: 'materials/textures/Metal_005_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Metal_005.png',
			normalMapStrength: 0.85,
			tiling: 1,
			metalness: 0.08,
			smoothness: 0.05,
			name: 'Metal 005',
			id: 79,
		},
		{
			albedo: 'materials/textures/Metal_006_diffuse.png',
			normal: 'materials/textures/Metal_006_normal.png',
			r: 'materials/textures/Metal_006_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Metal_006.png',
			normalMapStrength: 0.95,
			tiling: 1,
			metalness: 0.05,
			smoothness: 0.03,
			name: 'Metal 006',
			id: 80,
		},
		{
			albedo: 'materials/textures/Mud_001_diffuse.png',
			normal: 'materials/textures/Mud_001_normal.png',
			r: 'materials/textures/Mud_001_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Mud_001.png',
			normalMapStrength: 0.77,
			tiling: 1,
			metalness: 0.01,
			smoothness: 0.16,
			name: 'Mud 001',
			id: 81,
		},
		{
			albedo: 'materials/textures/Rock_003_diffuse.png',
			normal: 'materials/textures/Rock_003_normal.png',
			r: 'materials/textures/Rock_003_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Rock_003.png',
			normalMapStrength: 0.83,
			tiling: 1,
			metalness: 0.06,
			smoothness: 0.27,
			name: 'Rock 003',
			id: 82,
		},
		{
			albedo: 'materials/textures/Rock_004_color.png',
			normal: 'materials/textures/Rock_004_normal.png',
			r: 'materials/textures/Rock_004_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_Rock_004.png',
			normalMapStrength: 0.83,
			tiling: 1,
			metalness: 0.06,
			smoothness: 0.27,
			name: 'Rock 004',
			id: 83,
		},
		{
			albedo: 'materials/textures/SolarPanel_001_diffuse.png',
			normal: 'materials/textures/SolarPanel_001_normal.png',
			r: 'materials/textures/SolarPanel_001_smoothness.png',
			thumb: 'materials/thumbs/Thb_Mat_SolarPanel_001.png',
			normalMapStrength: 0.11,
			tiling: 1,
			metalness: 0.11,
			smoothness: 0.61,
			name: 'Solar Panel 001',
			id: 84,
		},
	
	
	
	],
	colors: [
		{
			name: 'Color Swatch 1',
			hex: ['#9B9B9B','#C5C5C5' ,'#D8D8D8' ,'#E1E1E1'],
		},
		{
			name: 'Color Swatch 2',
			hex: ['#323031','#3D3B3C' ,'#7F7979' ,'#C1BDB3'],
		},
		{
			name: 'Color Swatch 3',
			hex: ['#000000','#434343' ,'#737373' ,'#B9B9B9'],
		},
		{
			name: 'Color Swatch 4',
			hex: ['#FFD2C7','#92140C' ,'#FF7C5C' ,'#FFFFFF'],
		},
		{
			name: 'Color Swatch 5',
			hex: ['#FF8E72','#FFB9A7' ,'#FDD4C9' ,'#FFEBE6'],
		},
		{
			name: 'Color Swatch 6',
			hex: ['#FF0B00','#FF5600' ,'#FF7E56' ,'#FFA88E'],
		},
		{
			name: 'Color Swatch 7',
			hex: ['#FF2827','#FF4127' ,'#FF5A27' ,'#FF7327'],
		},
		{
			name: 'Color Swatch 8',
			hex: ['#E30303','#FF1C03' ,'#FF3503' ,'#FF4E03'],
		},
		{
			name: 'Color Swatch 9',
			hex: ['#D10F10','#F7A399' ,'#FBC3BC' ,'#FFE3E0'],
		},
		{
			name: 'Color Swatch 10',
			hex: ['#BE0000','#E11900' ,'#FF3200' ,'#FF4B00'],
		},
		{
			name: 'Color Swatch 11',
			hex: ['#8C0000','#AF1900' ,'#D23200' ,'#F54B00'],
		},
		{
			name: 'Color Swatch 12',
			hex: ['#F59CA9','#F6828C' ,'#DF57BC' ,'#A03E99'],
		},
		{
			name: 'Color Swatch 13',
			hex: ['#F759A8','#FAB1D2' ,'#FCD7E6' ,'#FFEDEF'],
		},
		{
			name: 'Color Swatch 14',
			hex: ['#89023E','#CC7178' ,'#FFD9DA' ,'#F3E1DD'],
		},
		{
			name: 'Color Swatch 15',
			hex: ['#6B2D5C','#F0386B' ,'#FF5376' ,'#F8C0C8'],
		},
		{
			name: 'Color Swatch 16',
			hex: ['#8661C1','#A37EE0' ,'#C3A6F3' ,'#E1D1FD'],
		},
		{
			name: 'Color Swatch 17',
			hex: ['#6133F9','#A583FA' ,'#C2A7FA' ,'#E5B5FF'],
		},
		{
			name: 'Color Swatch 18',
			hex: ['#03256C','#2541B2' ,'#1768AC' ,'#06BEE1'],
		},
		{
			name: 'Color Swatch 19',
			hex: ['#8FB4FF','#B2CDFF' ,'#D5E6FF' ,'#F8FFFF'],
		},
		{
			name: 'Color Swatch 20',
			hex: ['#588DF7','#B2DDFB' ,'#D8ECFD' ,'#ECF0FE'],
		},
		{
			name: 'Color Swatch 21',
			hex: ['#0E53C5','#4283EE' ,'#6AA5E2' ,'#A2CCF8'],
		},
		{
			name: 'Color Swatch 22',
			hex: ['#0760CD','#64A1F7' ,'#5190F6' ,'#8599FF'],
		},
		{
			name: 'Color Swatch 23',
			hex: ['#0E7773','#48CFCA' ,'#055E5B' ,'#A0DEDC'],
		},
		{
			name: 'Color Swatch 24',
			hex: ['#59F7D8','#B1FAEF' ,'#D7FCF9' ,'#EDFBFF'],
		},
		{
			name: 'Color Swatch 25',
			hex: ['#A2F9E8','#76C2B3' ,'#3D8778' ,'#C8DED9'],
		},
		{
			name: 'Color Swatch 26',
			hex: ['#72FFDE','#158C70' ,'#DEFCF5' ,'#22C7A0'],
		},
		{
			name: 'Color Swatch 27',
			hex: ['#00FFC3','#69FFC3' ,'#D2FFC3' ,'#FFFFC3'],
		},
		{
			name: 'Color Swatch 28',
			hex: ['#37E287','#5AFB87' ,'#7DFF87' ,'#A0FF87'],
		},
		{
			name: 'Color Swatch 29',
			hex: ['#00FF5A','#85FFAF' ,'#C2FFD7' ,'#EBFFF2'],
		},
		{
			name: 'Color Swatch 30',
			hex: ['#147D1E','#1BA12F' ,'#1FB23A' ,'#16C66E'],
		},
		{
			name: 'Color Swatch 31',
			hex: ['#00FF00','#69FF00' ,'#A0FF5E' ,'#C9FFA3'],
		},
		{
			name: 'Color Swatch 32',
			hex: ['#00B200','#5BF05B' ,'#276E27' ,'#035403'],
		},
		{
			name: 'Color Swatch 33',
			hex: ['#0F730D','#328C0D' ,'#55A50D' ,'#78BE0D'],
		},
		{
			name: 'Color Swatch 34',
			hex: ['#64F759','#B3FAB1' ,'#D7FCD8' ,'#EDFFF3'],
		},
		{
			name: 'Color Swatch 35',
			hex: ['#F7FFF6','#BCEBCB' ,'#87D68D' ,'#93B48B'],
		},
		{
			name: 'Color Swatch 36',
			hex: ['#DDFCAD','#C8E087' ,'#95A472' ,'#82846D'],
		},
		{
			name: 'Color Swatch 37',
			hex: ['#95DD24','#6F9C28' ,'#415226' ,'#C4F07D'],
		},
		{
			name: 'Color Swatch 38',
			hex: ['#526E27','#6F9633' ,'#86B53F' ,'#B8FA55'],
		},
		{
			name: 'Color Swatch 39',
			hex: ['#5F634F','#9BC4CB' ,'#CFEBDF' ,'#E2FADB'],
		},
		{
			name: 'Color Swatch 40',
			hex: ['#FBFF98','#C0C288' ,'#8F9156' ,'#EEF0B1'],
		},
		{
			name: 'Color Swatch 41',
			hex: ['#D3C202','#F6DB02' ,'#FFF402' ,'#FFFF02'],
		},
		{
			name: 'Color Swatch 42',
			hex: ['#FDD132','#FCEA86' ,'#FDF4A9' ,'#F2FCBD'],
		},
		{
			name: 'Color Swatch 43',
			hex: ['#FFBA00','#FFD300' ,'#FFEC00' ,'#FFFF00'],
		},
		{
			name: 'Color Swatch 44',
			hex: ['#FF9C00','#FFB947' ,'#FFC870' ,'#FFE8C2'],
		},
		{
			name: 'Color Swatch 45',
			hex: ['#FF7300','#FF8C00' ,'#FFA500' ,'#FFBE00'],
		},
		{
			name: 'Color Swatch 46',
			hex: ['#EA8C55','#C75146' ,'#AD2E24' ,'#81171B'],
		},
		{
			name: 'Color Swatch 47',
			hex: ['#D75B00','#FA7400' ,'#FF8D00' ,'#FFA600'],
		},
		{
			name: 'Color Swatch 48',
			hex: ['#FF4F00','#FF6800' ,'#FF8100' ,'#FF9A00'],
		},
		{
			name: 'Color Swatch 49',
			hex: ['#F56B30','#F7A87E' ,'#F8C3A0' ,'#FFE7AB'],
		},
		{
			name: 'Color Swatch 50',
			hex: ['#86300B','#A9490B' ,'#CC620B' ,'#EF7B0B'],
		},
		{
			name: 'Color Swatch 51',
			hex: ['#6C4433','#996448' ,'#AF785A' ,'#C9BAAB'],
		},
		{
			name: 'Color Swatch 52',
			hex: ['#501B04','#733404' ,'#964D04' ,'#B96604'],
		},
		{
			name: 'Color Swatch 53',
			hex: ['#381304','#5B2C04' ,'#7E4504' ,'#A15E04'],
		},
		{
			name: 'Color Swatch 54',
			hex: ['#FFFEFF','#FF01FB' ,'#02A9EA' ,'#FAFF00'],
		},
		{
			name: 'Color Swatch 55',
			hex: ['#EF3E36','#F7C59F' ,'#EFEFD0' ,'#004E89'],
		},
		{
			name: 'Color Swatch 56',
			hex: ['#A63446','#FBFEF9' ,'#0C6291' ,'#000004'],
		},
		{
			name: 'Color Swatch 57',
			hex: ['#FF9FB2','#FBDCE2' ,'#0ACDFF' ,'#60AB9A'],
		},
		{
			name: 'Color Swatch 58',
			hex: ['#EF476F','#FFD166' ,'#06D6A0' ,'#118AB2'],
		},
		{
			name: 'Color Swatch 59',
			hex: ['#ECCBD9','#E1EFF6' ,'#97D2FB' ,'#83BCFF'],
		},
		{
			name: 'Color Swatch 60',
			hex: ['#550527','#688E26' ,'#FAA613' ,'#F44708'],
		},
		{
			name: 'Color Swatch 61',
			hex: ['#592941','#498467' ,'#52B788' ,'#B2D3A8'],
		},
		{
			name: 'Color Swatch 62',
			hex: ['#A4036F','#048BA8' ,'#16DB93' ,'#EFEA5A'],
		},
		{
			name: 'Color Swatch 63',
			hex: ['#A80874','#B7FDFE' ,'#5EF38C' ,'#2B9720'],
		},
		{
			name: 'Color Swatch 64',
			hex: ['#533A71','#6184D8' ,'#50C5B7' ,'#9CEC5B'],
		},
		{
			name: 'Color Swatch 65',
			hex: ['#3D348B','#7678ED' ,'#F7B801' ,'#F18701'],
		},
		{
			name: 'Color Swatch 66',
			hex: ['#7776BC','#CDC7E5' ,'#FFFBDB' ,'#FFEC51'],
		},
		{
			name: 'Color Swatch 67',
			hex: ['#555B6E','#89B0AE' ,'#BEE3DB' ,'#FAF9F9'],
		},
		{
			name: 'Color Swatch 68',
			hex: ['#25283D','#8F3985' ,'#A675A1' ,'#CEA2AC'],
		},
		{
			name: 'Color Swatch 69',
			hex: ['#246EB9','#4CB944' ,'#FDFFFC' ,'#F5EE9E'],
		},
		{
			name: 'Color Swatch 70',
			hex: ['#094074','#3C6997' ,'#5ADBFF' ,'#FFDD4A'],
		},
		{
			name: 'Color Swatch 71',
			hex: ['#1C77C3','#39A9DB' ,'#40BCD8' ,'#F39237'],
		},
		{
			name: 'Color Swatch 72',
			hex: ['#337CA0','#3EC300' ,'#FFFC31' ,'#FF1D15'],
		},
		{
			name: 'Color Swatch 73',
			hex: ['#042A2B','#5EB1BF' ,'#CDEDF6' ,'#EF7B45'],
		},
		{
			name: 'Color Swatch 74',
			hex: ['#DDFFF7','#93E1D8' ,'#FFA69E' ,'#AA4465'],
		},
		{
			name: 'Color Swatch 75',
			hex: ['#8CB369','#F4E285' ,'#F4A259' ,'#5B8E7D'],
		},
		{
			name: 'Color Swatch 76',
			hex: ['#F6FF00','#7E2E84' ,'#D14081' ,'#EF798A'],
		},
		{
			name: 'Color Swatch 77',
			hex: ['#FFF402','#6699CC' ,'#FF8C42' ,'#FF3C38'],
		},
		{
			name: 'Color Swatch 78',
			hex: ['#FFF79D','#AC8887' ,'#9F4A54' ,'#241E4E'],
		},
		{
			name: 'Color Swatch 79',
			hex: ['#E9D758','#297373' ,'#FF8552' ,'#E6E6E6'],
		},
		{
			name: 'Color Swatch 80',
			hex: ['#EAC435','#345995' ,'#03CEA4' ,'#FB4D3D'],
		},
		{
			name: 'Color Swatch 81',
			hex: ['#F79256','#FBD1A2' ,'#7DCFB6' ,'#00B2CA'],
		},
		// { name: 'Green', hex: '#99D1AB' },
		// { name: 'Green', hex: '#B1D570' },
		// { name: 'Green', hex: '#23B07F' },
		// { name: 'Green', hex: '#16964A' },
		// { name: 'Green', hex: '#19603C' },
		// { name: 'Green', hex: '#394824' },
		//
		// { name: 'Blue', hex: '#D8F6FF' },
		// { name: 'Blue', hex: '#B3EFFF' },
		// { name: 'Blue', hex: '#66C9D8' },
		// { name: 'Blue', hex: '#66CCED' },
		// { name: 'Blue', hex: '#62C7CC' },
		// { name: 'Blue', hex: '#73CEE9' },
		// { name: 'Blue', hex: '#187183' },
		// { name: 'Blue', hex: '#165999' },
		// { name: 'Blue', hex: '#18484D' },
		//
		// { name: 'Purple', hex: '#F3E4FF' },
		// { name: 'Purple', hex: '#EBC2F9' },
		// { name: 'Purple', hex: '#D1AEE5' },
		// { name: 'Purple', hex: '#A984BF' },
		// { name: 'Purple', hex: '#B27DD2' },
		// { name: 'Purple', hex: '#916AAE' },
		// { name: 'Purple', hex: '#9634AB' },
		// { name: 'Purple', hex: '#7D3994' },
		// { name: 'Purple', hex: '#AC0CE5' },
		//
		// { name: 'Pink', hex: '#FFDAD9' },
		// { name: 'Pink', hex: '#F8B0D0' },
		// { name: 'Pink', hex: '#F1AEC8' },
		// { name: 'Pink', hex: '#EC9FB3' },
		// { name: 'Pink', hex: '#F0758C' },
		// { name: 'Pink', hex: '#E785B6' },
		// { name: 'Pink', hex: '#EB5FAC' },
		// { name: 'Pink', hex: '#DB798B' },
		// { name: 'Pink', hex: '#EF387D' },
		//
		// { name: 'B&W', hex: '#FFFFFF' },
		// { name: 'B&W', hex: '#DFDFDF' },
		// { name: 'B&W', hex: '#BCBCBC' },
		// { name: 'B&W', hex: '#A0A0A0' },
		// { name: 'B&W', hex: '#808080' },
		// { name: 'B&W', hex: '#606060' },
		// { name: 'B&W', hex: '#404040' },
		// { name: 'B&W', hex: '#202020' },
		// { name: 'B&W', hex: '#000000' },
		//
		// { name: 'Brown', hex: '#DFD6BF' },
		// { name: 'Brown', hex: '#AA9469' },
		// { name: 'Brown', hex: '#D3C7A8' },
		// { name: 'Brown', hex: '#816748' },
		// { name: 'Brown', hex: '#855236' },
		// { name: 'Brown', hex: '#9F8F5E' },
		// { name: 'Brown', hex: '#A1733E' },
		// { name: 'Brown', hex: '#3E2C1C' },
		//
		// { name: 'Skin Tones', hex: '#332317' },
		// { name: 'Skin Tones', hex: '#623D1D' },
		// { name: 'Skin Tones', hex: '#B0684C' },
		// { name: 'Skin Tones', hex: '#543622' },
		// { name: 'Skin Tones', hex: '#B88859' },
		// { name: 'Skin Tones', hex: '#CF9C7C' },
		// { name: 'Skin Tones', hex: '#DCB079' },
		// { name: 'Skin Tones', hex: '#F7E1A9' },
		// { name: 'Skin Tones', hex: '#F7DCC3' },
		//
		// { name: 'Metals', hex: '#F6F6F6' },
		// { name: 'Metals', hex: '#999997' },
		// { name: 'Metals', hex: '#D0CFD2' },
		// { name: 'Metals', hex: '#979497' },
		// { name: 'Metals', hex: '#9C6C52' },
		// { name: 'Metals', hex: '#AAC6C8' },
		// { name: 'Metals', hex: '#D5CB9B' },
		// { name: 'Metals', hex: '#444442' },
		// { name: 'Metals', hex: '#38221B' },
		//
		// { name: 'Earth Stones', hex: '#382D24' },
		// { name: 'Earth Stones', hex: '#695B4F' },
		// { name: 'Earth Stones', hex: '#492B1B' },
		// { name: 'Earth Stones', hex: '#6C4C20' },
		// { name: 'Earth Stones', hex: '#6C3410' },
		// { name: 'Earth Stones', hex: '#C47100' },
		// { name: 'Earth Stones', hex: '#363E20' },
		// { name: 'Earth Stones', hex: '#668741' },
		// { name: 'Earth Stones', hex: '#3E4951' },
		//
		// { name: 'GrassLand', hex: '#B1D8A6' },
		// { name: 'GrassLand', hex: '#C5B183' },
		// { name: 'GrassLand', hex: '#618740' },
		// { name: 'GrassLand', hex: '#A1B72D' },
		// { name: 'GrassLand', hex: '#807F61' },
		// { name: 'GrassLand', hex: '#84A44D' },
		// { name: 'GrassLand', hex: '#8A9360' },
		// { name: 'GrassLand', hex: '#4D503D' },
		// { name: 'GrassLand', hex: '#82A2CC' },
		//
		// { name: 'Forest', hex: '#1C2B0C' },
		// { name: 'Forest', hex: '#2A3C63' },
		// { name: 'Forest', hex: '#394823' },
		// { name: 'Forest', hex: '#35601E' },
		// { name: 'Forest', hex: '#005953' },
		// { name: 'Forest', hex: '#5C612C' },
		// { name: 'Forest', hex: '#33651F' },
		// { name: 'Forest', hex: '#BFF147' },
		// { name: 'Forest', hex: '#CAAB72' },
		//
		// { name: 'Sun Set', hex: '#FFF6EA' },
		// { name: 'Sun Set', hex: '#FFDEBB' },
		// { name: 'Sun Set', hex: '#F5F38A' },
		// { name: 'Sun Set', hex: '#FE8B36' },
		// { name: 'Sun Set', hex: '#FE554D' },
		// { name: 'Sun Set', hex: '#E93F2E' },
		// { name: 'Sun Set', hex: '#80414B' },
		// { name: 'Sun Set', hex: '#4A4566' },
		// { name: 'Sun Set', hex: '#052D3C' },
		//
		// { name: 'Montana', hex: '#BF946B' },
		// { name: 'Montana', hex: '#E09F4A' },
		// { name: 'Montana', hex: '#E8BD2B' },
		// { name: 'Montana', hex: '#516716' },
		// { name: 'Montana', hex: '#353E16' },
		// { name: 'Montana', hex: '#00A6BB' },
		// { name: 'Montana', hex: '#A1C8C4' },
		// { name: 'Montana', hex: '#4A5777' },
		// { name: 'Montana', hex: '#EB725D' },
		//
		// { name: 'Appalachian', hex: '#D9D5AF' },
		// { name: 'Appalachian', hex: '#BDB69E' },
		// { name: 'Appalachian', hex: '#94C25C' },
		// { name: 'Appalachian', hex: '#68974B' },
		// { name: 'Appalachian', hex: '#213325' },
		// { name: 'Appalachian', hex: '#33542B' },
		// { name: 'Appalachian', hex: '#6BBFE4' },
		// { name: 'Appalachian', hex: '#3871BD' },
		//
		// { name: 'Pond Water', hex: '#E7E7E9' },
		// { name: 'Pond Water', hex: '#B6EEF6' },
		// { name: 'Pond Water', hex: '#38A48D' },
		// { name: 'Pond Water', hex: '#4DB697' },
		// { name: 'Pond Water', hex: '#8E9E37' },
		// { name: 'Pond Water', hex: '#4C9755' },
		// { name: 'Pond Water', hex: '#1F5650' },
		// { name: 'Pond Water', hex: '#6784BA' },
		// { name: 'Pond Water', hex: '#4B5E7C' },
		//
		// { name: 'Crazy', hex: '#FF34EC' },
		// { name: 'Crazy', hex: '#B234FF' },
		// { name: 'Crazy', hex: '#7E99FF' },
		// { name: 'Crazy', hex: '#5AC9FF' },
		// { name: 'Crazy', hex: '#44FFED' },
		// { name: 'Crazy', hex: '#74FFC4' },
		// { name: 'Crazy', hex: '#FFC745' },
		// { name: 'Crazy', hex: '#FF709C' },
		//
		// { name: 'Ice', hex: '#DAE2DE' },
		// { name: 'Ice', hex: '#D6EAEB' },
		// { name: 'Ice', hex: '#CAE6EF' },
		// { name: 'Ice', hex: '#CBD8D6' },
		// { name: 'Ice', hex: '#B1DAE5' },
		// { name: 'Ice', hex: '#BFCFD1' },
		// { name: 'Ice', hex: '#A8D0D7' },
		// { name: 'Ice', hex: '#B1C8CD' },
		// { name: 'Ice', hex: '#8ECDDF' },
		//
		// { name: 'Volcano', hex: '#E3E3E3' },
		// { name: 'Volcano', hex: '#97999E' },
		// { name: 'Volcano', hex: '#5C5C5C' },
		// { name: 'Volcano', hex: '#8E8E8E' },
		// { name: 'Volcano', hex: '#B6A494' },
		// { name: 'Volcano', hex: '#452228' },
		// { name: 'Volcano', hex: '#E63905' },
		// { name: 'Volcano', hex: '#F9BB0C' },
	],
	accents: [{
		thumb: 'accents/thumbnails/Icon_Accent_001.png',
		name: 'Circle 001',
		url: 'accents/meshes/Accent_001.babylon',
		id: 1,
	},
		{
			thumb: 'accents/thumbnails/Icon_Accent_008.png',
			name: 'Corners Round 01',
			url: 'accents/meshes/Accent_008.babylon',
			id: 8,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_007.png',
			name: 'Corners Square 01',
			url: 'accents/meshes/Accent_007.babylon',
			id: 7,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_009.png',
			name: 'Corners Triangle 01',
			url: 'accents/meshes/Accent_009.babylon',
			id: 9,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_002.png',
			name: 'Star 001',
			url: 'accents/meshes/Accent_002.babylon',
			id: 2,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_003.png',
			name: 'StripesD 01',
			url: 'accents/meshes/Accent_003.babylon',
			id: 3,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_004.png',
			name: 'StripesD 02',
			url: 'accents/meshes/Accent_004.babylon',
			id: 4,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_005.png',
			name: 'StripesH 01',
			url: 'accents/meshes/Accent_005.babylon',
			id: 5,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_006.png',
			name: 'StripesV 01',
			url: 'accents/meshes/Accent_006.babylon',
			id: 6,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_010.png',
			name: 'Circle 002',
			url: 'accents/meshes/Accent_010.babylon',
			id: 10,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_011.png',
			name: 'Corners Round 02',
			url: 'accents/meshes/Accent_011.babylon',
			id: 11,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_012.png',
			name: 'Corners Square 02',
			url: 'accents/meshes/Accent_012.babylon',
			id: 12,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_013.png',
			name: 'Corners Triangle 02',
			url: 'accents/meshes/Accent_013.babylon',
			id: 13,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_014.png',
			name: 'Star 002',
			url: 'accents/meshes/Accent_014.babylon',
			id: 14,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_015.png',
			name: 'Star 003',
			url: 'accents/meshes/Accent_015.babylon',
			id: 15,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_016.png',
			name: 'Star 004',
			url: 'accents/meshes/Accent_016.babylon',
			id: 16,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_017.png',
			name: 'Star 005',
			url: 'accents/meshes/Accent_017.babylon',
			id: 17,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_018.png',
			name: 'Star 006',
			url: 'accents/meshes/Accent_018.babylon',
			id: 18,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_019.png',
			name: 'Star 007',
			url: 'accents/meshes/Accent_019.babylon',
			id: 19,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_020.png',
			name: 'Star 008',
			url: 'accents/meshes/Accent_020.babylon',
			id: 20,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_021.png',
			name: 'Star 009',
			url: 'accents/meshes/Accent_021.babylon',
			id: 21,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_022.png',
			name: 'StripesD 03',
			url: 'accents/meshes/Accent_022.babylon',
			id: 22,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_023.png',
			name: 'StripesD 04',
			url: 'accents/meshes/Accent_023.babylon',
			id: 23,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_024.png',
			name: 'StripesH 02',
			url: 'accents/meshes/Accent_024.babylon',
			id: 24,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_025.png',
			name: 'StripesH 03',
			url: 'accents/meshes/Accent_025.babylon',
			id: 25,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_026.png',
			name: 'StripesV 02',
			url: 'accents/meshes/Accent_026.babylon',
			id: 26,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_027.png',
			name: 'StripesV 03',
			url: 'accents/meshes/Accent_027.babylon',
			id: 27,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_028.png',
			name: 'Dots 01',
			url: 'accents/meshes/Accent_028.babylon',
			id: 28,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_029.png',
			name: 'Dots 02',
			url: 'accents/meshes/Accent_029.babylon',
			id: 29,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_030.png',
			name: 'Corners Triangle 03',
			url: 'accents/meshes/Accent_030.babylon',
			id: 30,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_031.png',
			name: 'Dots 03',
			url: 'accents/meshes/Accent_031.babylon',
			id: 31,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_032.png',
			name: 'Floral Stem Border 003',
			url: 'accents/meshes/Accent_032.babylon',
			id: 32,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_033.png',
			name: 'Floral Stem Border 004',
			url: 'accents/meshes/Accent_033.babylon',
			id: 33,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_034.png',
			name: 'Floral Stem Border 001',
			url: 'accents/meshes/Accent_034.babylon',
			id: 34,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_035.png',
			name: 'Floral Stem Border 002',
			url: 'accents/meshes/Accent_035.babylon',
			id: 35,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_036.png',
			name: 'Floral Stem 001',
			url: 'accents/meshes/Accent_036.babylon',
			id: 36,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_037.png',
			name: 'Floral Stem 002',
			url: 'accents/meshes/Accent_037.babylon',
			id: 37,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_038.png',
			name: 'Floral Stem 003',
			url: 'accents/meshes/Accent_038.babylon',
			id: 38,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_039.png',
			name: 'Floral Stem 004',
			url: 'accents/meshes/Accent_039.babylon',
			id: 39,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_040.png',
			name: 'Floral Stem 005',
			url: 'accents/meshes/Accent_040.babylon',
			id: 40,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_041.png',
			name: 'Floral Stem 006',
			url: 'accents/meshes/Accent_041.babylon',
			id: 41,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_042.png',
			name: 'Floral Stem 007',
			url: 'accents/meshes/Accent_042.babylon',
			id: 42,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_043.png',
			name: 'Floral Stem 008',
			url: 'accents/meshes/Accent_043.babylon',
			id: 43,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_044.png',
			name: 'Floral Stem 009',
			url: 'accents/meshes/Accent_044.babylon',
			id: 44,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_045.png',
			name: 'Bird 001',
			url: 'accents/meshes/Accent_045.babylon',
			id: 45,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_046.png',
			name: 'Bird 002',
			url: 'accents/meshes/Accent_046.babylon',
			id: 46,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_047.png',
			name: 'Bird 003',
			url: 'accents/meshes/Accent_047.babylon',
			id: 47,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_048.png',
			name: 'Bird 004',
			url: 'accents/meshes/Accent_048.babylon',
			id: 48,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_049.png',
			name: 'Bird 005',
			url: 'accents/meshes/Accent_049.babylon',
			id: 49,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_050.png',
			name: 'Bird 006',
			url: 'accents/meshes/Accent_050.babylon',
			id: 50,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_051.png',
			name: 'Butterfly 001',
			url: 'accents/meshes/Accent_051.babylon',
			id: 51,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_052.png',
			name: 'Cat 001',
			url: 'accents/meshes/Accent_052.babylon',
			id: 52,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_053.png',
			name: 'Dog 001',
			url: 'accents/meshes/Accent_053.babylon',
			id: 53,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_054.png',
			name: 'Donkey 001',
			url: 'accents/meshes/Accent_054.babylon',
			id: 54,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_055.png',
			name: 'Elephant 001',
			url: 'accents/meshes/Accent_055.babylon',
			id: 55,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_056.png',
			name: 'Fish 001',
			url: 'accents/meshes/Accent_056.babylon',
			id: 56,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_057.png',
			name: 'Fox 001',
			url: 'accents/meshes/Accent_057.babylon',
			id: 57,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_058.png',
			name: 'Frog 001',
			url: 'accents/meshes/Accent_058.babylon',
			id: 58,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_059.png',
			name: 'Hedgehog 001',
			url: 'accents/meshes/Accent_059.babylon',
			id: 59,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_060.png',
			name: 'Hen 001',
			url: 'accents/meshes/Accent_060.babylon',
			id: 60,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_061.png',
			name: 'Ladybug 001',
			url: 'accents/meshes/Accent_061.babylon',
			id: 61,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_062.png',
			name: 'Owl 001',
			url: 'accents/meshes/Accent_062.babylon',
			id: 62,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_063.png',
			name: 'Raccoon 001',
			url: 'accents/meshes/Accent_063.babylon',
			id: 63,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_064.png',
			name: 'Turtle 001',
			url: 'accents/meshes/Accent_064.babylon',
			id: 64,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_065.png',
			name: 'Radial 001',
			url: 'accents/meshes/Accent_065.babylon',
			id: 65,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_066.png',
			name: 'Radial 002',
			url: 'accents/meshes/Accent_066.babylon',
			id: 66,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_067.png',
			name: 'Bear 001',
			url: 'accents/meshes/Accent_067.babylon',
			id: 67,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_068.png',
			name: 'Bee 001',
			url: 'accents/meshes/Accent_068.babylon',
			id: 68,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_069.png',
			name: 'Camel 001',
			url: 'accents/meshes/Accent_069.babylon',
			id: 69,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_070.png',
			name: 'Dolphin 001',
			url: 'accents/meshes/Accent_070.babylon',
			id: 70,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_071.png',
			name: 'Horse 001',
			url: 'accents/meshes/Accent_071.babylon',
			id: 71,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_072.png',
			name: 'Monkey 001',
			url: 'accents/meshes/Accent_072.babylon',
			id: 72,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_073.png',
			name: 'Penguin 001',
			url: 'accents/meshes/Accent_073.babylon',
			id: 73,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_074.png',
			name: 'Pig 001',
			url: 'accents/meshes/Accent_074.babylon',
			id: 74,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_075.png',
			name: 'Rabbit 001',
			url: 'accents/meshes/Accent_075.babylon',
			id: 75,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_076.png',
			name: 'Rabbit 002',
			url: 'accents/meshes/Accent_076.babylon',
			id: 76,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_077.png',
			name: 'Seahorse 001',
			url: 'accents/meshes/Accent_077.babylon',
			id: 77,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_078.png',
			name: 'Squirrel 001',
			url: 'accents/meshes/Accent_078.babylon',
			id: 78,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_079.png',
			name: 'Brontosaurus 001',
			url: 'accents/meshes/Accent_079.babylon',
			id: 79,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_080.png',
			name: 'Stegosaurus 001',
			url: 'accents/meshes/Accent_080.babylon',
			id: 80,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_081.png',
			name: 'T-Rex 001',
			url: 'accents/meshes/Accent_081.babylon',
			id: 81,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_082.png',
			name: 'Triceratops 001',
			url: 'accents/meshes/Accent_082.babylon',
			id: 82,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_083.png',
			name: 'Clover 001',
			url: 'accents/meshes/Accent_083.babylon',
			id: 83,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_084.png',
			name: 'Mushroom 001',
			url: 'accents/meshes/Accent_084.babylon',
			id: 84,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_085.png',
			name: 'Mushroom 002',
			url: 'accents/meshes/Accent_085.babylon',
			id: 85,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_086.png',
			name: 'Carrot 001',
			url: 'accents/meshes/Accent_086.babylon',
			id: 86,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_087.png',
			name: 'Watermelon 001',
			url: 'accents/meshes/Accent_087.babylon',
			id: 87,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_088.png',
			name: 'Apple 001',
			url: 'accents/meshes/Accent_088.babylon',
			id: 88,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_089.png',
			name: 'Cherries 001',
			url: 'accents/meshes/Accent_089.babylon',
			id: 89,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_090.png',
			name: 'Banana 001',
			url: 'accents/meshes/Accent_090.babylon',
			id: 90,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_091.png',
			name: 'Pineapple 001',
			url: 'accents/meshes/Accent_091.babylon',
			id: 91,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_092.png',
			name: 'Lemon 001',
			url: 'accents/meshes/Accent_092.babylon',
			id: 92,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_093.png',
			name: 'Strawberry 001',
			url: 'accents/meshes/Accent_093.babylon',
			id: 93,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_094.png',
			name: 'Grapes 001',
			url: 'accents/meshes/Accent_094.babylon',
			id: 94,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_095.png',
			name: 'Sun 001',
			url: 'accents/meshes/Accent_095.babylon',
			id: 95,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_096.png',
			name: 'Sun 002',
			url: 'accents/meshes/Accent_096.babylon',
			id: 96,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_097.png',
			name: 'Snowflake 001',
			url: 'accents/meshes/Accent_097.babylon',
			id: 97,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_098.png',
			name: 'Snowflake 002',
			url: 'accents/meshes/Accent_098.babylon',
			id: 98,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_099.png',
			name: 'Flower 001',
			url: 'accents/meshes/Accent_099.babylon',
			id: 99,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_100.png',
			name: 'Flower 002',
			url: 'accents/meshes/Accent_100.babylon',
			id: 100,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_101.png',
			name: 'Flower 003',
			url: 'accents/meshes/Accent_101.babylon',
			id: 101,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_102.png',
			name: 'Flower 004',
			url: 'accents/meshes/Accent_102.babylon',
			id: 102,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_103.png',
			name: 'Flower 005',
			url: 'accents/meshes/Accent_103.babylon',
			id: 103,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_104.png',
			name: 'Flower 006',
			url: 'accents/meshes/Accent_104.babylon',
			id: 104,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_105.png',
			name: 'Cheeseburger',
			url: 'accents/meshes/Accent_105.babylon',
			id: 105,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_106.png',
			name: 'Ice Cream Cone',
			url: 'accents/meshes/Accent_106.babylon',
			id: 106,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_107.png',
			name: 'Hot Dog',
			url: 'accents/meshes/Accent_107.babylon',
			id: 107,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_108.png',
			name: 'Pizza',
			url: 'accents/meshes/Accent_108.babylon',
			id: 108,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_109.png',
			name: 'Pancakes',
			url: 'accents/meshes/Accent_109.babylon',
			id: 109,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_110.png',
			name: 'Taco',
			url: 'accents/meshes/Accent_110.babylon',
			id: 110,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_111.png',
			name: 'Circle 003',
			url: 'accents/meshes/Accent_111.babylon',
			id: 111,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_112.png',
			name: 'Circle 003 Var 001',
			url: 'accents/meshes/Accent_112.babylon',
			id: 112,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_113.png',
			name: 'Circle 003 Var 002',
			url: 'accents/meshes/Accent_113.babylon',
			id: 113,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_114.png',
			name: 'Circle 003 Var 003',
			url: 'accents/meshes/Accent_114.babylon',
			id: 114,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_115.png',
			name: 'Circle 003 Var 004',
			url: 'accents/meshes/Accent_115.babylon',
			id: 115,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_116.png',
			name: 'Asterisk 001',
			url: 'accents/meshes/Accent_116.babylon',
			id: 116,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_117.png',
			name: 'Column 001',
			url: 'accents/meshes/Accent_117.babylon',
			id: 117,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_118.png',
			name: 'Cross 001',
			url: 'accents/meshes/Accent_118.babylon',
			id: 118,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_119.png',
			name: 'Cross 002',
			url: 'accents/meshes/Accent_119.babylon',
			id: 119,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_120.png',
			name: 'Diamond 001',
			url: 'accents/meshes/Accent_120.babylon',
			id: 120,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_121.png',
			name: 'Diamond 001 Var 001',
			url: 'accents/meshes/Accent_121.babylon',
			id: 121,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_122.png',
			name: 'Diamond 001 Var 002',
			url: 'accents/meshes/Accent_122.babylon',
			id: 122,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_123.png',
			name: 'Diamond 007',
			url: 'accents/meshes/Accent_123.babylon',
			id: 123,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_124.png',
			name: 'Heart 001',
			url: 'accents/meshes/Accent_124.babylon',
			id: 124,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_125.png',
			name: 'Hex 001',
			url: 'accents/meshes/Accent_125.babylon',
			id: 125,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_126.png',
			name: 'Hex 001 Var 001',
			url: 'accents/meshes/Accent_126.babylon',
			id: 126,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_127.png',
			name: 'Hex 001 Var 002',
			url: 'accents/meshes/Accent_127.babylon',
			id: 127,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_128.png',
			name: 'Hex 001 Var 003',
			url: 'accents/meshes/Accent_128.babylon',
			id: 128,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_129.png',
			name: 'Hex 001 Var 004',
			url: 'accents/meshes/Accent_129.babylon',
			id: 129,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_130.png',
			name: 'Hex 001 Var 006',
			url: 'accents/meshes/Accent_130.babylon',
			id: 130,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_131.png',
			name: 'Hex 001 Var 008',
			url: 'accents/meshes/Accent_131.babylon',
			id: 131,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_132.png',
			name: 'Hex 001 Var 010',
			url: 'accents/meshes/Accent_132.babylon',
			id: 132,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_133.png',
			name: 'Hex 001 Var 011',
			url: 'accents/meshes/Accent_133.babylon',
			id: 133,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_134.png',
			name: 'Hex 001 Var 015',
			url: 'accents/meshes/Accent_134.babylon',
			id: 134,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_135.png',
			name: 'Hex 001 Var 016',
			url: 'accents/meshes/Accent_135.babylon',
			id: 135,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_136.png',
			name: 'Hex 001 Var 017',
			url: 'accents/meshes/Accent_136.babylon',
			id: 136,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_137.png',
			name: 'Hex 001 Var 018',
			url: 'accents/meshes/Accent_137.babylon',
			id: 137,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_138.png',
			name: 'Hex 001 Var 019',
			url: 'accents/meshes/Accent_138.babylon',
			id: 138,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_139.png',
			name: 'Hex 001 Var 020',
			url: 'accents/meshes/Accent_139.babylon',
			id: 139,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_140.png',
			name: 'Hex 001 Var 021',
			url: 'accents/meshes/Accent_140.babylon',
			id: 140,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_141.png',
			name: 'Hex 003',
			url: 'accents/meshes/Accent_141.babylon',
			id: 141,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_142.png',
			name: 'Hex 003 Var 001',
			url: 'accents/meshes/Accent_142.babylon',
			id: 142,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_143.png',
			name: 'Hex 003 Var 002',
			url: 'accents/meshes/Accent_143.babylon',
			id: 143,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_144.png',
			name: 'Hex 003 Var 003',
			url: 'accents/meshes/Accent_144.babylon',
			id: 144,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_145.png',
			name: 'Hex 003 Var 004',
			url: 'accents/meshes/Accent_145.babylon',
			id: 145,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_146.png',
			name: 'Hex 003 Var 005',
			url: 'accents/meshes/Accent_146.babylon',
			id: 146,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_147.png',
			name: 'Lightning 001',
			url: 'accents/meshes/Accent_147.babylon',
			id: 147,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_148.png',
			name: 'Moon 001',
			url: 'accents/meshes/Accent_148.babylon',
			id: 148,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_149.png',
			name: 'Octagon 001',
			url: 'accents/meshes/Accent_149.babylon',
			id: 149,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_150.png',
			name: 'Octagon 001 Var 001',
			url: 'accents/meshes/Accent_150.babylon',
			id: 150,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_151.png',
			name: 'Octagon 001 Var 002',
			url: 'accents/meshes/Accent_151.babylon',
			id: 151,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_152.png',
			name: 'Octagon 001 Var 003',
			url: 'accents/meshes/Accent_152.babylon',
			id: 152,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_153.png',
			name: 'Parallelogram 001',
			url: 'accents/meshes/Accent_153.babylon',
			id: 153,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_154.png',
			name: 'Parallelogram 001 Var 001',
			url: 'accents/meshes/Accent_154.babylon',
			id: 154,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_155.png',
			name: 'Parallelogram 001 Var 002',
			url: 'accents/meshes/Accent_155.babylon',
			id: 155,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_156.png',
			name: 'Parallelogram 001 Var 003',
			url: 'accents/meshes/Accent_156.babylon',
			id: 156,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_157.png',
			name: 'Parallelogram 001 Var 004',
			url: 'accents/meshes/Accent_157.babylon',
			id: 157,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_158.png',
			name: 'Parallelogram 001 Var 005',
			url: 'accents/meshes/Accent_158.babylon',
			id: 158,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_159.png',
			name: 'Parallelogram 002',
			url: 'accents/meshes/Accent_159.babylon',
			id: 159,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_160.png',
			name: 'Parallelogram 002 Var 001',
			url: 'accents/meshes/Accent_160.babylon',
			id: 160,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_161.png',
			name: 'Parallelogram 002 Var 002',
			url: 'accents/meshes/Accent_161.babylon',
			id: 161,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_162.png',
			name: 'Parallelogram 002 Var 003',
			url: 'accents/meshes/Accent_162.babylon',
			id: 162,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_163.png',
			name: 'Parallelogram 002 Var 004',
			url: 'accents/meshes/Accent_163.babylon',
			id: 163,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_164.png',
			name: 'Parallelogram 002 Var 005',
			url: 'accents/meshes/Accent_164.babylon',
			id: 164,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_165.png',
			name: 'Petals 001',
			url: 'accents/meshes/Accent_165.babylon',
			id: 165,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_166.png',
			name: 'Petals 002',
			url: 'accents/meshes/Accent_166.babylon',
			id: 166,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_167.png',
			name: 'Petals 003',
			url: 'accents/meshes/Accent_167.babylon',
			id: 167,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_168.png',
			name: 'ProSphere 001',
			url: 'accents/meshes/Accent_168.babylon',
			id: 168,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_169.png',
			name: 'Square 001',
			url: 'accents/meshes/Accent_169.babylon',
			id: 169,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_170.png',
			name: 'Square 001 Var 001',
			url: 'accents/meshes/Accent_170.babylon',
			id: 170,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_171.png',
			name: 'Square 001 Var 002',
			url: 'accents/meshes/Accent_171.babylon',
			id: 171,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_172.png',
			name: 'Square 001 Var 004',
			url: 'accents/meshes/Accent_172.babylon',
			id: 172,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_173.png',
			name: 'Square 001 Var 005',
			url: 'accents/meshes/Accent_173.babylon',
			id: 173,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_174.png',
			name: 'Square 004',
			url: 'accents/meshes/Accent_174.babylon',
			id: 174,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_175.png',
			name: 'Square 004 Var 001',
			url: 'accents/meshes/Accent_175.babylon',
			id: 175,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_176.png',
			name: 'Square 004 Var 002',
			url: 'accents/meshes/Accent_176.babylon',
			id: 176,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_177.png',
			name: 'Square 004 Var 004',
			url: 'accents/meshes/Accent_177.babylon',
			id: 177,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_178.png',
			name: 'Square 004 Var 005',
			url: 'accents/meshes/Accent_178.babylon',
			id: 178,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_179.png',
			name: 'Star 010',
			url: 'accents/meshes/Accent_179.babylon',
			id: 179,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_180.png',
			name: 'Star 011',
			url: 'accents/meshes/Accent_180.babylon',
			id: 180,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_181.png',
			name: 'Star 012',
			url: 'accents/meshes/Accent_181.babylon',
			id: 181,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_182.png',
			name: 'Suit Club 001',
			url: 'accents/meshes/Accent_182.babylon',
			id: 182,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_183.png',
			name: 'Suit Diamond 001',
			url: 'accents/meshes/Accent_183.babylon',
			id: 183,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_184.png',
			name: 'Suit Heart 001',
			url: 'accents/meshes/Accent_184.babylon',
			id: 184,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_185.png',
			name: 'Suit Spade 001',
			url: 'accents/meshes/Accent_185.babylon',
			id: 185,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_186.png',
			name: 'Sun 003',
			url: 'accents/meshes/Accent_186.babylon',
			id: 186,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_187.png',
			name: 'Y 001',
			url: 'accents/meshes/Accent_187.babylon',
			id: 187,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_188.png',
			name: 'Y 001 Var 001',
			url: 'accents/meshes/Accent_188.babylon',
			id: 188,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_189.png',
			name: 'Y 001 Var 002',
			url: 'accents/meshes/Accent_189.babylon',
			id: 189,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_190.png',
			name: 'Y 001 Var 003',
			url: 'accents/meshes/Accent_190.babylon',
			id: 190,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_191.png',
			name: 'Y 001 Var 004',
			url: 'accents/meshes/Accent_191.babylon',
			id: 191,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_192.png',
			name: 'Alabama',
			url: 'accents/meshes/Accent_192.babylon',
			id: 192,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_193.png',
			name: 'Alaska',
			url: 'accents/meshes/Accent_193.babylon',
			id: 193,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_194.png',
			name: 'Arizona',
			url: 'accents/meshes/Accent_194.babylon',
			id: 194,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_195.png',
			name: 'Arkansas',
			url: 'accents/meshes/Accent_195.babylon',
			id: 195,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_196.png',
			name: 'California',
			url: 'accents/meshes/Accent_196.babylon',
			id: 196,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_197.png',
			name: 'Colorado',
			url: 'accents/meshes/Accent_197.babylon',
			id: 197,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_198.png',
			name: 'Connecticut',
			url: 'accents/meshes/Accent_198.babylon',
			id: 198,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_199.png',
			name: 'Delaware',
			url: 'accents/meshes/Accent_199.babylon',
			id: 199,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_200.png',
			name: 'Florida',
			url: 'accents/meshes/Accent_200.babylon',
			id: 200,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_201.png',
			name: 'Georgia',
			url: 'accents/meshes/Accent_201.babylon',
			id: 201,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_202.png',
			name: 'Hawaii',
			url: 'accents/meshes/Accent_202.babylon',
			id: 202,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_203.png',
			name: 'Idaho',
			url: 'accents/meshes/Accent_203.babylon',
			id: 203,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_204.png',
			name: 'Illinois',
			url: 'accents/meshes/Accent_204.babylon',
			id: 204,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_205.png',
			name: 'Indiana',
			url: 'accents/meshes/Accent_205.babylon',
			id: 205,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_206.png',
			name: 'Iowa',
			url: 'accents/meshes/Accent_206.babylon',
			id: 206,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_207.png',
			name: 'Kansas',
			url: 'accents/meshes/Accent_207.babylon',
			id: 207,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_208.png',
			name: 'Kentucky',
			url: 'accents/meshes/Accent_208.babylon',
			id: 208,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_209.png',
			name: 'Louisiana',
			url: 'accents/meshes/Accent_209.babylon',
			id: 209,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_210.png',
			name: 'Maine',
			url: 'accents/meshes/Accent_210.babylon',
			id: 210,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_211.png',
			name: 'Maryland',
			url: 'accents/meshes/Accent_211.babylon',
			id: 211,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_212.png',
			name: 'Massachusetts',
			url: 'accents/meshes/Accent_212.babylon',
			id: 212,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_213.png',
			name: 'Michigan',
			url: 'accents/meshes/Accent_213.babylon',
			id: 213,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_214.png',
			name: 'Minnesota',
			url: 'accents/meshes/Accent_214.babylon',
			id: 214,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_215.png',
			name: 'Mississippi',
			url: 'accents/meshes/Accent_215.babylon',
			id: 215,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_216.png',
			name: 'Missouri',
			url: 'accents/meshes/Accent_216.babylon',
			id: 216,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_217.png',
			name: 'Montana',
			url: 'accents/meshes/Accent_217.babylon',
			id: 217,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_218.png',
			name: 'Nebraska',
			url: 'accents/meshes/Accent_218.babylon',
			id: 218,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_219.png',
			name: 'Nevada',
			url: 'accents/meshes/Accent_219.babylon',
			id: 219,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_220.png',
			name: 'New Hampshire',
			url: 'accents/meshes/Accent_220.babylon',
			id: 220,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_221.png',
			name: 'New Jersey',
			url: 'accents/meshes/Accent_221.babylon',
			id: 221,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_222.png',
			name: 'New Mexico',
			url: 'accents/meshes/Accent_222.babylon',
			id: 222,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_223.png',
			name: 'New York',
			url: 'accents/meshes/Accent_223.babylon',
			id: 223,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_224.png',
			name: 'North Carolina',
			url: 'accents/meshes/Accent_224.babylon',
			id: 224,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_225.png',
			name: 'North Dakota',
			url: 'accents/meshes/Accent_225.babylon',
			id: 225,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_226.png',
			name: 'Ohio',
			url: 'accents/meshes/Accent_226.babylon',
			id: 226,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_227.png',
			name: 'Oklahoma',
			url: 'accents/meshes/Accent_227.babylon',
			id: 227,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_228.png',
			name: 'Oregon',
			url: 'accents/meshes/Accent_228.babylon',
			id: 228,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_229.png',
			name: 'Pennsylvania',
			url: 'accents/meshes/Accent_229.babylon',
			id: 229,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_230.png',
			name: 'Rhode Island',
			url: 'accents/meshes/Accent_230.babylon',
			id: 230,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_231.png',
			name: 'South Carolina',
			url: 'accents/meshes/Accent_231.babylon',
			id: 231,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_232.png',
			name: 'South Dakota',
			url: 'accents/meshes/Accent_232.babylon',
			id: 232,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_233.png',
			name: 'Tennessee',
			url: 'accents/meshes/Accent_233.babylon',
			id: 233,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_234.png',
			name: 'Texas',
			url: 'accents/meshes/Accent_234.babylon',
			id: 234,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_235.png',
			name: 'Utah',
			url: 'accents/meshes/Accent_235.babylon',
			id: 235,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_236.png',
			name: 'Vermont',
			url: 'accents/meshes/Accent_236.babylon',
			id: 236,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_237.png',
			name: 'Virginia',
			url: 'accents/meshes/Accent_237.babylon',
			id: 237,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_238.png',
			name: 'Washington',
			url: 'accents/meshes/Accent_238.babylon',
			id: 238,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_239.png',
			name: 'West Virginia',
			url: 'accents/meshes/Accent_239.babylon',
			id: 239,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_240.png',
			name: 'Wisconsin',
			url: 'accents/meshes/Accent_240.babylon',
			id: 240,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_241.png',
			name: 'Wyoming',
			url: 'accents/meshes/Accent_241.babylon',
			id: 241,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_242.png',
			name: '1x1 Half 1',
			url: 'accents/meshes/Accent_242.babylon',
			id: 242,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_243.png',
			name: '1x1 Half 2',
			url: 'accents/meshes/Accent_243.babylon',
			id: 243,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_244.png',
			name: '1x1 Square',
			url: 'accents/meshes/Accent_244.babylon',
			id: 244,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_245.png',
			name: '1x1',
			url: 'accents/meshes/Accent_245.babylon',
			id: 245,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_246.png',
			name: '2x2 Square',
			url: 'accents/meshes/Accent_246.babylon',
			id: 246,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_247.png',
			name: '2x2',
			url: 'accents/meshes/Accent_247.babylon',
			id: 247,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_248.png',
			name: '3x3 Square',
			url: 'accents/meshes/Accent_248.babylon',
			id: 248,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_249.png',
			name: '3x3',
			url: 'accents/meshes/Accent_249.babylon',
			id: 249,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_250.png',
			name: '4x4 Square',
			url: 'accents/meshes/Accent_250.babylon',
			id: 250,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_251.png',
			name: '4x4',
			url: 'accents/meshes/Accent_251.babylon',
			id: 251,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_252.png',
			name: '5x5 Square',
			url: 'accents/meshes/Accent_252.babylon',
			id: 252,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_253.png',
			name: '5x5',
			url: 'accents/meshes/Accent_253.babylon',
			id: 253,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_254.png',
			name: '6x6 Square',
			url: 'accents/meshes/Accent_254.babylon',
			id: 254,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_255.png',
			name: 'Windmill',
			url: 'accents/meshes/Accent_255.babylon',
			id: 255,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_256.png',
			name: "Washington's Puzzle",
			url: 'accents/meshes/Accent_256.babylon',
			id: 256,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_257.png',
			name: 'Vortex',
			url: 'accents/meshes/Accent_257.babylon',
			id: 257,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_258.png',
			name: 'Triangles 2',
			url: 'accents/meshes/Accent_258.babylon',
			id: 258,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_259.png',
			name: 'Triangles 1',
			url: 'accents/meshes/Accent_259.babylon',
			id: 259,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_260.png',
			name: 'Interlocked Squares 1',
			url: 'accents/meshes/Accent_260.babylon',
			id: 260,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_261.png',
			name: 'Diamonds 2',
			url: 'accents/meshes/Accent_261.babylon',
			id: 261,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_262.png',
			name: 'Diamonds 1',
			url: 'accents/meshes/Accent_262.babylon',
			id: 262,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_263.png',
			name: "Cleopatra's Fan",
			url: 'accents/meshes/Accent_263.babylon',
			id: 263,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_264.png',
			name: 'Arabic Lattice',
			url: 'accents/meshes/Accent_264.babylon',
			id: 264,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_265.png',
			name: 'Abstract Triangles 2',
			url: 'accents/meshes/Accent_265.babylon',
			id: 265,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_266.png',
			name: 'Abstract Triangles 1',
			url: 'accents/meshes/Accent_266.babylon',
			id: 266,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_267.png',
			name: '10x10 Square',
			url: 'accents/meshes/Accent_267.babylon',
			id: 267,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_268.png',
			name: '9x9 Square',
			url: 'accents/meshes/Accent_268.babylon',
			id: 268,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_269.png',
			name: 'Pinwheel 1',
			url: 'accents/meshes/Accent_269.babylon',
			id: 269,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_270.png',
			name: '8x8',
			url: 'accents/meshes/Accent_270.babylon',
			id: 270,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_271.png',
			name: '7x7 Square',
			url: 'accents/meshes/Accent_271.babylon',
			id: 271,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_272.png',
			name: '6x6',
			url: 'accents/meshes/Accent_272.babylon',
			id: 272,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_273.png',
			name: '8x8 Square',
			url: 'accents/meshes/Accent_273.babylon',
			id: 273,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_274.png',
			name: '9x9 Grid',
			url: 'accents/meshes/Accent_274.babylon',
			id: 274,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_275.png',
			name: '10x10 Grid',
			url: 'accents/meshes/Accent_275.babylon',
			id: 275,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_276.png',
			name: '11x11 Squares',
			url: 'accents/meshes/Accent_276.babylon',
			id: 276,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_277.png',
			name: '11x11 Grid',
			url: 'accents/meshes/Accent_277.babylon',
			id: 277,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_278.png',
			name: '12x12 Squares',
			url: 'accents/meshes/Accent_278.babylon',
			id: 278,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_279.png',
			name: '12x12 Grid',
			url: 'accents/meshes/Accent_279.babylon',
			id: 279,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_280.png',
			name: 'Triangles 3',
			url: 'accents/meshes/Accent_280.babylon',
			id: 280,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_281.png',
			name: 'Diamonds 3',
			url: 'accents/meshes/Accent_281.babylon',
			id: 281,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_282.png',
			name: 'Sunburst',
			url: 'accents/meshes/Accent_282.babylon',
			id: 282,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_283.png',
			name: 'Starwheel',
			url: 'accents/meshes/Accent_283.babylon',
			id: 283,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_284.png',
			name: 'Blazing Star 1',
			url: 'accents/meshes/Accent_284.babylon',
			id: 284,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_285.png',
			name: 'Blazing Star 2',
			url: 'accents/meshes/Accent_285.babylon',
			id: 285,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_286.png',
			name: 'Blazing Star 3',
			url: 'accents/meshes/Accent_286.babylon',
			id: 286,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_287.png',
			name: 'Blazing Star 4',
			url: 'accents/meshes/Accent_287.babylon',
			id: 287,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_288.png',
			name: 'Circles 1',
			url: 'accents/meshes/Accent_288.babylon',
			id: 288,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_289.png',
			name: 'Circles 2',
			url: 'accents/meshes/Accent_289.babylon',
			id: 289,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_290.png',
			name: '7x7 Template',
			url: 'accents/meshes/Accent_290.babylon',
			id: 290,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_291.png',
			name: 'Diamond Leaf',
			url: 'accents/meshes/Accent_291.babylon',
			id: 291,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_292.png',
			name: 'Spinwheel',
			url: 'accents/meshes/Accent_292.babylon',
			id: 292,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_293.png',
			name: 'Circles 3',
			url: 'accents/meshes/Accent_293.babylon',
			id: 293,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_294.png',
			name: 'Dresden Fan',
			url: 'accents/meshes/Accent_294.babylon',
			id: 294,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_295.png',
			name: 'Wavy Checkers',
			url: 'accents/meshes/Accent_295.babylon',
			id: 295,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_296.png',
			name: 'Fleur De Lis 1',
			url: 'accents/meshes/Accent_296.babylon',
			id: 296,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_297.png',
			name: 'Fleur De Lis 2',
			url: 'accents/meshes/Accent_297.babylon',
			id: 297,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_298.png',
			name: 'Fleur De Lis 3',
			url: 'accents/meshes/Accent_298.babylon',
			id: 298,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_299.png',
			name: 'Fan 1',
			url: 'accents/meshes/Accent_299.babylon',
			id: 299,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_300.png',
			name: 'Circles 4',
			url: 'accents/meshes/Accent_300.babylon',
			id: 300,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_301.png',
			name: 'Fan 2',
			url: 'accents/meshes/Accent_301.babylon',
			id: 301,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_302.png',
			name: 'Cubic 3',
			url: 'accents/meshes/Accent_302.babylon',
			id: 302,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_303.png',
			name: 'Cubic 2',
			url: 'accents/meshes/Accent_303.babylon',
			id: 303,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_304.png',
			name: 'Twist 1',
			url: 'accents/meshes/Accent_304.babylon',
			id: 304,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_305.png',
			name: 'Flower Garden',
			url: 'accents/meshes/Accent_305.babylon',
			id: 305,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_306.png',
			name: 'Twist 2',
			url: 'accents/meshes/Accent_306.babylon',
			id: 306,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_307.png',
			name: 'Ellipse 1',
			url: 'accents/meshes/Accent_307.babylon',
			id: 307,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_308.png',
			name: 'Twist 3',
			url: 'accents/meshes/Accent_308.babylon',
			id: 308,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_309.png',
			name: 'Sun Ray',
			url: 'accents/meshes/Accent_309.babylon',
			id: 309,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_310.png',
			name: 'Cross 4',
			url: 'accents/meshes/Accent_310.babylon',
			id: 310,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_311.png',
			name: 'Accordion',
			url: 'accents/meshes/Accent_311.babylon',
			id: 311,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_312.png',
			name: 'Rings 1',
			url: 'accents/meshes/Accent_312.babylon',
			id: 312,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_313.png',
			name: 'Rings 2',
			url: 'accents/meshes/Accent_313.babylon',
			id: 313,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_314.png',
			name: 'Flying Geese 1',
			url: 'accents/meshes/Accent_314.babylon',
			id: 314,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_315.png',
			name: 'Beach Umbrella',
			url: 'accents/meshes/Accent_315.babylon',
			id: 315,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_316.png',
			name: 'Diagonal 1',
			url: 'accents/meshes/Accent_316.babylon',
			id: 316,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_317.png',
			name: 'Cross 1',
			url: 'accents/meshes/Accent_317.babylon',
			id: 317,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_318.png',
			name: 'Cross 2',
			url: 'accents/meshes/Accent_318.babylon',
			id: 318,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_319.png',
			name: 'Horizontal Bar',
			url: 'accents/meshes/Accent_319.babylon',
			id: 319,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_320.png',
			name: 'Flower 2',
			url: 'accents/meshes/Accent_320.babylon',
			id: 320,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_321.png',
			name: 'Cubic 1',
			url: 'accents/meshes/Accent_321.babylon',
			id: 321,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_322.png',
			name: 'Twist 4',
			url: 'accents/meshes/Accent_322.babylon',
			id: 322,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_323.png',
			name: 'Flower 1',
			url: 'accents/meshes/Accent_323.babylon',
			id: 323,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_324.png',
			name: 'Blazing Star 5',
			url: 'accents/meshes/Accent_324.babylon',
			id: 324,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_325.png',
			name: 'Skyscraper',
			url: 'accents/meshes/Accent_325.babylon',
			id: 325,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_326.png',
			name: 'Interlocked Squares 2',
			url: 'accents/meshes/Accent_326.babylon',
			id: 326,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_327.png',
			name: 'Indian Summer',
			url: 'accents/meshes/Accent_327.babylon',
			id: 327,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_328.png',
			name: 'Interlocked Squares 3',
			url: 'accents/meshes/Accent_328.babylon',
			id: 328,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_329.png',
			name: 'Dual Wheel 1',
			url: 'accents/meshes/Accent_329.babylon',
			id: 329,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_330.png',
			name: 'Circus Tent',
			url: 'accents/meshes/Accent_330.babylon',
			id: 330,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_331.png',
			name: 'Halo 1',
			url: 'accents/meshes/Accent_331.babylon',
			id: 331,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_332.png',
			name: 'Hex 15 Column',
			url: 'accents/meshes/Accent_332.babylon',
			id: 332,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_333.png',
			name: 'Hex 4 Column',
			url: 'accents/meshes/Accent_333.babylon',
			id: 333,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_334.png',
			name: 'Hex 7.5 Column',
			url: 'accents/meshes/Accent_334.babylon',
			id: 334,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_335.png',
			name: 'Hex 8 Column',
			url: 'accents/meshes/Accent_335.babylon',
			id: 335,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_336.png',
			name: 'Hex 2.5 Column',
			url: 'accents/meshes/Accent_336.babylon',
			id: 336,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_337.png',
			name: 'Hex 5 Column',
			url: 'accents/meshes/Accent_337.babylon',
			id: 337,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_338.png',
			name: 'Hex 3 Column',
			url: 'accents/meshes/Accent_338.babylon',
			id: 338,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_339.png',
			name: 'Hex 6 Column',
			url: 'accents/meshes/Accent_339.babylon',
			id: 339,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_340.png',
			name: 'Arkansas Traveler 1',
			url: 'accents/meshes/Accent_340.babylon',
			id: 340,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_341.png',
			name: 'Arkansas Traveler 2',
			url: 'accents/meshes/Accent_341.babylon',
			id: 341,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_342.png',
			name: 'Flying Geese 2',
			url: 'accents/meshes/Accent_342.babylon',
			id: 342,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_343.png',
			name: 'Rounded Star 1',
			url: 'accents/meshes/Accent_343.babylon',
			id: 343,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_344.png',
			name: 'Rounded Star 2',
			url: 'accents/meshes/Accent_344.babylon',
			id: 344,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_345.png',
			name: 'Rounded Star 3',
			url: 'accents/meshes/Accent_345.babylon',
			id: 345,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_346.png',
			name: 'Spherical Crescents',
			url: 'accents/meshes/Accent_346.babylon',
			id: 346,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_347.png',
			name: 'Blazing Star 6',
			url: 'accents/meshes/Accent_347.babylon',
			id: 347,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_348.png',
			name: 'Pinwheel 2',
			url: 'accents/meshes/Accent_348.babylon',
			id: 348,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_349.png',
			name: 'Blazing Star 7',
			url: 'accents/meshes/Accent_349.babylon',
			id: 349,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_350.png',
			name: 'Pinwheel 3',
			url: 'accents/meshes/Accent_350.babylon',
			id: 350,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_351.png',
			name: 'Tile Star 1',
			url: 'accents/meshes/Accent_351.babylon',
			id: 351,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_352.png',
			name: 'Pinwheel 4',
			url: 'accents/meshes/Accent_352.babylon',
			id: 352,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_353.png',
			name: 'Cross 5',
			url: 'accents/meshes/Accent_353.babylon',
			id: 353,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_354.png',
			name: 'Flying Geese 3',
			url: 'accents/meshes/Accent_354.babylon',
			id: 354,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_355.png',
			name: 'Star Knot 1',
			url: 'accents/meshes/Accent_355.babylon',
			id: 355,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_356.png',
			name: 'Star Knot 2',
			url: 'accents/meshes/Accent_356.babylon',
			id: 356,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_357.png',
			name: 'Cross 3',
			url: 'accents/meshes/Accent_357.babylon',
			id: 357,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_358.png',
			name: 'Flower 3',
			url: 'accents/meshes/Accent_358.babylon',
			id: 358,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_359.png',
			name: 'Log Cabin',
			url: 'accents/meshes/Accent_359.babylon',
			id: 359,
		},
		{
			thumb: 'accents/thumbnails/Icon_Accent_360.png',
			name: 'Pinwheel 5',
			url: 'accents/meshes/Accent_360.babylon',
			id: 360,
		},
	],
	scenes: [{
		thumb: 'scenes/thumbnails/Background_001.png',
		name: 'Background 1',
		url: 'scenes/TemplateBackground/ActivityBackground_001.babylon',
		id: 11,
	},
		{
			thumb: 'scenes/thumbnails/Background_002.png',
			name: 'Background 2',
			url: 'scenes/TemplateBackground/ActivityBackground_002.babylon',
			id: 1,
		},
		{
			thumb: 'scenes/thumbnails/Background_003.png',
			name: 'Background 3',
			url: 'scenes/TemplateBackground/ActivityBackground_003.babylon',
			id: 2,
		},
		{
			thumb: 'scenes/thumbnails/Background_004.png',
			name: 'Background 4',
			url: 'scenes/TemplateBackground/ActivityBackground_004.babylon',
			id: 3,
		},
		{
			thumb: 'scenes/thumbnails/Background_005.png',
			name: 'Background 5',
			url: 'scenes/TemplateBackground/ActivityBackground_005.babylon',
			id: 4,
		},
		{
			thumb: 'scenes/thumbnails/Background_006.png',
			name: 'Background 6',
			url: 'scenes/TemplateBackground/ActivityBackground_006.babylon',
			id: 5,
		},
		{
			thumb: 'scenes/thumbnails/Background_007.png',
			name: 'Background 7',
			url: 'scenes/TemplateBackground/ActivityBackground_007.babylon',
			id: 6,
		},
		{
			thumb: 'scenes/thumbnails/Background_008.png',
			name: 'Background 8',
			url: 'scenes/TemplateBackground/ActivityBackground_008.babylon',
			id: 7,
		},
		{
			thumb: 'scenes/thumbnails/Background_009.png',
			name: 'Background 9',
			url: 'scenes/TemplateBackground/ActivityBackground_009.babylon',
			id: 8,
		},
		{
			thumb: 'scenes/thumbnails/Background_010.png',
			name: 'Background 10',
			url: 'scenes/TemplateBackground/ActivityBackground_010.babylon',
			id: 9,
		},
		{
			thumb: 'scenes/thumbnails/Background_011.png',
			name: 'Background 11',
			url: 'scenes/TemplateBackground/ActivityBackground_011.babylon',
			id: 10,
		},
		{
			thumb: 'scenes/thumbnails/Background_013.png',
			name: 'Background 13',
			url: 'scenes/TemplateBackground/ActivityBackground_013.babylon',
			id: 12,
		},
	],

	frames: [
		{
		thumb: 'frames/thumbnails/Frame_001.png',
		name: 'Frame 001',
		url: 'frames/meshes/Frame_001.babylon',
		id: 1,
		},
		{
			thumb: 'frames/thumbnails/Frame_003.png',
			name: 'Frame 003',
			url: 'frames/meshes/Frame_003.babylon',
			id: 3,
		},
		{
			thumb: 'frames/thumbnails/Frame_004.png',
			name: 'Frame 004',
			url: 'frames/meshes/Frame_004.babylon',
			id: 4,
		},
		{
			thumb: 'frames/thumbnails/Frame_005.png',
			name: 'Frame 005',
			url: 'frames/meshes/Frame_005.babylon',
			id: 5,
		},
		{
			thumb: 'frames/thumbnails/Frame_007.png',
			name: 'Frame 007',
			url: 'frames/meshes/Frame_007.babylon',
			id: 7,
		},
		{
			thumb: 'frames/thumbnails/Frame_008.png',
			name: 'Frame 008',
			url: 'frames/meshes/Frame_008.babylon',
			id: 8,
		},
		{
			thumb: 'frames/thumbnails/Frame_010.png',
			name: 'Frame 010',
			url: 'frames/meshes/Frame_010.babylon',
			id: 10,
		},
		{
			thumb: 'frames/thumbnails/Frame_012.png',
			name: 'Frame 012',
			url: 'frames/meshes/Frame_012.babylon',
			id: 12,
		},
		{
			thumb: 'frames/thumbnails/Frame_013.png',
			name: 'Frame 013',
			url: 'frames/meshes/Frame_013.babylon',
			id: 13,
		}
	],
	patternFrames: [
		{
			thumb: 'patternFrame/thumbnails/Frame_001.png',
			name: 'Frame 001',
			url: 'patternFrame/meshes/Frame_001.babylon',
			id: 1,
		},
		{
			thumb: 'patternFrame/thumbnails/Frame_003.png',
			name: 'Frame 003',
			url: 'patternFrame/meshes/Frame_003.babylon',
			id: 3,
		},
		{
			thumb: 'patternFrame/thumbnails/Frame_004.png',
			name: 'Frame 004',
			url: 'patternFrame/meshes/Frame_004.babylon',
			id: 4,
		},
		{
			thumb: 'patternFrame/thumbnails/Frame_005.png',
			name: 'Frame 005',
			url: 'patternFrame/meshes/Frame_005.babylon',
			id: 5,
		},
		{
			thumb: 'patternFrame/thumbnails/Frame_007.png',
			name: 'Frame 007',
			url: 'patternFrame/meshes/Frame_007.babylon',
			id: 7,
		},
		{
			thumb: 'patternFrame/thumbnails/Frame_008.png',
			name: 'Frame 008',
			url: 'patternFrame/meshes/Frame_008.babylon',
			id: 8,
		},
		{
			thumb: 'patternFrame/thumbnails/Frame_010.png',
			name: 'Frame 010',
			url: 'patternFrame/meshes/Frame_010.babylon',
			id: 10,
		},
		{
			thumb: 'patternFrame/thumbnails/Frame_012.png',
			name: 'Frame 012',
			url: 'patternFrame/meshes/Frame_012.babylon',
			id: 12,
		},
		{
			thumb: 'patternFrame/thumbnails/Frame_013.png',
			name: 'Frame 013',
			url: 'patternFrame/meshes/Frame_013.babylon',
			id: 13,
		},
	]
} // .